import React from "react";
import { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { useLocation, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { nl2br, checkForceConsents } from '../../utils/functions'
import QuickAddConsentModal from "../PatientServices/QuickAddConsentModal";
import axios from "axios";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { baseurImage, baseurl } from "../../Baseurl";
import Select from "react-select";
import Swal from "sweetalert2";
import logo from "../../assests/logo.png";
import perImg from "../../../src/assests/profile.jpg";
import human from "../../../src/assests/humanboodyv2.png";
import timeImg from "../../../src/assests/kedney.webp";
import PainBarChart from "./PainBarChart";
import VitalSignsTab from "./VitalSignsTab";
import { Chip } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import PatientServices from "../PatientServices";
import PatientBilling from "../PatientServices/PatientBilling";
import PatientInsurance from "../PatientServices/PatientInsurance";
import PatientForms from "../PatientServices/PatientForms";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";
import { hasSubModulePermission } from "../../utils/permissions";
import axiosInstance from "../../api/axiosInstance";
import moment from "moment";
import Dental from "./Dental/Dental";
import Derma from "./Dermatology/Derma";
import { set } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { fetchMedicalData } from "../../store/medicalSlice";
import { triggerLabRefresh } from "../../store/labSlice";
import MedicalTemplateList from "./SubComponents/MedicalTemplateList";
import FileUploads from "./FileUploads";

export default function ManageAppointment() {
  const marks = Array.from({ length: 10 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));
  const marks1 = Array.from({ length: 10 }, (_, i) => ({
    value: i + 1,
    label: `${i + 1}`,
  }));
  const tableCell = (value) => <td>{value}</td>;
  const location = useLocation();
  const navigate = useNavigate();
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const refreshKey = useSelector((state) => state.lab.refreshKey);
  const allBranchSettings = useSelector((state) => state.business.allBranchSettings);
  const [addpatinemodal, setAddpatinemodal] = useState(false);
  const [diagnosisStatus, setDiagnosisStatus] = useState("provisional");
  const [showModalDoctor, setShowModalDoctor] = useState(false);
  const [openVital, setOpenVital] = useState(false);
  const [openMedical, setOpenMedical] = useState(false);
  const [openVital121, setOpenVital121] = useState(false);
  const [dataAllergy, setDataAllergy] = useState([]);
  const [allAllergies, setAllAllergies] = useState([]);
  const [chronicillness1, setChronicillness1] = useState([]);
  const [chronicillness12, setChronicillness12] = useState([]);
  const [diagonisemodal, setDiagonisemodal] = useState(false);
  const [patientServiceData, setPatientServiceData] = useState([]);
  const [show, setShow] = useState(true);
  const [vitaldatas, setVitaldatas] = useState([]);
  const [personalinfo, setPersonalinfo] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const [patinetvitals, setPatinetvitals] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [decodedPassword, setDecodedPassword] = useState("");
  const [loggedInUser, setLoggedInUser] = useState(null);
  const [recordLockHours, setRecordLockHours] = useState(null);
  const [forceVitalsEnabled, setForceVitalsEnabled] = useState(false);
  const [dentalModuleEnabled, setDentalModuleEnabled] = useState(false);
  const [insuranceModuleEnabled, setInsuranceModuleEnabled] = useState(false);
  const [dermatologyEnabled, setDermatologyEnabled] = useState(false);

  // discount state
  const [globalDiscountLimit, setGlobalDiscountLimit] = useState(0);
  const [testTotalPrice, setTestTotalPrice] = useState(0);
  const [testDiscountAmont, setTestDiscountAmount] = useState(0);
  const [testNetAmount, setTestNetAmount] = useState(0);
  const [testErrors, setTestErrors] = useState({});



  const [editTestTotalPrice, setEditTestTotalPrice] = useState(0);
  const [editTestDiscountAmount, setEditTestDiscountAmount] = useState(0);
  const [editTestNetAmount, setEditTestNetAmount] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  const [doctors, setDoctors] = useState([]);
  const [dataMedical, setDataMedical] = useState(null);
  const [openmodalforvital, setOpenmodalforvital] = useState(false);
  const [openmodalforvital1, setOpenmodalforvital1] = useState(false);
  const [openmodaltest, setOpenmodaltest] = useState(false);
  const [diagnosis, setDiagnosis] = useState([]);
  const [diagnosis11, setDiagnosis11] = useState([]);
  const [patientservice, setpatientservice] = useState([]);
  const [getservice, setGetservice] = useState([]);
  const [patients, setPatients] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [painAssesmentModal, setPainAssesmentModal] = useState(false);

  // ── Appointment Packages ──────────────────────────────────────────────────
  const [packages, setPackages] = useState([]);
  const [expandedPackage, setExpandedPackage] = useState(null);
  const [showAddPackageModal, setShowAddPackageModal] = useState(false);
  const [showBookSessionModal, setShowBookSessionModal] = useState(false);
  const [selectedSession, setSelectedSession] = useState(null);
  const [packageForm, setPackageForm] = useState({ package_name: "", doctor_id: "", total_sessions: 1, notes: "" });
  const [bookSessionForm, setBookSessionForm] = useState({ appointmentDate: "", startTime: "", endTime: "", doctorId: "", reason: "", branchId: "" });
  const [packagesLoading, setPackagesLoading] = useState(false);
  const [inpval, setInpval] = useState({
    category: "",
    doctor_id: "",
    title: "",
    description: "",
    serviceIds: [],
    file: null,
    discount_type: "Amount",
    discount_value: 0,
    totalPrice: 0,
    discount_amount: 0,
    net_amount: 0,
  });
  const [dataAppointment, setDataAppointment] = useState([]);
  const [noShowRiskById, setNoShowRiskById] = useState({});
  const [appointmentdata, setAppointmentdata] = useState([]);
  const [labData, setLabData] = useState([]);
  const [labSearch, setLabSearch] = useState("");
  const [data2, setData2] = useState([]);
  const [labServices, setLabServices] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [pendingMissingConsents, setPendingMissingConsents] = useState(null);
  const [showEditLabModal, setShowEditLabModal] = useState(false);
  const [medicalNotes, setMedicalNotes] = useState({});
  const [dataxray, setDataxray] = useState("");
  const [uploadTypes, setUploadTypes] = useState([]);
  const [ddsafjahfl, setDdsafjahfl] = useState([]);
  const [filterdatae, setFilterdatae] = useState([]);
  const today = new Date().toLocaleDateString("en-GB");
  const [datta, setDatta] = useState([]);
  const [dateSelectData, setDateSelectData] = useState([]);
  const [expandedRow, setExpandedRow] = useState(null);
  const [expandedDiagnosis, setExpandedDiagnosis] = useState({});

  const [editPrescriptionModal, setEditPrescriptionModal] = useState(false);
  const [selectedPrescription, setSelectedPrescription] = useState(null);
  const [editMedicines, setEditMedicines] = useState([]);



  // Existing states ke saath add karo
  const [isEditMode, setIsEditMode] = useState(false);        // ✅ New
  const [editingGroupId, setEditingGroupId] = useState(null); // ✅ New


  const [editLabData, setEditLabData] = useState({
    request_id: null,
    lab_id: "",
    title: "",
    description: "",
    serviceId: null,
  });

  const [enhancedDoctors, setEnhancedDoctors] = useState([]);
  const [termsCondition, setTermsCondition] = useState(null);

  const [services, setServices] = useState([]);
  const [planTotal, setPlanTotal] = useState(0);
  const [completedTotal, setCompletedTotal] = useState(0);
  const [totalPlanServices, setTotalPlanServices] = useState(0);
  const [totalCompleteServices, setTotalCompleteServices] = useState(0);
  const [inventoryItems, setInventoryItems] = useState([]);
  const [availableServices, setAvailableServices] = useState([]);
  const [availableInventory, setAvailableInventory] = useState([]);
  const [serviceModalOpen, setServiceModalOpen] = useState(false);
  const [inventoryModalOpen, setInventoryModalOpen] = useState(false);
  const [selectedService, setSelectedService] = useState(null);
  const [selectedInventory, setSelectedInventory] = useState(null);
  const [searchServiceQuery, setSearchServiceQuery] = useState("");
  const [searchInventoryQuery, setSearchInventoryQuery] = useState("");
  const [showServiceSuggestions, setShowServiceSuggestions] = useState(false);
  const [showInventorySuggestions, setShowInventorySuggestions] =
    useState(false);
  const [hasActiveInsuranceCard, setHasActiveInsuranceCard] = useState(false);
  const [insuranceCompanyId, setInsuranceCompanyId] = useState(null);
  const [companyLabPriceMap, setCompanyLabPriceMap] = useState({});
  const [serviceTableSearchTerm, setServiceTableSearchTerm] = useState("");
  const [inventoryTableSearchTerm, setInventoryTableSearchTerm] = useState("");

  const [currentServicePage, setCurrentServicePage] = useState(1);
  const [currentInventoryPage, setCurrentInventoryPage] = useState(1);
  const servicesPerPage = 10;
  const inventoryPerPage = 10;

  const [serviceFormData, setServiceFormData] = useState({
    serviceId: "",
    extraNotes: "",
    discountType: "Amount",
    discountValue: 0,
    status: "Plan",
    customCost: "",
    sent_by: "",
  });

  const [inventoryFormData, setInventoryFormData] = useState({
    inventoryId: "",
    quantity: 1,
  });




  let patientIdentifier;
  location?.state?.patientid?.patientId
    ? (patientIdentifier = location?.state?.patientid?.patientId)
    : (patientIdentifier = location?.state?.patientid?.id);
  const filterdate1 = async () => {
    try {
      const response = await axiosInstance.get(
        `getAllMedicalDataByPatient/${patientIdentifier}`
      );

      // Check HTTP status
      if (response.status !== 200) {
        console.error("Unexpected status:", response.status);
        Swal.fire("Error!", "Unexpected server response.", "error");
        return;
      }

      // Check API success flag
      if (response.data?.success) {
        setDatta(response.data.data || []);
      } else {
        console.warn("API failed:", response.data?.message);
        console.error(
          "Failed!",
          response.data?.message || "Data not found",
          "warning"
        );
      }
    } catch (error) {
      console.error("API Error:", error);

      // Axios sends different error types - handle all properly:
      if (error.response) {
        // Server returned an error response
        console.error(
          "Server Error!",
          error.response.data?.message ||
          `Server responded with ${error.response.status}`,
          "error"
        );
      } else if (error.request) {
        // No response received
        console.error(
          "Network Error!",
          "Unable to reach the server. Please check your internet.",
          "error"
        );
      } else {
        // Something wrong in code setup
        console.error(
          "Error!",
          error.message || "Unexpected error occurred",
          "error"
        );
      }
    }
  };




  const getDateSelectData = async () => {
    try {
      const response = await axiosInstance.post(
        `appointmentByPatientId/${patientIdentifier}`
      );

      // Check HTTP status
      if (response.status !== 200) {
        console.error("Unexpected status:", response.status);
        Swal.fire("Error!", "Unexpected server response.", "error");
        return;
      }

      // Check API success flag
      if (response.data?.success) {
        setDataAppointment(response.data.data);
        let dateSelectDataArr = []
        response.data.data
          .slice()
          .sort((a, b) => new Date(a.appointmentDate) - new Date(b.appointmentDate))
          .forEach((item) => {
            // appointmentDate is a timestamp, so it arrives UTC-shifted (local midnight
            // comes back as the previous day 21:00Z). Parsing only its first 10
            // characters dated every visit a day early, so no note ever matched its chip.
            const visitDay = typeof item.appointmentDate === "string" && !item.appointmentDate.includes("T")
              ? moment(item.appointmentDate, "YYYY-MM-DD")
              : moment(item.appointmentDate);
            const date = {
              appointmentDate: visitDay.startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
              doctor_name: item.doctorName || item.doctor_name,
              doctor_id: item.doctorId ?? item.doctor_id ?? null,
              appointment_id: item.id ?? null,
              startTime: item.startTime || null,
            };
            // One chip per appointment: two doctors on the same day each need their own
            // visit button, and each one's notes hang off that appointment.
            if (!dateSelectDataArr.some(d => d.appointment_id != null && d.appointment_id === date.appointment_id)) {
              dateSelectDataArr.push(date);
            }
          });
        setDateSelectData(dateSelectDataArr || []);
      } else {
        console.warn("API failed:", response.data?.message);
        console.error(
          "Failed!",
          response.data?.message || "Data not found",
          "warning"
        );
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  const filterdate111 = async () => {
    try {
      const response = await axiosInstance.get(
        `getTodaysPatientVitals/${patientIdentifier}`
      );

      // Validate HTTP response
      if (response.status !== 200) {
        console.error("Unexpected HTTP status:", response.status);
        return;
      }

      // Validate API success
      if (response.data?.success) {
        const vitals = response.data?.vitals || [];

        setDataVitals(vitals);

        if (vitals.length === 0) {
          console.warn("No Data", "No vitals found for today.", "info");
        }
      } else {
        console.warn("API returned failure:", response.data?.message);
        console.error(
          "Failed!",
          response.data?.message || "Unable to fetch today's vitals",
          "warning"
        );
      }
    } catch (error) {
      if (error?.response?.status === 404) {
        // 404 means no vitals recorded today — normal state, not an error
        setDataVitals([]);
      } else {
        console.error("API Error:", error);
      }
    }
  };

  useEffect(() => {
    filterdate1();
    filterdate111();
    fetchAllAllergies();
    getDateSelectData();
    fetchGlobalDiscountLimit();
    axiosInstance.get('getAllUploadTypes')
      .then(res => setUploadTypes(res.data?.data || []))
      .catch(() => {})
    axiosInstance.get('getBusinessSettings')
      .then(res => {
        const h = res.data?.data?.record_lock_hours
        if (h != null) setRecordLockHours(Number(h))
      })
      .catch(() => {})
    axiosInstance.get('getModuleSettings')
      .then(res => {
        if (res.data?.success) {
          const rows = res.data.data
          const fv = rows.find(r => r.module_name === 'force_vitals')
          if (fv) setForceVitalsEnabled(Boolean(fv.enable))
          const dm = rows.find(r => r.module_name === 'dental_module')
          if (dm) setDentalModuleEnabled(Boolean(dm.enable))
          const im = rows.find(r => r.module_name === 'insurance_module')
          if (im) setInsuranceModuleEnabled(Boolean(im.enable))
          const derm = rows.find(r => r.module_name === 'dermatology')
          if (derm) setDermatologyEnabled(Boolean(derm.enable))
        }
      })
      .catch(() => {})
  }, []);

  const fetchAllAllergies = async () => {
    try {
      const response = await axiosInstance.get(`getAllAllergies`);
      if (response.data.success === true) {
        setAllAllergies(response.data.data);
        setPAllergy(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching allergies:", error);
    }
  };

  // State to track active tab
  const [activeTab, setActiveTab] = useState(null);

  // Define tab configurations with their permission IDs
  const tabConfigs = [
    { id: "personaldata", permissionId: 2, name: "Personal Data" },
    { id: "Appointment", permissionId: 3, name: "Appointment" },
    { id: "vitalsings", permissionId: 4, name: "Vital Signs" },
    { id: "forms", permissionId: 5, name: "Forms" },
    { id: "patientfiles", permissionId: 7, name: "Files" },
    { id: "labs", permissionId: 6, name: "Labs" },
    { id: "medicalhistory", permissionId: 7, name: "Medical History" },
    { id: "dental", permissionId: 8, name: "Dental" },
    { id: "dermatology", permissionId: 8, name: "Dermatology" },
    { id: "service", permissionId: 9, name: "Services" },
    { id: "billing", permissionId: 10, name: "Billing" },
    { id: "insurance", permissionId: 11, name: "Insurance" },
  ];

  // Set the first available tab on component mount or restore from navigation state
  useEffect(() => {
    // Check if there's a stored tab from navigation (when coming back from a view page)
    const storedTab =
      location.state?.activeTab ||
      sessionStorage.getItem(`activeTab_${patientIdentifier}`);

    let tabToActivate = null;

    if (
      storedTab &&
      tabConfigs.find(
        (tab) =>
          tab.id === storedTab && hasSubModulePermission(tab.permissionId)
      )
    ) {
      // Restore the previously active tab if it exists and user has permission
      tabToActivate = storedTab;
    } else {
      // Otherwise, find the first available tab
      const firstAvailableTab = tabConfigs.find((tab) =>
        hasSubModulePermission(tab.permissionId)
      );
      tabToActivate = firstAvailableTab?.id;
    }

    if (tabToActivate) {
      setActiveTab(tabToActivate);
    }
  }, []);
  useEffect(() => {
    if (!openmodaltest && !serviceModalOpen) return;
    if (!loggedInUser) return;

    // Create logged-in user entry using doctor table ID to stay in the same namespace as the doctors array
    const doctorId = loggedInUser.doctorId || loggedInUser.id;
    const userEntry = {
      id: doctorId,
      displayName: loggedInUser.fullName || loggedInUser.displayName || loggedInUser.name || "Current User",
      isLoggedInUser: true
    };

    // Merge: logged-in user first, then all other doctors (filter by doctor table ID)
    const merged = [userEntry, ...doctors.filter(d => d.id !== doctorId)];
    setEnhancedDoctors(merged);

    // Auto-select logged-in user for Add Test
    if (openmodaltest && !inpval.doctor_id) {
      setInpval(prev => ({ ...prev, doctor_id: userEntry.id }));
    }

    // Auto-select logged-in user for Add Service
    if (serviceModalOpen && !selectedService && !serviceFormData.sent_by) {
      setServiceFormData(prev => ({ ...prev, sent_by: userEntry.id }));
    }
  }, [openmodaltest, serviceModalOpen, loggedInUser, doctors, inpval.doctor_id, serviceFormData.sent_by, selectedService]);

  useEffect(() => {
    const userMedical = localStorage.getItem("userMedical");
    if (userMedical) {
      const parsedUser = JSON.parse(userMedical);
      setLoggedInUser(parsedUser?.data);
    }

    const fetchTerms = async () => {
      try {
        const response = await axiosInstance.get("getTermsCondition/1");
        if (response.data.success && response.data.data) {
          const termData = Array.isArray(response.data.data)
            ? response.data.data[0]
            : response.data.data;
          setTermsCondition(termData);
        }
      } catch (error) {
        console.error("Error fetching terms:", error);
      }
    };
    fetchTerms();
  }, []);

  // Save active tab to sessionStorage whenever it changes
  useEffect(() => {
    if (activeTab) {
      sessionStorage.setItem(`activeTab_${patientIdentifier}`, activeTab);
      // Dispatch fetchMedicalData when entering relevant tabs to ensure fresh data
      if (activeTab === "medicalhistory" || activeTab === "dental" || activeTab === "patientfiles") {
        dispatch(fetchMedicalData(patientIdentifier));
      }
    }
  }, [activeTab, patientIdentifier, dispatch]);
  const [editLabAttachments, setEditLabAttachments] = useState([]);
  const [labs, setLabs] = useState([]);
  const now = new Date();
  const date = now.toISOString().split("T")[0];
  const time = now.toTimeString().split(" ")[0];
  const handleclick = () => {
    setModalOpen(true);
  };
  const datauser = location.state.patientid.id;
  const handleClose = () => {
    setModalOpen(false);
  };
  // getdata() is called after mutations (e.g. booking a session); initial load handled by getDateSelectData()
  const getdata = async () => {
    try {
      const response = await axiosInstance.post(
        `appointmentByPatientId/${patientIdentifier}`
      );
      if (response.data.success === true) {
        setDataAppointment(response.data.data);
      } else {
        console.warn("something went worng");
      }
    } catch (error) {
      console.error(
        "Error while fetching appointment data:",
        error.response?.data || error.message
      );
    }
  };
  // ── Packages helpers ─────────────────────────────────────────────────────
  const fetchPackages = async () => {
    if (!patientIdentifier) return;
    setPackagesLoading(true);
    try {
      const res = await axiosInstance.get(`getPatientPackages/${patientIdentifier}`);
      if (res.data.success) setPackages(res.data.data);
    } catch (e) {
      console.error("Failed to fetch packages", e);
    } finally {
      setPackagesLoading(false);
    }
  };
  useEffect(() => { fetchPackages(); }, [patientIdentifier]);

  const handleCreatePackage = async () => {
    if (!packageForm.package_name || !packageForm.total_sessions) return;
    try {
      await axiosInstance.post("createPackage", {
        patient_id: patientIdentifier,
        doctor_id: packageForm.doctor_id || null,
        package_name: packageForm.package_name,
        total_sessions: Number(packageForm.total_sessions),
        notes: packageForm.notes,
      });
      setShowAddPackageModal(false);
      setPackageForm({ package_name: "", doctor_id: "", total_sessions: 1, notes: "" });
      fetchPackages();
    } catch (e) {
      console.error("Failed to create package", e);
    }
  };

  const handleBookSession = async () => {
    if (!bookSessionForm.appointmentDate || !selectedSession) return;
    try {
      const res = await axiosInstance.put(`bookPackageSession/${selectedSession.id}`, {
        appointmentDate: bookSessionForm.appointmentDate,
        startTime: bookSessionForm.startTime,
        endTime: bookSessionForm.endTime,
        doctorId: bookSessionForm.doctorId || null,
        reason: bookSessionForm.reason,
        branchId: bookSessionForm.branchId || parseInt(localStorage.getItem('activeBranchId')) || (allBranchSettings.length === 1 ? allBranchSettings[0]?.id : null),
      });
      if (res.data?.success === false) {
        Swal.fire("Error", res.data.message || "Failed to book session", "error");
        return;
      }
      setShowBookSessionModal(false);
      setSelectedSession(null);
      setBookSessionForm({ appointmentDate: "", startTime: "", endTime: "", doctorId: "", reason: "", branchId: "" });
      await fetchPackages();
      getdata();
    } catch (e) {
      console.error("Failed to book session", e);
      const msg = e.response?.data?.message || e.response?.data?.sql || e.message || "Failed to book session";
      Swal.fire("Error", msg, "error");
    }
  };

  const handleDeletePackage = async (pkgId) => {
    const result = await Swal.fire({
      title: "Delete Package?",
      text: "This will delete the package and all its sessions.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Yes, delete",
    });
    if (!result.isConfirmed) return;
    try {
      await axiosInstance.delete(`deletePackage/${pkgId}`);
      fetchPackages();
    } catch (e) {
      console.error("Failed to delete package", e);
    }
  };

  const handleclickopenvital = () => {
    setOpenVital(true);
  };
  const handlecMedical = async () => {
    // A note has to hang off a visit, otherwise it cannot be attributed to a doctor —
    // the logged-in user may be an admin or a nurse writing it up for someone else.
    if (activeTab === "medicalhistory" && !appointmentqq && !dateqq && visitChips.length > 0) {
      Swal.fire({
        icon: "info",
        title: "Select a Visit First",
        text: "Pick the visit button (date and doctor) above, then add the notes — that way they are saved under that appointment's doctor.",
        confirmButtonText: "OK",
      });
      return;
    }
    try {
      const settingsRes = await axiosInstance.get('getModuleSettings')
      const forceVitalsRow = settingsRes.data?.data?.find(r => r.module_name === 'force_vitals')
      const isForced = forceVitalsRow ? Boolean(forceVitalsRow.enable) : false

      if (isForced) {
        try {
          await axiosInstance.get(`getTodaysPatientVitals/${patientIdentifier}`)
          // 200 means vitals exist — allow through
        } catch (vitalsErr) {
          const status = vitalsErr?.response?.status
          if (status === 404) {
            // 404 = no vitals recorded today
            Swal.fire({
              icon: 'warning',
              title: 'Vitals Required',
              text: 'No vital signs have been recorded for this patient. Please take and save vital signs before adding medical notes.',
              confirmButtonText: 'OK',
            })
            return
          }
          // any other error (network, 500…): allow through to not block the user
          console.error('Vitals check error:', vitalsErr)
        }
      }
    } catch (err) {
      console.error('Module settings fetch failed:', err)
    }
    setOpenMedical(true);
  };
  const handleclickopenvital11 = () => {
    setOpenVital121(true);
  };
  const handlecloseVital = () => {
    setOpenVital(false);
  };
  const handlecloseMedical = () => {
    setOpenMedical(false);
  };
  const hndleclosemodalservice = () => {
    setOpenVital121(false);
  };
  const hndleclosddddd = () => {
    setDiagonisemodal(false);
  };
  const handlechange = (e) => {
    const { name, value, files, type } = e.target;
    setInpval({
      ...inpval,
      [name]: type === "file" ? files[0] : value,
    });

    // Fetch lab services when lab is selected
    if (name === "category" && value) {
      fetchLabServices(value);
      // Clear selected services when lab changes

      setInpval((prev) => ({
        ...prev,
        serviceIds: [],
        discount_type: "Amount",
        discount_value: 0,
        totalPrice: 0,
        discount_amount: 0,
        net_amount: 0,
      }));
      setSelectedServices([]);
    }
  };
  const handleEditLabServicesChange = (event, newValue) => {
    setEditLabData((prev) => ({
      ...prev,
      serviceId: newValue ? newValue.id : null,
    }));
  };
  const handleServicesChange = (event, newValue) => {
    const previousQtyById = {};
    selectedServices.forEach((s) => {
      previousQtyById[s.id] = s.quantity;
    });
    const services = (newValue || []).map((s) => ({
      ...s,
      quantity: previousQtyById[s.id] || s.quantity || 1,
    }));
    setSelectedServices(services);
    setInpval((prev) => ({
      ...prev,
      serviceIds: services.map((s) => s.id),
    }));
  };

  const handleServiceQuantityChange = (serviceId, quantity) => {
    const qty = parseInt(quantity, 10) || 1;
    setSelectedServices((prev) =>
      prev.map((s) => (s.id === serviceId ? { ...s, quantity: qty } : s))
    );
  };
  const handledelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this service?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await axiosInstance.delete(
            `DeletePatientService/${id}`
          );
          if (response.data.success === true) {
            getPatientservice();
            Swal.fire(
              "Deleted!",
              "Service data deleted from patient.",
              "success"
            );
          } else {
            Swal.fire("Error", "Something went wrong.", "error");
          }
        } catch (error) {
          Swal.fire(
            "Error",
            error.response?.data?.message || "Request failed",
            "error"
          );
        }
      } else {
        Swal.fire("Cancelled", "Your service is safe!", "info");
      }
    });
  };

  // Fetch global discount limit - use same endpoint as FinanceSetting
  const fetchGlobalDiscountLimit = async () => {
    try {
      const response = await axiosInstance.get(`getAllDiscount`);
      if (response.data.success) {
        const data = response.data.data;
        const value = Array.isArray(data) && data.length > 0
          ? Number(data[0].discount_value)
          : 0;
        setGlobalDiscountLimit(Number.isFinite(value) ? value : 0);
      }
    } catch (error) {
      console.error("Error fetching global discount:", error);
      setGlobalDiscountLimit(0);
    }
  };


  // discount type chnage

  const handleDiscountTypeChange = (e) => {
    setInpval(prev => ({
      ...prev,
      //update selected discount type
      discount_type: e.target.value,
      // reset calculated discount amount
      discount_value: 0,
      //reset the calculation amount
      discount_amount: 0,

      // reset net amount back to original total price
      net_amount: prev.totalPrice || 0,
    }));
  };

  const handleDiscountValueChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    const totalPrice = inpval.totalPrice || testTotalPrice || 0;

    if (inpval.discount_type === "Percentage") {
      if (value > globalDiscountLimit) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Percentage discount cannot exceed ${globalDiscountLimit}%`,
        });
        return;
      }
    } else if (inpval.discount_type === "Amount") {
      const maxAllowedAmount = (totalPrice * globalDiscountLimit) / 100;
      if (value > maxAllowedAmount) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Amount discount cannot exceed ${globalDiscountLimit}% of total price (max ${maxAllowedAmount.toFixed(3)} BHD)`,
        });
        return;
      }
    }
    setInpval((prev) => ({
      ...prev,
      discount_value: value,
    }));
  };


  const handleEditPrescription = (plan) => {

    if (!plan) {
      Swal.fire("Error", "Prescription data missing", "error");
      return;
    }

    if (!plan.group_id) {
      console.warn("group_id missing in plan", plan);
      Swal.fire("Error", "Prescription Id missing", "error");
      return;
    }

    setIsEditMode(true);                          // ✅ Edit mode on
    setEditingGroupId(plan.group_id);             // ✅ Group ID save

    // Pre-fill form data
    setAddedMedicines((plan.medicines || []).map(med => ({
      rxId: med.rxId || null,
      medicine_name: med.medicine_name,
      dose: med.dose || "",
      frequency: med.frequency || "",
      duration: med.duration || "",
      notes: med.notes || "",
      dosage: med.dosage || "",
      form: med.form || "",
      substance: med.substance || "",
      product_type: med.product_type || "",
      packet_size: med.packet_size || "",
      route: med.route || "",
      strength: med.strength || "",
      unit: med.unit || "",
    })));

    setPrescriptionModalOpen(true);               // ✅ Same modal open
  };


  const handleUpdatePrescription = async () => {
    try {
      // Validation
      if (!selectedPrescription?.group_id) {
        Swal.fire("Error", "No prescription selected", "error");
        return;
      }

      if (!editMedicines || editMedicines.length === 0) {
        Swal.fire("Error", "At least one medicine required", "error");
        return;
      }

      // Payload preparation
      const payload = {
        patient_id: location?.state?.patientid?.id,
        medicines: editMedicines.map(med => ({
          medicine_name: med.medicine_name,
          strength: med.strength || null,
          frequency: med.frequency || null,
          dose: med.dose || null,
          dosage: med.dosage || null,
          product_type: med.product_type || null,
          duration: med.duration || null,
          route: med.route || null,
          substance: med.substance || null,
          packet_size: med.packet_size || null,
          notes: med.notes || null,
        })),
      };

      // API Call - NEW ENDPOINT
      const response = await axiosInstance.put(
        `updatePrescriptionGroup/${selectedPrescription.group_id}`,
        payload
      );

      if (response.data.success === true) {
        setEditPrescriptionModal(false);
        setSelectedPrescription(null);
        setEditMedicines([]);
        getdatamedical();    // Refresh prescription list
        getDataa1();         // Refresh medical data
        Swal.fire("Success", "Prescription updated successfully", "success");
      } else {
        Swal.fire("Error", response.data.message || "Update failed", "error");
      }
    } catch (error) {
      console.error("Update prescription error:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Failed to update prescription",
        "error"
      );
    }
  };



  const handlesavevital123 = async () => {
    try {
      const dataPost = {
        patientId: patientIdentifier,
        doctor_id: inpval.doctor_id,
        serviceId: inpval.service_id,
        amount: inpval.amount,
        insurance: inpval.insurance,
        vat: inpval.vat,
        branch_id: parseInt(localStorage.getItem('activeBranchId')) || (allBranchSettings.length === 1 ? allBranchSettings[0]?.id : null),
      };
      const response = await axiosInstance.post(`AddPatientServices`, dataPost);
      if (response.status === 200 || response.status === 201) {
        // Deduct linked inventory items for this service
        if (inpval.service_id) {
          try {
            await axiosInstance.post(`deductServiceInventory`, { service_id: inpval.service_id, patient_id: patientIdentifier });
          } catch (e) {
            console.warn("Inventory deduction failed:", e);
            Swal.fire("Warning", "Service added but inventory could not be deducted. Please check stock manually.", "warning");
          }
        }
        getPatientservice();
        hndleclosemodalservice();
        setOpenVital121(false);
        Swal.fire("Success", "Service Added successfully.", "success");
      } else {
        console.warn("Unexpected response:", response);
        Swal.fire(
          "error",
          "Unexpected server response. Please try again.",
          "error"
        );
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
        alert(
          "No response from server. Please check your internet connection."
        );
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };
  const pdfRef = useRef();
  const handleDownload = async () => {
    const element = pdfRef.current;
    const canvas = await html2canvas(element);
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("Patient File.pdf");
  };
  const handlesavevital = async () => {
    try {
      if (!patientIdentifier || !inpval.nurse || !inpval.recorded_at) {
        console.warn("Missing required fields");
        alert("Please fill in all required fields.");
        return;
      }
      const dataPost = {
        patient_id: parseInt(patientIdentifier),
        recorded_at: inpval.recorded_at,
        blood_pressure_systolic: inpval.blood_pressure_systolic,
        blood_pressure_blood_pressure_diastolic:
          inpval.blood_pressure_blood_pressure_diastolic,
        heart_rate: inpval.heart_rate,
        respiratory_rate: inpval.respiratory_rate,
        temperature: inpval.temperature,
        weight: inpval.weight,
        height: inpval.height,
        bmi: inpval.bmi,
        oxygen_saturation: inpval.oxygen_saturation,
        notes: inpval.notes,
      };
      const response = await axiosInstance.post(
        `recordPatientVitals`,
        dataPost
      );
      if (response.status === 200 || response.status === 201) {
        filterdate1();
        handlecloseVital();
        Swal.fire("success", "Vitals add Successfully", "success");
      } else {
        console.warn("Unexpected response:", response);
      }
    } catch (error) {
      if (error.response) {
        console.error("Error response:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error setting up request:", error.message);
      }
    }
  };
  const [prescriptionModalOpen, setPrescriptionModalOpen] = useState(false);
  const handlemodaldiagonise = () => {
    resetDiagnosisForm();
    setDiagonisemodal(true);
  };
  const handlemodaldiagoniseclose = () => {
    setPrescriptionModalOpen(false);
  };
  const handlemodaldpresctiption = () => {
    setIsEditMode(false);           // ✅ Add mode
    setEditingGroupId(null);        // ✅ Reset

    // Reset form
    setAddedMedicines([]);
    setMedicineData({
      rxId: null,
      medicine_name: "",
      dose: "",
      frequency: "",
      duration: "",
      notes: "",
      dosage: "",
      form: "",
      substance: "",
      productType: "",
      packet_size: "",
      route: "",
      strength: "",
      unit: "",
    });

    setPrescriptionModalOpen(true);
  };
  const userddertails = JSON.parse(localStorage.getItem("userMedical"));
  useEffect(() => {
    getDataa();
  }, []);
  useEffect(() => {
    getDataa1();
  }, []);
  const getDataa = async () => {
    try {
      const response = await axiosInstance.get(
        `getPatientVitalsByPatientId/${patientIdentifier}`
      );

      // Validate HTTP status
      if (response.status !== 200) {
        console.error("Unexpected HTTP status:", response.status);
        return;
      }

      // Validate success flag
      if (response.data?.success) {
        const vitals = response.data?.data?.vitals || [];
        setVitaldatas(vitals);
        setPatinetvitals(response.data?.vitals || vitals);
      } else {
        console.warn("API returned failure:", response.data);
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  // getDataa1patientvital removed — patinetvitals now set inside getDataa() above

  const userMedical = localStorage.getItem("userMedical");

  const parsedUser = userMedical ? JSON.parse(userMedical) : null;

  const nurseName = parsedUser?.data?.fullName || "Unknown Nurse";

  const getDataa1 = async () => {
    try {
      const response = await axiosInstance.get(
        `getMedicalDataWithVitals/${patientIdentifier}`
      );
      if (response.data?.success === true) {
        setDataMedical(response.data.data);
        setVitaldatas(response.data.data.vitals);
      } else {
        console.warn("Vitals not found or invalid status:", response.data);
      }
    } catch (error) {
      if (error.response) {
        console.error("API error:", error.response.data);
      } else if (error.request) {
        console.error("No response received:", error.request);
      } else {
        console.error("Error in request setup:", error.message);
      }
    }
  };


  // getDoctors removed — doctors loaded by loadDoctors() in [patientIdentifier] effect




  // Discount calculation useEffect
  useEffect(() => {
    const total = selectedServices.reduce((sum, s) => {
      const price = companyLabPriceMap[s.id] ?? parseFloat(s.price) ?? 0;
      const qty = parseInt(s.quantity, 10) || 1;
      return sum + price * qty;
    }, 0);

    const maxAllowedDiscountAmount = (total * globalDiscountLimit) / 100;

    let discountAmt = 0;
    if (inpval.discount_type === "Percentage") {
      discountAmt = (total * (parseFloat(inpval.discount_value) || 0)) / 100;
    } else {
      discountAmt = parseFloat(inpval.discount_value) || 0;
    }

    // Ensure discount never exceeds the global discount limit or the total
    discountAmt = Math.min(discountAmt, maxAllowedDiscountAmount, total);
    const net = total - discountAmt;

    setTestTotalPrice(total);
    setTestDiscountAmount(discountAmt);
    setTestNetAmount(net);

    setInpval((prev) => ({
      ...prev,
      totalPrice: total,
      discount_amount: discountAmt,
      net_amount: net,
    }));
  }, [selectedServices, inpval.discount_type, inpval.discount_value, companyLabPriceMap, globalDiscountLimit]);

  const handlesavediagonise = async () => {
    try {
      if (!inpval.icd10_id || !inpval.notes || !inpval.doctor_id) {
        Swal.fire("Error", "Please fill in all fields.", "error");
        return;
      }
      const dataPost = {
        patient_id: parseInt(patientIdentifier),
        icd10_id: inpval.icd10_id,
        doctor_id: inpval.doctor_id,
        notes: inpval.notes,
        diagnosis_date: inpval.diagnosis_date,
      };
      const response = await axiosInstance.post(
        `recordPatientDiagnosis`,
        dataPost
      );
      if (response.data.success === true) {
        setDiagonisemodal(false);
        Swal.fire("Success", "Diagnosis saved successfully.", "success");
      } else {
        Swal.fire(
          "Error",
          "Failed to save diagnosis. Please try again.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error saving diagnosis:", error);
      Swal.fire(
        "Error",
        "Failed to save diagnosis. Please try again.",
        "error"
      );
    }
  };
  useEffect(() => {
    getrecordDiagpise();
  }, []);
  const getrecordDiagpise = async () => {
    try {
      const response = await axiosInstance.get(
        `getPatientDiagnosisByPatientId/${patientIdentifier}`
      );

      if (response?.data?.success === true) {
        setDiagnosis11(response.data.data);
      } else {
        console.warn(
          "Diagnosis not found OR API returned success:false",
          response?.data
        );
      }
    } catch (error) {
      console.error(error)
      setDiagnosis11([]);
    }
  };

  // getservices removed — getservice/patients now set by loadAvailableServices() in [patientIdentifier] effect
  const getPatientAppointment = async () => {
    try {
      const response = await axiosInstance.get(
        `getPatientById/${patientIdentifier}`
      );

      // Validate success response
      if (response?.data?.success === true) {
        setPersonalinfo(response.data.data);
        if (response.data.data.patient_password_base64) {
          try {
            setDecodedPassword(atob(response.data.data.patient_password_base64));
          } catch (e) {
            console.error("Error decoding password:", e);
            setDecodedPassword("");
          }
        }
      } else {
        console.warn(
          "Patient data fetch failed or returned success:false:",
          response?.data?.message || "Unknown message"
        );
      }
    } catch (error) {
      console.error("Error fetching patient data:", error);

      // 4️⃣ Optional fallback: avoid UI crash
      setPersonalinfo(null);
    }
  };

  useEffect(() => {
    getPatientAppointment();
    loadAvailableServices();
    getPatientservice();
  }, [triggerLabRefresh]);
  const getPatientservice = async () => {
    try {
      // Use the specific ID that PatientServices uses to ensure consistency
      const targetId = location?.state?.patientid?.id || patientIdentifier;
      const response = await axiosInstance.get(
        `getPatientServices/${targetId}?date=${dateqq || ""}`
      );
      if (response.status === 200) {
        setpatientservice(response.data.data);
      } else {
        setpatientservice([])
      }
    } catch (error) {
      setpatientservice([])
      console.error("Error fetching patient service:", error.message);
    }
  };
  useEffect(() => {
    getPatientservice();
    loadPatientServices();
  }, [refreshKey]);

  ////////////////////////////////////// const vital form///////////////////////////
  const [formData, setFormData] = useState({
    blood_pressure_systolic: "",
    blood_pressure_diastolic: "",
    bp_position: "",
    respiratory_rate: "",
    pulse: "",
    temperature: "",
    spo2: "",
    rbs_mg: "",
    rbs_nmol: "",
    weight: "",
    height: "",
    risk_of_fall: "",
    urgency: "",
    notes: "",
  });
  // const [formData, setFormData] = useState();
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: value });
  };
  const calculateBMI = () => {
    const weight = parseFloat(formData.weight);
    const heightInMeters = parseFloat(formData.height) / 100;
    if (!weight || !heightInMeters || heightInMeters === 0) return "";
    return (weight / (heightInMeters * heightInMeters)).toFixed(2);
  };

  const handleapisubmit = async () => {
    setIsSubmitting(true);
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0];
    const recordedAt = `${date} ${time}`;

    const validations = [
      {
        name: "blood_pressure_systolic",
        value: formData.blood_pressure_systolic,
        min: 40,
        max: 300,
      },
      {
        name: "blood_pressure_diastolic BP",
        value: formData.blood_pressure_diastolic,
        min: 20,
        max: 180,
      },
      {
        name: "Respiratory Rate",
        value: formData.respiratory_rate,
        min: 5,
        max: 50,
      },
      { name: "Pulse", value: formData.pulse, min: 10, max: 400 },
      { name: "Temperature", value: formData.temperature, min: 10, max: 60 },
      { name: "spo2", value: formData.spo2, min: 0, max: 100 },
      { name: "RBS mg/dl", value: formData.rbs_mg, min: 10, max: 800 },
      { name: "RBS mmol/l", value: formData.rbs_nmol, min: 0.5, max: 50 },
      { name: "Weight", value: formData.weight, min: 0, max: 1000 },
      { name: "Height", value: formData.height, min: 0, max: 300 },
    ];

    // Updated validation: skip empty fields, validate filled ones
    for (const field of validations) {
      if (
        field.value === "" ||
        field.value === null ||
        field.value === undefined
      ) {
        continue;
      }

      const num = parseFloat(field.value);

      if (isNaN(num) || num < field.min || num > field.max) {
        setIsSubmitting(false);
        return Swal.fire(
          "Required",
          `${field.name} must be between ${field.min} and ${field.max}`,
          "warning"
        );
      }
    }
    const payload = {
      blood_pressure_systolic: parseInt(formData.blood_pressure_systolic),
      blood_pressure_diastolic: parseInt(formData.blood_pressure_diastolic),
      bp_position: formData.bp_position,
      respiratory_rate: parseInt(formData.respiratory_rate),
      pulse: parseInt(formData.pulse),
      age: location.state.patientid.age,
      spo2: parseInt(formData.spo2),
      rbs_mg: parseFloat(formData.rbs_mg),
      rbs_nmol: parseFloat(formData.rbs_nmol),
      temperature: parseFloat(formData.temperature),
      weight: parseFloat(formData.weight),
      height: parseFloat(formData.height),
      risk_of_fall: formData.risk_of_fall,
      urgency: formData.urgency,
      notes: formData.notes,
      patient_id: location?.state?.patientid?.id,
      recorded_at: recordedAt,
      doctor_id: location.state.patientid.defaultDoctorId,
    };
    try {
      const response = await axiosInstance.post(`recordPatientVitals`, payload);
      if (response.data.success === true) {
        getDataa();
        getdatamedical();
        getDataa1();
        getDataa();
        filterdate111();
        Swal.fire("Success", "Vitals added successfully", "success");
        setFormData({
          blood_pressure_systolic: "",
          blood_pressure_diastolic: "",
          bp_position: "",
          respiratory_rate: "",
          pulse: "",
          temperature: "",
          spo2: "",
          rbs_mg: "",
          rbs_nmol: "",
          weight: "",
          height: "",
          risk_of_fall: "",
          urgency: "",
          notes: "",
        });
        setIsSubmitting(false);
        handlecloseVital();
      } else {
        Swal.fire("Oops!", "Something went wrong!", "error");
        setIsSubmitting(false);
      }
    } catch (error) {
      setIsSubmitting(false);
      const err = error?.response?.data;
      let messages = [];
      if (err?.errors && Array.isArray(err.errors)) {
        messages = err.errors;
      } else if (err?.message) {
        messages = [err.message];
      } else if (typeof err === "string") {
        messages = [err];
      } else {
        messages = ["Something went wrong"];
      }
      return Swal.fire({
        icon: "error",
        title: "Please check the following:",
        html: messages.map((m) => `<p >${m}</p>`).join(""),
      });
    }
  };

  const handleclickdeletevital = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#e61e10ff",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (result.isConfirmed) {
      try {
        const response = await axiosInstance.delete(
          `deletePatientVital/${id}/${location.state.patientid.id}`
        );
        if (response.data.success === true) {
          getDataa();
          Swal.fire("Deleted!", "Vital deleted successfully.", "success");
        } else {
          Swal.fire("Oops!", "Something went wrong.", "error");
        }
      } catch (error) {
        Swal.fire(
          "Error",
          error?.response?.data?.message || "Something went wrong",
          "error"
        );
      }
    }
  };
  const handleclikdeleteapp = async (item) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#f3150eff",
      confirmButtonText: "Yes, delete it!",
    });
    if (confirmResult.isConfirmed) {
      try {
        const response = await axiosInstance.delete(
          `deleteAppointments/${item.id}`
        );
        if (response.data.success === true) {
          getdata();
          Swal.fire(
            "Deleted!",
            "Patient appointment deleted successfully.",
            "success"
          );
        } else {
          Swal.fire("Error", "Something went wrong.", "error");
        }
      } catch (error) {
        const err = error.response?.data?.message || "Server error";
        Swal.fire("Error", err, "error");
      }
    }
  };
  const handleclickpopusopenn = () => {
    setAddpatinemodal(true);
  };
  const handleclickpopusopenn11 = () => {
    setAddpatinemodal(false);
  };
  const patientid = location?.state?.patientid?.id;
  const patientId = location?.state?.patientid?.id;
  // ////////////////////////////////////////////////// add appointment////////////////////////
  const [formData1, setFormData1] = useState({
    // patientId: patientid,
    doctorId: "",
    appointmentDate: "",
    startTime: null,
    endTime: null,
    reason: "",
    status: "Scheduled",
  });
  const [errors, setErrors] = useState({});
  const [doctors1, setDoctors1] = useState([]);
  // fetchDoctors removed — doctors1 now set by loadDoctors() in [patientIdentifier] effect
  const validate = () => {
    const newErrors = {};
    if (!formData1.appointmentDate)
      newErrors.appointmentDate = "Date is required";
    if (!formData1.reason.trim()) newErrors.reason = "Notes is required";
    if (!formData1.doctorId) newErrors.doctorId = "Doctor is required";
    if (!formData1.startTime) newErrors.startTime = "Start time is required";
    if (!formData1.endTime) newErrors.endTime = "End time is required";
    if (formData1.startTime && formData1.endTime) {
      const start = new Date(`2020-01-01T${formData1?.startTime}`);
      const end = new Date(`2020-01-01T${formData1?.endTime}`);
      const diffInMs = end - start;
      const diffInHours = diffInMs / (1000 * 60 * 60);
      if (diffInHours <= 0) {
        newErrors.endTime = "End time must be after start time";
      } else if (diffInHours > 5) {
        newErrors.endTime = "Appointment can't be more than 5 hours";
      }
    }
    setErrors(newErrors);
    return newErrors;
  };
  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1((prev) => ({ ...prev, [name]: value }));
  };
  const handleSubmit = async (e) => {
    let dataToSend = { ...formData1 };
    if (formData1.status === "Waiting") {
      delete dataToSend.startTime;
      delete dataToSend.endTime;
    } else {
      if (!formData1.startTime || !formData1.endTime) {
        setErrors((prev) => ({
          ...prev,
          startTime: "Start time is required",
          endTime: "End time is required",
        }));
        return;
      }

      const [startHour, startMinute] = formData1.startTime
        .split(":")
        .map(Number);
      const [endHour, endMinute] = formData1.endTime.split(":").map(Number);
      const startTotal = startHour * 60 + startMinute;
      const endTotal = endHour * 60 + endMinute;
      if (endTotal - startTotal < 5) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Time Range",
          text: "End time must be at least 5 minutes after start time.",
        });
        return;
      }
      if (endTotal <= startTotal) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Time Selection",
          text: "End time must be later than start time.",
        });
        return;
      }
    }
    try {
      const response = await axiosInstance.post(`createAppointment`, {
        ...formData1,
        patientId,
        branch_id: parseInt(localStorage.getItem('activeBranchId')) || null,
      });
      if (response.data.success) {
        handleclickpopusopenn11();
        getdata();
        Swal.fire("Success", "Appointment added successfully!", "success");
        setFormData1({
          doctorId: "",
          appointmentDate: "",
          startTime: "",
          endTime: "",
          reason: "",
          status: "Scheduled",
          status: "",
        });
        setErrors({});
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Unknown error occurred.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error creating appointment:", error);
      if (error.response) {
        const errMessage =
          error.response.data?.message || "Server error occurred.";
        Swal.fire("Error", errMessage, "error");
      } else if (error.request) {
        Swal.fire(
          "Error",
          "No response from server. Please check your internet.",
          "error"
        );
      } else {
        Swal.fire(
          "Error",
          "Something went wrong while sending the request.",
          "error"
        );
      }
    }
  };

  // //////////////////////////////////////////////////allergy//////////////////////////////////////////////
  const [editingXray, setEditingXray] = useState(null); // store ID when editing
  const [isEditingXray, setIsEditingXray] = useState(false);
  const addxray = async () => {
    // Allergies are stored by name, exactly as typed. The backend adds an unseen name to
    // the suggestion list itself, so there is no separate "create the master entry" step
    // that can fail and leave the allergy saved as an unresolvable value.
    const allergyName = (formData13.name || "").trim();
    if (!allergyName) {
      Swal.fire("Error", "Please enter an allergy name", "error");
      return;
    }

    const obj = {
      patient_id: location?.state?.patientid?.id,
      name: allergyName,
      type: formData13.description,
    };
    try {
      const response = await axiosInstance.post(`addPatientAllergy`, obj);
      if (response.data.success === true) {
        getdatamedical();
        getDataa1();
        closeAllergy();
        fetchAllAllergies();
        Swal.fire("Success", "Allergy Added Successfully", "success");
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        const errData = error.response.data;
        if (Array.isArray(errData.errors)) {
          const formattedErrors = errData.errors
            .map((err) => `• ${err.msg || err}`)
            .join("<br/>");
          Swal.fire({
            icon: "error",
            title: "Validation Errors",
            html: formattedErrors,
          });
        } else if (typeof errData.message === "string") {
          Swal.fire("Error", errData.message, "error");
        } else if (typeof errData === "object") {
          const formatted = Object.entries(errData)
            .map(([key, val]) => `• ${key}: ${val}`)
            .join("<br/>");
          Swal.fire({
            icon: "error",
            title: "Errors",
            html: formatted,
          });
        } else {
          Swal.fire("Error", "Unexpected error occurred", "error");
        }
      } else {
        Swal.fire("Error", "Network error or server not responding", "error");
      }
    }
  };
  const handlechangeXray = (e) => {
    const { name, value, files, type } = e.target;
    setDataxray((prev) => ({
      ...prev,
      [name]: type === "file" ? Array.from(files) : value,
    }));
  };
  const Addreport = async () => {
    const files = Array.isArray(dataxray.attachment)
      ? dataxray.attachment
      : dataxray.attachment
      ? [dataxray.attachment]
      : [];
    if (files.length === 0) {
      Swal.fire("Error", "Please select at least one file", "error");
      return;
    }
    try {
      for (const file of files) {
        const formdata = new FormData();
        formdata.append("title", dataxray.Title || "");
        formdata.append("description", dataxray.description || "");
        formdata.append("attachment", file);
        formdata.append("patient_id", location?.state?.patientid?.id);
        await axiosInstance.post(`addXrayReport`, formdata);
      }
      getdatamedical();
      getDataa1();
      closexray();
      Swal.fire(
        "success",
        files.length > 1 ? `${files.length} files Added Successfully` : "Added Successfully",
        "success"
      );
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to add file(s)", "error");
    }
  };
  const handleEditXray = (plan) => {
    setDataxray({
      Title: plan.title,
      description: plan.description,
      attachment: null,
    });
    setEditingXray(plan.id);
    setIsEditingXray(true);
    openxray();
  };
  const updateXray = async () => {
    const formData = new FormData();
    formData.append("id", editingXray);
    formData.append("title", dataxray.Title || "");
    formData.append("description", dataxray.description || "");
    const file = Array.isArray(dataxray.attachment) ? dataxray.attachment[0] : dataxray.attachment;
    if (file) {
      formData.append("attachment", file);
    }
    try {
      const response = await axiosInstance.put(`updateXrayReport`, formData);
      if (response.data.success) {
        getdatamedical();
        getDataa1();
        Swal.fire("Success", "Updated Successfully", "success");
        setIsEditingXray(false);
        setEditingXray(null);
        closexray();
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Failed to update Xray", "error");
    }
  };


  const handleclickopentestadd = () => {
    // Step 1: Modal open karo
    setOpenmodaltest(true);

    // Step 2: Form reset karo - doctor_id empty rakho, useEffect handle karega
    setInpval({
      category: "",
      doctor_id: "",
      title: "",
      description: "",
      serviceIds: [],
      file: null,
      discount_type: "Amount",
      discount_value: 0,
      totalPrice: 0,
      discount_amount: 0,
      net_amount: 0,
    });

    // Step 3: Price states reset karo
    setTestTotalPrice(0);
    setTestDiscountAmount(0);
    setTestNetAmount(0);
    setSelectedServices([]);
    setLabServices([]);

    // Step 4: Doctor auto-select useEffect pe chhod do (doctors load hone ke baad)

    // Step 5: Agar data2 available hai toh first lab select karo
    setTimeout(() => {
      if (data2 && data2.length > 0) {
        const firstLab = data2[0];
        setInpval((prev) => ({
          ...prev,
          category: firstLab.id
        }));
        fetchLabServices(firstLab.id);
      }
    }, 0);
  };


  const closeModaladdtest = () => {
    setOpenmodaltest(false);
  };
  useEffect(() => {
    getDataset();
  }, []);


  const fetchLabServices = async (labId) => {
    if (!labId) {
      setLabServices([]);
      setSelectedServices([]);
      return Promise.resolve();
    }
    try {
      const response = await axiosInstance.get(`getLabById/${labId}`);
      if (
        response.data.success &&
        response.data.data &&
        Array.isArray(response.data.data.services)
      ) {
        setLabServices(response.data.data.services);
      } else {
        console.warn("Failed to fetch lab services or no services");
        setLabServices([]);
      }
    } catch (error) {
      console.error("Error fetching lab services:", error);
      setLabServices([]);
      throw error;
    }
    return Promise.resolve();
  };
  const getDataset = async () => {
    try {
      const response = await axiosInstance.get(`getAllActiveLabs`);
      if (response.data.success === true) {
        setData2(response.data.data);
      } else {
        Swal.fire("Error", "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Failed to fetch labs", error);
    }
  };
  const handletest = async () => {
    try {
      const formData = new FormData();
      formData.append("patient_id", location.state.patientid.id);
      formData.append("lab_id", inpval.category);
      formData.append("doctor_id", inpval.doctor_id);
      formData.append("title", inpval.title);
      formData.append("description", inpval.description);
      formData.append("sent_by", "nurse1");
      formData.append("serviceIds", JSON.stringify(inpval.serviceIds || []));
      const serviceQuantities = {};
      selectedServices.forEach((s) => {
        serviceQuantities[s.id] = parseInt(s.quantity, 10) || 1;
      });
      formData.append("serviceQuantities", JSON.stringify(serviceQuantities));

      // discount fields add
      formData.append("discount_type", inpval.discount_type);
      formData.append("discount_value", inpval.discount_value);
      formData.append("total_price", inpval.totalPrice || testTotalPrice);
      formData.append("discount_amount", inpval.discount_amount || testDiscountAmont);
      formData.append("net_amount", inpval.net_amount || testNetAmount);
      formData.append("branch_id", parseInt(localStorage.getItem('activeBranchId')) || (allBranchSettings.length === 1 ? allBranchSettings[0]?.id : null) || "");
      const response = await axiosInstance.post(`addLabRequest`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.success === true) {
        if (inpval.file) {
          try {
            const attachmentFormData = new FormData();
            attachmentFormData.append("file", inpval.file);
            attachmentFormData.append(
              "name",
              inpval.file.name || "Lab Request Attachment"
            );
            attachmentFormData.append("report_status", "Pending");
            const attachmentResponse = await axiosInstance.post(
              `addLabRequestAttachment/${response.data.data.request_id || response.data.data.id
              }`,
              attachmentFormData,
              {
                headers: { "Content-Type": "multipart/form-data" },
              }
            );
            if (attachmentResponse.data.success) {

            } else {
              console.warn(
                "Lab request created but attachment failed:",
                attachmentResponse.data
              );
            }
          } catch (attachmentError) {
            console.error("Error adding attachment:", attachmentError);
          }
        }
        // Reset discount states
        setTestTotalPrice(0);
        setTestDiscountAmount(0);
        setTestNetAmount(0);
        closeModaladdtest();
        getLabsbypatient();
        dispatch(triggerLabRefresh());
        Swal.fire("success", "Lab Request Added Successfully", "success");
      } else {
        console.warn(
          "Something went wrong:",
          response.data.message || response.data
        );
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
    }
  };
  const handleclicknavi = (item) => {
    navigate("/Admin/viewappointment", { state: { data: item } });
  };
  const handleChange23 = (e) => {
    const { name, value, type, checked } = e.target;
    setAppointmentdata({ ...appointmentdata, [name]: value });
  };
  const handlimodalopen = (item) => {
    setAppointmentdata(item);
    setShowModalDoctor(true);
  };
  const handleclose111 = () => {
    setShowModalDoctor(false);
  };
  useEffect(() => {
    getLabsbypatient();
  }, []);
  useEffect(() => {
    axiosInstance.get(`getAllLabs`).then((res) => {
      if (res.data.success && Array.isArray(res.data.data)) {
        setLabs(res.data.data);
      }
    });
  }, []);
  const getLabsbypatient = async (selectedDate = null) => {
    try {
      const response = await axiosInstance.get(
        `getLabRequestsByPatient/${location.state.patientid.id}?date=${selectedDate || ""}`
      );
      if (response.data.success === true) {
        setLabData(response.data.data);
      } else {
        console.warn(
          "Something went wrong:",
          response.data.message || response.data
        );
      }
    } catch (error) {
      setLabData([])
      console.error("API Error:", error.response?.data || error.message);
    }
  };
  const handleLabView = (item) => {
    navigate(`/Admin/ViewLab/${item.request_id}`);
  };



  const handleLabEdit = async (item) => {

    // Identify all possible variations of lab_id from the initial item
    let initialLabId = item.lab_id || item.labId || item.LabID || "";

    // Fallback: If lab_id is missing but lab_name is present, find the ID from labs list
    if (!initialLabId && item.lab_name && labs.length > 0) {
      const foundLab = labs.find(l => l.lab_name === item.lab_name);
      if (foundLab) initialLabId = foundLab.id;
    }

    // Set basic data immediately to open the modal
    setEditLabData({
      request_id: item.request_id,
      lab_id: initialLabId ? String(initialLabId) : "",
      title: item.title || "",
      description: item.description || "",
      serviceId: null,
      attachmentName: "",
      attachmentStatus: "",
      // Add discount fields with fallback to existing values or defaults
      discount_type: item.discount_type || "Amount",
      discount_value: item.discount_value || 0,
      total_price: item.total_price || 0,
      discount_amount: item.discount_amount || 0,
      net_amount: item.net_amount || 0,
    });

    // Set discount states from existing data
    setEditTestTotalPrice(Number(item.total_price) || 0);
    setEditTestDiscountAmount(Number(item.discount_amount) || 0);
    setEditTestNetAmount(Number(item.net_amount) || 0);

    setShowEditLabModal(true);

    try {
      const res = await axiosInstance.get(`getLabRequestById/${item.request_id}`);

      if (res.data.success && res.data.data) {
        const data = res.data.data;

        // Extract effective lab_id (check multiple fields + name fallback)
        let effectiveLabId = data.lab_id || data.labId || data.LabID || initialLabId;

        if (!effectiveLabId && data.lab_name && labs.length > 0) {
          const foundLab = labs.find(l => l.lab_name === data.lab_name);
          if (foundLab) effectiveLabId = foundLab.id;
        }

        // Update basic data
        setEditLabData((prev) => ({
          ...prev,
          lab_id: effectiveLabId ? String(effectiveLabId) : prev.lab_id,
          title: data.title || prev.title,
          description: data.description || prev.description,
          // Update discount fields if available in response
          discount_type: data.discount_type || prev.discount_type || "Amount",
          discount_value: data.discount_value || prev.discount_value || 0,
          total_price: data.total_price || prev.total_price || 0,
          discount_amount: data.discount_amount || prev.discount_amount || 0,
          net_amount: data.net_amount || prev.net_amount || 0,
        }));

        // Update discount states from detailed response
        const totalPrice = Number(data.total_price) || 0;
        const discountAmount = Number(data.discount_amount) || 0;
        const netAmount = Number(data.net_amount) || 0;

        setEditTestTotalPrice(totalPrice);
        setEditTestDiscountAmount(discountAmount);
        setEditTestNetAmount(netAmount);

        if (effectiveLabId) {
          await fetchLabServices(effectiveLabId);

          let serviceId = null;

          // Check ALL possible variations for service selection
          if (data.service_ids) {
            serviceId = data.service_ids;
          } else if (data.service_Ids) {
            serviceId = data.service_Ids;
          } else if (Array.isArray(data.serviceIds) && data.serviceIds.length > 0) {
            serviceId = data.serviceIds[0];
          } else if (data.services && Array.isArray(data.services) && data.services.length > 0) {
            serviceId = data.services[0].serviceId || data.services[0].id || data.services[0].service_id;
          } else if (item.service_ids || item.service_Ids) {
            serviceId = item.service_ids || item.service_Ids;
          }

          setEditLabData((prev) => ({
            ...prev,
            serviceId: serviceId ? String(serviceId) : null,
          }));
        }
      }
    } catch (error) {
      console.error("Failed to load lab request details", error);
    }

    // Fetch attachments separately
    axiosInstance
      .get(`getLabRequestAttachmentsByLabRequestId/${item.request_id}`)
      .then((res) => {
        if (res.data.success) {
          setEditLabAttachments(res.data.data);
        } else {
          setEditLabAttachments([]);
        }
      })
      .catch((err) => {
        setEditLabAttachments([]);
      });
  };



  const handleLabDelete = async (item) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });
    if (confirm.isConfirmed) {
      try {
        const response = await axiosInstance.delete(
          `deleteLabRequest/${item.request_id}`
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Lab request has been deleted.", "success");
          getLabsbypatient();
        } else {
          Swal.fire(
            "Error",
            response.data.message || "Failed to delete lab request",
            "error"
          );
        }
      } catch (error) {
        Swal.fire("Error", "Server error while deleting lab request", "error");
      }
    }
  };
  const resetDiagnosisForm = () => {
    setInputValue9("");
    setInputValue1("");
    setInputValueCode("");
    setIcdList1([]);
    setSelectedIcd1(null);
    setSelectedCode(null);
    setDiagnosisStatus("");
    setShow(true);
  };
  const apihitmedicdeagonil = async () => {
    const obj = {
      patient_id: location?.state?.patientid?.id,
      diagnosis_text: show === false ? inputValue9 : selectedIcd1?.label,
      code: show === false ? "" : selectedIcd1?.code,
      status: diagnosisStatus,
    };
    try {
      const response = await axiosInstance.post(`addDiagnosis`, obj);
      if (
        response.data?.success === true ||
        response.data?.success === "true" ||
        response.data?.success === 1
      ) {
        getdatamedical();
        getDataa1();
        resetDiagnosisForm();
        hndleclosddddd();
        Swal.fire("Success", "Diagnosis  added successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      if (error.response?.data) {
        const errData = error.response.data;
        if (Array.isArray(errData?.errors)) {
          const formattedErrors = errData.errors
            .map((err) => `• ${err.msg || err}`)
            .join("<br/>");
          Swal.fire({
            icon: "error",
            title: "Validation Errors",
            html: formattedErrors,
          });
          return;
        }
        if (typeof errData?.message === "string") {
          Swal.fire("Error", errData.message, "error");
          return;
        }
        if (typeof errData === "object") {
          const formatted = Object.entries(errData)
            .map(([key, val]) => `• ${key}: ${val}`)
            .join("<br/>");
          Swal.fire({ icon: "error", title: "Errors", html: formatted });
          return;
        }
      }
      Swal.fire("Error", "Network error or server not responding", "error");
    }
  };
  const apihitmedicdeagonilsdsd = async () => {
    try {
      const obj = {
        prescription_id: editLabData?.prescription_id,
        patient_id: location?.state?.patientid?.id,
        branch_id: parseInt(localStorage.getItem('activeBranchId')) || (allBranchSettings.length === 1 ? allBranchSettings[0]?.id : null),
      };

      // Validation before API call
      if (!obj.prescription_id || !obj.patient_id) {
        Swal.fire("Error", "Missing required fields", "error");
        return;
      }

      const response = await axiosInstance.post(`addPrescription`, obj);

      // Handle missing or invalid response
      if (!response || !response.data) {
        Swal.fire("Error", "Invalid server response", "error");
        return;
      }

      // Success response
      if (response.data.success === true) {
        handlemodaldiagoniseclose();

        Swal.fire("Success", "Prescription added successfully", "success");

        getdatamedical();
        getDataa1();
      } else {
        // Backend returned success: false
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (err) {
      console.error("API Error:", err);

      // Axios error with response (server error)
      if (err.response) {
        Swal.fire(
          "Error",
          err.response.data?.message || "Server returned an error",
          "error"
        );
      }
      // No response (network error)
      else if (err.request) {
        Swal.fire(
          "Network Error",
          "Unable to reach server. Check your internet connection.",
          "error"
        );
      }
      // Something else (unexpected error)
      else {
        Swal.fire("Error", err.message || "Unexpected error occurred", "error");
      }
    }
  };

  const handleEditLabChange = (e) => {
    const { name, value } = e.target;
    setEditLabData((prev) => ({ ...prev, [name]: value }));

    // When lab is changed in edit modal, refetch services for that lab and clear selections
    if (name === "lab_id" && value !== editLabData.lab_id) {
      fetchLabServices(value);
      setEditLabData((prev) => ({
        ...prev,
        lab_id: value,
        serviceId: null,
      }));
    }
  };
  const handleEditLabFileChange = (e) => {
    const { name, files } = e.target;
    setEditLabData((prev) => ({ ...prev, [name]: files[0] }));
  };
  const handleAddLabAttachment = async () => {
    if (
      !editLabData.newAttachment ||
      !editLabData.attachmentName ||
      !editLabData.attachmentStatus
    ) {
      Swal.fire("Error", "Please fill all attachment fields", "error");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", editLabData.newAttachment);
      formData.append("name", editLabData.attachmentName);
      formData.append("report_status", editLabData.attachmentStatus);
      const response = await axiosInstance.post(
        `addLabRequestAttachment/${editLabData.request_id}`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (response.data.success) {
        const res = await axiosInstance.get(
          `getLabRequestAttachmentsByLabRequestId/${editLabData.request_id}`
        );
        if (res.data.success) {
          setEditLabAttachments(res.data.data);
        }
        setEditLabData((prev) => ({
          ...prev,
          newAttachment: null,
          attachmentName: "",
          attachmentStatus: "",
        }));
        Swal.fire("Success", "Attachment added successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to add attachment",
          "error"
        );
      }
    } catch (error) {
      console.error("Error adding attachment:", error);
      Swal.fire("Error", "Server error while adding attachment", "error");
    }
  };



  const handleEditLabSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        lab_id: editLabData.lab_id,
        serviceIds: editLabData.serviceId ? [Number(editLabData.serviceId)] : [],
        // Add discount fields to payload
        discount_type: editLabData.discount_type || "Amount",
        discount_value: parseFloat(editLabData.discount_value) || 0,
        total_price: editTestTotalPrice || 0,
        discount_amount: editTestDiscountAmount || 0,
        net_amount: editTestNetAmount || 0,
      };

      // Title aur Description optional hain - sirf value hai toh include karo
      if (editLabData.title && editLabData.title.trim() !== "") {
        payload.title = editLabData.title;
      }
      if (editLabData.description && editLabData.description.trim() !== "") {
        payload.description = editLabData.description;
      }

      const res = await axiosInstance.put(
        `${baseurl}editLabRequest/${editLabData.request_id}`,
        payload
      );

      if (res.data.success) {
        setShowEditLabModal(false);
        // Reset discount states
        setEditTestTotalPrice(0);
        setEditTestDiscountAmount(0);
        setEditTestNetAmount(0);
        getLabsbypatient();
        Swal.fire("Success", "Lab request updated successfully", "success");
      } else {
        Swal.fire(
          "Error",
          res.data.message || "Failed to update lab request",
          "error"
        );
      }
    } catch {
      Swal.fire("Error", "Server error while updating lab request", "error");
    }
  };


  const handleDeleteLabAttachment = async (attachmentId) => {
    Swal.fire({
      title: "Are you sure?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axiosInstance.delete(
            `deleteLabRequestAttachment/${attachmentId}`
          );
          if (res.data.success) {
            setEditLabAttachments((prev) =>
              prev.filter((att) => att.attachment_id !== attachmentId)
            );
            Swal.fire(
              "Deleted!",
              "The attachment has been deleted.",
              "success"
            );
          } else {
            Swal.fire(
              "Error",
              res.data.message || "Failed to delete attachment",
              "error"
            );
          }
        } catch {
          Swal.fire("Error", "Server error while deleting attachment", "error");
        }
      }
    });
  };
  const handleclickddappointment = async () => {
    if (!appointmentdata.appointmentDate) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Please select an appointment date.",
      });
      return;
    }
    if (!appointmentdata.startTime || !appointmentdata.endTime) {
      Swal.fire({
        icon: "warning",
        title: "Missing Fields",
        text: "Please select both start and end times.",
      });
      return;
    }
    const [startHour, startMinute] = appointmentdata.startTime
      .split(":")
      .map(Number);
    const [endHour, endMinute] = appointmentdata.endTime.split(":").map(Number);
    const startTotal = startHour * 60 + startMinute;
    const endTotal = endHour * 60 + endMinute;
    if (endTotal <= startTotal) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Time Selection",
        text: "End time must be later than start time.",
      });
      return;
    }
    if (endTotal - startTotal < 5) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Time Range",
        text: "End time must be at least 5 minutes after start time.",
      });
      return;
    }
    const localDate = new Date(appointmentdata?.appointmentDate);
    const formattedDate = localDate?.toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata",
    });
    const objedit = {
      appointmentDate: formattedDate,
      startTime: appointmentdata.startTime,
      endTime: appointmentdata.endTime,
      reason: appointmentdata.reason,
    };
    try {
      const response = await axiosInstance.put(
        `editAppointmentByPatientId/${appointmentdata.id}/${location.state.patientid.id}`,
        objedit
      );
      if (response.data.success === true) {
        handleclose111();
        getdata();
        Swal.fire("Success", "Appointment updated successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data.message || "Failed to update appointment",
          "error"
        );
      }
    } catch (error) {
      console.error("API Error:", error.response?.data || error.message);
      Swal.fire(
        "Error",
        "An error occurred while updating appointment",
        "error"
      );
    }
  };
  const handleclickpen = (item) => {
    setOpenmodalforvital(true);
    setFormData(item);
  };
  const handlecloseVitaleditclose = () => {
    setOpenmodalforvital1(false);
    setFormData({
      blood_pressure_systolic: "",
      blood_pressure_diastolic: "",
      bp_position: [],
      respiratory_rate: "",
      pulse: "",
      temperature: "",
      spo2: "",
      rbs_mg: "",
      rbs_nmol: "",
      weight: "",
      height: "",
      risk_of_fall: "",
      urgency: "",
      notes: "",
    });
  };
  const handleclickpen123 = (item) => {
    setOpenmodalforvital1(true);
    setFormData(item);
  };
  const handlecloseVitaledit = () => {
    setOpenmodalforvital(false);
    setFormData({
      blood_pressure_systolic: "",
      blood_pressure_diastolic: "",
      bp_position: [],
      respiratory_rate: "",
      pulse: "",
      temperature: "",
      spo2: "",
      rbs_mg: "",
      rbs_nmol: "",
      weight: "",
      height: "",
      risk_of_fall: "",
      urgency: "",
      notes: "",
    });
  };
  const [rxList, setRxList] = useState([]);
  useEffect(() => {
    usedfjh();
  }, []);
  const usedfjh = async () => {
    try {
      const response = await axiosInstance.get(`getAllRxList`);
      if (response.data.success) {
        setRxList(response.data.data);
      } else {
        console.error("API did not return success:", response.data.message);
      }
    } catch (error) {
      console.error("Error fetching Rx List:", error);
    }
  };
  const [selectedMedicines, setSelectedMedicines] = useState([]);
  const handdeditvital = async () => {
    const d = new Date(formData.recorded_at);
    const date = d.toISOString().split("T")[0]; // YYYY-MM-DD
    const time = d.toTimeString().split(" ")[0]; // HH:MM:SS
    const formattedRecordedAt = `${date} ${time}`; // final format
    const updatedData = {
      ...formData,
      recorded_at: formattedRecordedAt, // replace key
    };
    try {
      const respnse = await axiosInstance.put(
        `updatePatientVitals/${formData.id}`,
        updatedData
      );
      if (respnse.data.success === true) {
        getDataa();
        Swal.fire("Success", "Vitals updated successfully", "success");
        handlecloseVitaledit();
      } else {
        Swal.fire("Error", "Failed to update vitals", "error");
      }
    } catch (error) {
      console.error("Error updating vitals:", error);
      Swal.fire("Error", "Failed to update vitals", "error");
      return;
    }
  };
  const hhandlechangeaddnotes = (e) => {
    const { name, value } = e.target;
    setDataMedical((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Handler for Pain Assessment Slider
  const handlePainAssessmentChange = (event, newValue) => {
    setMedicalNotes((prev) => ({
      ...prev,
      pain_assessment: newValue,
    }));
  };
  // //////////////////////////////////////////////mediacal tab/////////////////////////////////////////////
  const [dataVitals, setDataVitals] = useState({});
  const [dataVitals123, setDataVitals123] = useState([]);
  const [radiology, setRadiology] = useState([]);
  useEffect(() => {
    getdatamedical();
  }, []);
  const getdatamedical = async () => {
    try {
      const response = await axiosInstance.get(
        `getPatientDiseaseDetails/${patientIdentifier}`
      );

      if (response?.data?.success === true) {
        const data = response.data.data;
        setDdsafjahfl(data?.diagnosis || []);
        setRadiology(data?.xray_reports || []);
        setDataAllergy(data?.allergies || []);
        setChronicillness1(data?.chronic_illness || []);
        setChronicillness12(data?.prescriptions || []);
        setDataMedical(data || {});
        setDataVitals123(data?.prescriptions || []);
      } else {
        console.warn(
          "API returned success:false or invalid response.",
          response?.data?.message || response
        );
      }
    } catch (error) {
      // 1️⃣ API responded with error (400/404/500)
      if (error.response) {
        console.error("API Error Status:", error.response.status);
        console.error(
          "API Error Message:",
          error.response.data?.message || "Unknown API error"
        );
        console.error("Full Error Response:", error.response.data);

        // 2️⃣ Request sent but server gave no response
      } else if (error.request) {
        console.error("No response received from server.");
        console.error("Request object:", error.request);

        // 3️⃣ Error while setting up the request (CORS, config, wrong URL)
      } else {
        console.error("Unexpected Error:", error.message);
      }

      // Optional fallback to prevent UI crash
      setDataMedical({});
      setDdsafjahfl([]);
      setDataVitals123([]);
    }
  };

  const [inputValue1, setInputValue1] = useState("");
  const [inputValueCode, setInputValueCode] = useState(""); // For ICD Code search
  const [suggestions1, setSuggestions1] = useState([]);
  const [services11, setServices11] = useState([]);

  const [inputValue2, setInputValue2] = useState("");
  const [suggestions2, setSuggestions2] = useState([]);
  const [services12, setServices12] = useState([]);

  const [inputValue3, setInputValue3] = useState("");
  const [suggestions3, setSuggestions3] = useState([]);
  const [services13, setServices13] = useState([]);

  const [inputValue4, setInputValue4] = useState("");
  const [suggestions4, setSuggestions4] = useState([]);
  const [services14, setServices14] = useState([]);

  const [inputValue5, setInputValue5] = useState("");
  const [suggestions5, setSuggestions5] = useState([]);
  const [services15, setServices15] = useState([]);

  const [inputValue6, setInputValue6] = useState("");
  const [suggestions6, setSuggestions6] = useState([]);
  const [services16, setServices16] = useState([]);

  const [inputValue7, setInputValue7] = useState("");
  const [suggestions7, setSuggestions7] = useState([]);
  const [services17, setServices17] = useState([]);

  const [inputValue8, setInputValue8] = useState("");
  const [suggestions8, setSuggestions8] = useState([]);
  const [services18, setServices18] = useState([]);

  const [inputValue9, setInputValue9] = useState("");
  const [suggestions9, setSuggestions9] = useState([]);
  const [services19, setServices19] = useState([]);

  const [inputValue10, setInputValue10] = useState("");
  const [suggestions10, setSuggestions10] = useState([]);
  const [services10, setServices10] = useState([]);

  const [inputValue111, setInputValue111] = useState("");
  const [suggestions111, setSuggestions111] = useState([]);
  const [services111, setServices111] = useState([]);

  const [inputValue, setInputValue] = useState(""); // Chief Complaint
  const [suggestions, setSuggestions] = useState([]);
  const [services1, setServices1] = useState([]);

  // --- Handlers for Text Area (with inline suggestion search on last line) ---
  const handleChange11111 = (e) => { const val = e.target.value; setInputValue1(val); const last = val.split("\n").pop().trim(); if (last) getdataapi1(last); else setSuggestions1([]); };
  const handleChange1111 = (e) => { const val = e.target.value; setInputValue(val); const last = val.split("\n").pop().trim(); if (last) getdataapi(last); else setSuggestions([]); };
  const handleChange1112 = (e) => { const val = e.target.value; setInputValue2(val); const last = val.split("\n").pop().trim(); if (last) getdataapi2(last); else setSuggestions2([]); };
  const handleChange1113 = (e) => { const val = e.target.value; setInputValue3(val); const last = val.split("\n").pop().trim(); if (last) getdataapi3(last); else setSuggestions3([]); };
  const handleChange1114 = (e) => { const val = e.target.value; setInputValue4(val); const last = val.split("\n").pop().trim(); if (last) getdataapi4(last); else setSuggestions4([]); };
  const handleChange1115 = (e) => { const val = e.target.value; setInputValue5(val); const last = val.split("\n").pop().trim(); if (last) getdataapi5(last); else setSuggestions5([]); };
  const handleChange1116 = (e) => { const val = e.target.value; setInputValue6(val); const last = val.split("\n").pop().trim(); if (last) getdataapi6(last); else setSuggestions6([]); };
  const handleChange1117 = (e) => { const val = e.target.value; setInputValue7(val); const last = val.split("\n").pop().trim(); if (last) getdataapi7(last); else setSuggestions7([]); };
  const handleChange1118 = (e) => { const val = e.target.value; setInputValue8(val); const last = val.split("\n").pop().trim(); if (last) getdataapi8(last); else setSuggestions8([]); };
  const handleChange1119 = (e) => setInputValue9(e.target.value);
  const handleChange111910 = (e) => { const val = e.target.value; setInputValue10(val); const last = val.split("\n").pop().trim(); if (last) getdataapi10(last); else setSuggestions10([]); };
  const handleChange1119111 = (e) => { const val = e.target.value; setInputValue111(val); const last = val.split("\n").pop().trim(); if (last) getdataapi111(last); else setSuggestions111([]); };

  const getdataapi = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=chief_complaints&search=${value}`
      );
      if (response.data.success === true) {
        setServices1(response.data.data || []);
        setSuggestions(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapichnagepanaassesemnt = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=chief_complaints&search=${value}`
      );
      if (response.data.success === true) {
        setServices1(response.data.data || []);
        setSuggestions(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi1 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=history_of_present_illness&search=${value}`
      );
      if (response.data.success === true) {
        setServices11(response.data.data || []);
        setSuggestions1(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi2 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=history_of_past_illness&search=${value}`
      );
      if (response.data.success === true) {
        setServices12(response.data.data || []);
        setSuggestions2(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi3 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=examination_general&search=${value}`
      );
      if (response.data.success === true) {
        setServices13(response.data.data || []);
        setSuggestions3(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi4 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=examination_systemic&search=${value}`
      );
      if (response.data.success === true) {
        setServices14(response.data.data || []);
        setSuggestions4(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi5 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=examination_local&search=${value}`
      );
      if (response.data.success === true) {
        setServices15(response.data.data || []);
        setSuggestions5(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi6 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=treatment_plan&search=${value}`
      );
      if (response.data.success === true) {
        setServices16(response.data.data || []);
        setSuggestions6(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi7 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=advises&search=${value}`
      );
      if (response.data.success === true) {
        setServices17(response.data.data || []);
        setSuggestions7(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi8 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=extra_notes&search=${value}`
      );
      if (response.data.success === true) {
        setServices18(response.data.data || []);
        setSuggestions8(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi9 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=extra_notes&search=${value}`
      );
      if (response.data.success === true) {
        setServices19(response.data.data || []);
        setSuggestions9(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi10 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=family_history&search=${value}`
      );
      if (response.data.success === true) {
        setServices10(response.data.data || []);
        setSuggestions10(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  const getdataapi111 = async (value) => {
    try {
      const response = await axiosInstance.post(
        `searchMedicalField?table=psychosocial&search=${value}`
      );
      if (response.data.success === true) {
        setServices111(response.data.data || []);
        setSuggestions111(response.data.data || []);
      } else {
        console.warn("Something went wrong");
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };

  const replaceLastLine = (prev, value) => {
    const lines = (prev || "").split("\n");
    lines[lines.length - 1] = value;
    return lines.join("\n");
  };
  const handleSuggestionClick = (value) => { setInputValue((prev) => replaceLastLine(prev, value)); setSuggestions([]); };
  const handleSuggestionClick1 = (value) => { setInputValue1((prev) => replaceLastLine(prev, value)); setSuggestions1([]); };
  const handleSuggestionClick2 = (value) => { setInputValue2((prev) => replaceLastLine(prev, value)); setSuggestions2([]); };
  const handleSuggestionClick3 = (value) => { setInputValue3((prev) => replaceLastLine(prev, value)); setSuggestions3([]); };
  const handleSuggestionClick4 = (value) => { setInputValue4((prev) => replaceLastLine(prev, value)); setSuggestions4([]); };
  const handleSuggestionClick5 = (value) => { setInputValue5((prev) => replaceLastLine(prev, value)); setSuggestions5([]); };
  const handleSuggestionClick6 = (value) => { setInputValue6((prev) => replaceLastLine(prev, value)); setSuggestions6([]); };
  const handleSuggestionClick7 = (value) => { setInputValue7((prev) => replaceLastLine(prev, value)); setSuggestions7([]); };
  const handleSuggestionClick8 = (value) => { setInputValue8((prev) => replaceLastLine(prev, value)); setSuggestions8([]); };
  const handleSuggestionClick9 = (value) => { setInputValue9((prev) => replaceLastLine(prev, value)); setSuggestions9([]); };
  const handleSuggestionClick10 = (value) => { setInputValue10((prev) => replaceLastLine(prev, value)); setSuggestions10([]); };
  const handleSuggestionClick111 = (value) => { setInputValue111((prev) => replaceLastLine(prev, value)); setSuggestions111([]); };
  const apihitmedical = async () => {
    if (!inputValue.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Please enter Chief Complaint.",
      });
      return;
    }
    if (!inputValue1.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Please enter History of Present Illness.",
      });
      return;
    }
    if (!inputValue5.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Missing Field",
        text: "Please enter Local Examination.",
      });
      return;
    }
    const obj = {
      chief_complaint: inputValue,
      history_of_present_illness: inputValue1,
      history_of_past_illness: inputValue2,
      examination_general: inputValue3,
      examination_systemic: inputValue4,
      examination_local: inputValue5,
      treatment_plan: inputValue6,
      advises: inputValue7,
      extra_notes: inputValue8,
      pain_assessment: medicalNotes.pain_assessment || null,
      family_history: inputValue10,
      psychosocial: inputValue111,
      // Bind the note to the visit selected in Medical History, so it belongs to that
      // appointment's doctor no matter who is typing it (admin, nurse, covering doctor).
      appointment_id: appointmentqq || null,
      visit_date: dateqq || null,
    };
    try {
      Swal.showLoading();
      const response = await axiosInstance.post(
        `addPatientMedicals/${location.state.patientid.id}`,
        obj
      );
      if (response.data.success === true) {
        getDataa1();
        getdatamedical();
        filterdate1();
        // Reload the visit the note was written for so it shows up straight away.
        handledategetsaddt(dateqq, doctorqq, appointmentqq);
        handlecloseMedical();
        setInputValue("");
        setInputValue1("");
        setInputValue2("");
        setInputValue3("");
        setInputValue4("");
        setInputValue5("");
        setInputValue6("");
        setInputValue7("");
        setInputValue8("");
        setInputValue10("");
        setInputValue111("");
        setMedicalNotes({}); // Reset to empty object
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Medical data saved successfully!",
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Submission Failed",
          text: "Something went wrong while saving medical details.",
        });
      }
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "An error occurred.",
      });
    }
  };
  // ///////////////////////////////chronic illness api////////////////////////////////////////
  const [chronic, setChronic] = useState({});
  const [illnessSuggestions, setIllnessSuggestions] = useState([]);
  const handlechnageillbness = async (e) => {
    const { name, value } = e.target;
    setChronic({ ...chronic, [name]: value });
    if (name === "illness_text" && value.trim()) {
      try {
        const res = await axiosInstance.post(`searchMedicalField?table=illness&search=${value}`);
        if (res.data.success) setIllnessSuggestions(res.data.data || []);
      } catch (_) { setIllnessSuggestions([]); }
    } else {
      setIllnessSuggestions([]);
    }
  };
  const handleIllnessSuggestionClick = (text) => {
    setChronic(prev => ({ ...prev, illness_text: text }));
    setIllnessSuggestions([]);
  };
  const Addchronicillness = async () => {
    const obj = {
      patient_id: patientIdentifier,
      illness_text: chronic.illness_text,
    };
    try {
      const response = await axiosInstance.post(`addChronicIllness`, obj);
      if (
        response.data?.success === true ||
        response.data?.success === "true" ||
        response.data?.success === 1
      ) {
        // Save to illness suggestion list for future use
        if (chronic.illness_text?.trim()) {
          axiosInstance.post(`createAllTableText?table=illness`, { text: chronic.illness_text.trim() }).catch(() => {});
        }
        setIllnessSuggestions([]);
        getdatamedical();
        getDataa1();
        closeChronicillness();
        Swal.fire("Success", "Chronic illness added successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      console.error("API Error:", error);
      if (error.response?.data) {
        const errData = error.response.data;
        if (Array.isArray(errData?.errors)) {
          const formattedErrors = errData.errors
            .map((err) => `• ${err.msg || err}`)
            .join("<br/>");
          Swal.fire({
            icon: "error",
            title: "Validation Errors",
            html: formattedErrors,
          });
          return;
        }
        if (typeof errData?.message === "string") {
          Swal.fire("Error", errData.message, "error");
          return;
        }
        if (typeof errData === "object") {
          const formatted = Object.entries(errData)
            .map(([key, val]) => `• ${key}: ${val}`)
            .join("<br/>");
          Swal.fire({ icon: "error", title: "Errors", html: formatted });
          return;
        }
      }
      Swal.fire("Error", "Network error or server not responding", "error");
    }
  };
  const [xrayRadio, setXrayRadio] = useState(false);
  const [allergy, setAllergy] = useState(false);
  const [chronicillness, setChronicillness] = useState(false);
  const openChronicillness = () => {
    setChronic({});
    setIllnessSuggestions([]);
    setChronicillness(true);
  };
  const closeChronicillness = () => {
    setChronic({});
    setIllnessSuggestions([]);
    setChronicillness(false);
  };
  const openAllergy = () => {
    setAllergy(true);
  };
  const closeAllergy = () => {
    setAllergy(false);
  };
  const openxray = () => {
    setXrayRadio(true);
  };
  const closexray = () => {
    setXrayRadio(false);
  };
  const filteredLabs = labData.filter((item) => {
    const term = (labSearch || "").toLowerCase().trim();
    if (!term) return true;
    const values = [
      item?.patient_name,
      item?.lab_name,
      item?.title,
      item?.description,
      item?.doctor_name,
      item?.patient_mobile,
      item?.mobile,
    ];
    return values.some((v) =>
      String(v || "")
        .toLowerCase()
        .includes(term)
    );
  });
  const filteredPatients = dataAppointment.filter(
    (item) =>
      `${item.doctorName}`.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.patientName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.reason?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.duration?.toString().includes(searchTerm) ||
      item.mobileNumber?.toString().includes(searchTerm) ||
      (item.appointmentDate &&
        new Date(item?.appointmentDate)
          .toLocaleDateString("en-GB")
          .includes(searchTerm))
  ).sort((a, b) => new Date(b.appointmentDate) - new Date(a.appointmentDate));
  const totalPages = Math.ceil(filteredPatients.length / itemsPerPage);
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentPatients = filteredPatients.slice(indexOfFirst, indexOfLast);

  useEffect(() => {
    const todayStart = new Date();
    todayStart.setHours(0, 0, 0, 0);
    const riskEligibleIds = currentPatients
      .filter(
        (item) =>
          (item.status === "Booked" || item.status === "Confirmed") &&
          item.appointmentDate &&
          new Date(item.appointmentDate).setHours(0, 0, 0, 0) >= todayStart.getTime()
      )
      .map((item) => item.id)
      .filter((id) => noShowRiskById[id] === undefined);

    if (riskEligibleIds.length === 0) return;

    axiosInstance
      .post(`getAppointmentNoShowRisk`, { appointmentIds: riskEligibleIds })
      .then((response) => {
        if (response.data.success) {
          setNoShowRiskById((prev) => ({ ...prev, ...response.data.data }));
        }
      })
      .catch((error) => console.error("Error fetching no-show risk:", error));
    // eslint-disable-next-line
  }, [currentPatients.map((item) => item.id).join(",")]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  // ///////////////////////////////medical tab/////////////////////////////////
  const [dateqq, setDateqq] = useState("");
  // Which visit is selected. A date alone does not identify a visit: the same patient can
  // be seen twice on one day by two different doctors, so the appointment identifies it.
  const [doctorqq, setDoctorqq] = useState(null);
  const [appointmentqq, setAppointmentqq] = useState(null);
  // The visit buttons: one per appointment, plus one for any note whose date no
  // appointment covers (written outside an appointment, or legacy data). Without those
  // extras such a note has no button to reach it and would look lost.
  const visitChips = useMemo(() => {
    const dayOf = (value) => moment(value, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD");
    const chips = [...dateSelectData];
    const coveredDays = new Set(chips.map((item) => dayOf(item?.appointmentDate)));
    (datta || []).forEach((record) => {
      if (!record?.created_at) return;
      const day = moment(record.created_at).format("YYYY-MM-DD");
      if (coveredDays.has(day)) return;
      const alreadyAdded = chips.some(
        (item) => item?.noteOnly && dayOf(item.appointmentDate) === day
          && String(item.doctor_id ?? '') === String(record.sent_by ?? '')
      );
      if (alreadyAdded) return;
      chips.push({
        appointmentDate: `${day}T00:00:00`,
        doctor_name: record.author_name || null,
        doctor_id: record.sent_by ?? null,
        appointment_id: null,
        startTime: null,
        noteOnly: true,
      });
    });
    return chips;
  }, [dateSelectData, datta]);
  // The selected visit, used to label the Medical Notes modal and to bind the saved note.
  const selectedVisit = useMemo(
    () => visitChips.find((item) => item?.appointment_id != null && item.appointment_id === appointmentqq) || null,
    [visitChips, appointmentqq]
  );
  useEffect(() => {
    const today = moment().format("YYYY-MM-DD");
    const todaysVisits = dateSelectData.filter(
      (item) => moment(item?.appointmentDate, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD") === today
    );
    if (todaysVisits.length > 0) {
      // Prefer the logged-in doctor's own visit when several doctors saw the patient today
      const ownVisit = todaysVisits.find(
        (item) => item?.doctor_id != null && String(item.doctor_id) === String(loggedInUser?.doctorId ?? loggedInUser?.id)
      );
      const visit = ownVisit || todaysVisits[0];
      handledategetsaddt(today, visit?.doctor_id ?? null, visit?.appointment_id ?? null)
    } else {
      handledategetsaddt(null)
    }
  }, [dateSelectData, datta]);


  // Discount calculation for edit modal - similar to add modal
  useEffect(() => {
    if (!showEditLabModal) return;

    const selectedService = editLabData.serviceId
      ? labServices.find((s) => String(s.id) === String(editLabData.serviceId))
      : null;

    const total = selectedService ? (parseFloat(selectedService.price) || 0) : (editLabData.total_price || 0);

    const maxAllowedDiscountAmount = (total * globalDiscountLimit) / 100;

    let discountAmt = 0;
    if (editLabData.discount_type === "Percentage") {
      discountAmt = (total * (parseFloat(editLabData.discount_value) || 0)) / 100;
    } else {
      discountAmt = parseFloat(editLabData.discount_value) || 0;
    }

    // Ensure discount never exceeds the global discount limit or the total
    discountAmt = Math.min(discountAmt, maxAllowedDiscountAmount, total);
    const net = total - discountAmt;

    setEditTestTotalPrice(total);
    setEditTestDiscountAmount(discountAmt);
    setEditTestNetAmount(net);

    setEditLabData((prev) => ({
      ...prev,
      total_price: total,
      discount_amount: discountAmt,
      net_amount: net,
    }));
  }, [editLabData.serviceId, editLabData.discount_type, editLabData.discount_value, labServices, showEditLabModal, globalDiscountLimit]);




  // Add these handler functions near other discount handlers
  const handleEditDiscountTypeChange = (e) => {
    setEditLabData(prev => ({
      ...prev,
      discount_type: e.target.value,
      discount_value: 0,
      discount_amount: 0,
      net_amount: prev.total_price || 0,
    }));
    setEditTestDiscountAmount(0);
    setEditTestNetAmount(editTestTotalPrice);
  };

  const handleEditDiscountValueChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    const totalPrice = editTestTotalPrice || 0;

    if (editLabData.discount_type === "Percentage") {
      if (value > globalDiscountLimit) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Percentage discount cannot exceed ${globalDiscountLimit}%`,
        });
        return;
      }
    } else if (editLabData.discount_type === "Amount") {
      const maxAllowedAmount = (totalPrice * globalDiscountLimit) / 100;
      if (value > maxAllowedAmount) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Amount discount cannot exceed ${globalDiscountLimit}% of total price (max ${maxAllowedAmount.toFixed(3)} BHD)`,
        });
        return;
      }
    }

    setEditLabData((prev) => ({
      ...prev,
      discount_value: value,
    }));
  };


  const handledategetsaddt = (selectedDate, selectedDoctorId = null, selectedAppointmentId = null) => {
    setDateqq(selectedDate);
    setDoctorqq(selectedDate ? (selectedDoctorId ?? null) : null);
    setAppointmentqq(selectedDate ? (selectedAppointmentId ?? null) : null);
    getMedicalData(
      selectedDate,
      selectedDate ? selectedDoctorId : null,
      selectedDate ? selectedAppointmentId : null
    );
    loadPatientServices(selectedDate);
  };
  const getMedicalData = async (selectedDate, selectedDoctorId = null, selectedAppointmentId = null) => {
    try {
      const response = await axiosInstance.post(
        `getMedicalRecordsByDate/${location.state.patientid.id}`,
        {
          date: selectedDate,
          doctor_id: selectedDoctorId || null,
          appointment_id: selectedAppointmentId || null,
        }
      );
      if (response.status === 200) {
        const data = response.data.data;
        setDdsafjahfl(data.diagnosis);
        setRadiology(data.xRay_and_radiology);
        setDataAllergy(data.allergies);
        setChronicillness1(data.chronic_illnesses);
        setChronicillness12(data.prescriptions);
        setDataMedical(data);
        setDataVitals(data.vitals);
      } else {
        console.warn("Something went wrong");
        setDdsafjahfl([]);
        setDataMedical({});
        setDataVitals([]);
      }
    } catch (error) {
      console.error("Error fetching medical records:", error);
      setDdsafjahfl([]);
      setDataMedical({});
      setDataVitals([]);
    }
  };
  const isMedicalNotesLocked = (() => {
    if (!dataMedical) return false;
    const timeLocked = recordLockHours && dataMedical?.created_at
      ? (Date.now() - new Date(dataMedical.created_at).getTime()) > recordLockHours * 60 * 60 * 1000
      : false;
    const notOwner = loggedInUser?.id != null && dataMedical?.sent_by != null
      ? String(loggedInUser.id) !== String(dataMedical.sent_by)
      : false;
    return timeLocked || notOwner;
  })();

  const [isEditing, setIsEditing] = useState(false);
  const [history, setHistory] = useState(
    dataMedical?.history_of_present_illness || ""
  );
  const handleEdit = () => {
    setIsEditing(true);
    setHistory(dataMedical?.history_of_present_illness || "");
  };
  const handleCancel = () => {
    setHistory(dataMedical?.history_of_present_illness || "");
    setIsEditing(false);
  };
  const handleSave = () => {
    setIsEditing(false);
  };
  const [isEditingChief, setIsEditingChief] = useState(false);
  const [chiefComplaint, setChiefComplaint] = useState(
    dataMedical?.chief_complaint || ""
  );
  const handleChiefEdit = () => {
    setIsEditingChief(true);
    setChiefComplaint(dataMedical?.chief_complaint || "");
  };
  const handleChiefCancel = () => {
    setChiefComplaint(dataMedical?.chief_complaint || "");
    setIsEditingChief(false);
  };
  const handleChiefSave = () => {
    setIsEditingChief(false);
  };
  const [isEditingPast, setIsEditingPast] = useState(false);
  const [pastIllness, setPastIllness] = useState(
    dataMedical?.history_of_past_illness || ""
  );
  const handlePastEdit = () => {
    setIsEditingPast(true);
    setPastIllness(dataMedical?.history_of_past_illness || "");
  };
  const handlePastCancel = () => {
    setPastIllness(dataMedical?.history_of_past_illness || "");
    setIsEditingPast(false);
  };
  const handlePastSave = () => {
    setIsEditingPast(false);
  };
  const [isEditingExam, setIsEditingExam] = useState(false);
  const [examGeneral, setExamGeneral] = useState(
    dataMedical?.examination_general || ""
  );
  const handleExamEdit = () => {
    setIsEditingExam(true);
    setExamGeneral(dataMedical?.examination_general || "");
  };
  const handleExamCancel = () => {
    setExamGeneral(dataMedical?.examination_general || "");
    setIsEditingExam(false);
  };
  const handleExamSave = () => {
    setIsEditingExam(false);
  };
  const [isEditing1, setIsEditing1] = useState(false);
  const [systemicValue1, setSystemicValue1] = useState(
    dataMedical?.examination_systemic || ""
  );

  const handleEdit1 = () => {
    setIsEditing1(true); // edit mode chalu
    setSystemicValue1(dataMedical?.examination_systemic || "");
  };

  const handleSave1 = () => {
    setIsEditing1(false);
  };

  const handleCancel1 = () => {
    setSystemicValue1(dataMedical?.examination_systemic || "");
    setIsEditing1(false); // cancel
  };
  const [examinationLocal, setExaminationLocal] = useState(
    dataMedical?.examination_local || ""
  );
  const [isEditingLocal, setIsEditingLocal] = useState(false);

  const handleEditLocal = () => {
    setIsEditingLocal(true);
    setExaminationLocal(dataMedical?.examination_local || "");
  };
  const handleEditLocalclose = () => {
    setIsEditingLocal(false);
  };

  const handleSaveLocal = () => {
    setIsEditingLocal(false);
  };
  const handleDeleteLocal = () => {
    setExaminationLocal("");
  };
  const [examinationLocal1, setExaminationLocal1] = useState(
    dataMedical?.family_history || ""
  );
  const [isEditingLocal1, setIsEditingLocal1] = useState(false);

  const handleEditLocal1 = () => {
    setIsEditingLocal1(true);
    setExaminationLocal1(dataMedical?.family_history || "");
  };
  const handleEditLocalclose1 = () => {
    setIsEditingLocal1(false);
  };

  const handleSaveLocal1 = () => {
    setIsEditingLocal1(false);
  };
  const handleDeleteLocal1 = () => {
    setExaminationLocal("");
  };
  const [examinationLocal12, setExaminationLocal12] = useState(
    dataMedical?.psychosocial || ""
  );
  const [isEditingLocal12, setIsEditingLocal12] = useState(false);

  const handleEditLocal12 = () => {
    setIsEditingLocal12(true);
    setExaminationLocal12(dataMedical?.psychosocial || "");
  };
  const handleEditLocalclose12 = () => {
    setIsEditingLocal12(false);
  };

  const handleSaveLocal12 = () => {
    setIsEditingLocal12(false);
  };
  const handleDeleteLocal12 = () => {
    setExaminationLocal12("");
  };
  const [isEditingTreatment, setIsEditingTreatment] = useState(false);
  const [treatmentInput, setTreatmentInput] = useState("");
  const handleSaveTreatment = () => {
    setIsEditingTreatment(false);
  };

  const [editAdvise, setEditAdvise] = useState(null);


  const handleSaveAdvise = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "advises",
      value: editAdvise,
    };

    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );

      if (response.data.success === true) {
        setEditAdvise(null);
        filterdate1();
        getdatamedical();
        getDataa1();
        Swal.fire("Success", "Advise updated successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update advise", "error");
    }
  };
  const handleSavehistory_of_present_illness = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "history_of_present_illness",
      value: history,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleCancel();
        getDataa1();
        filterdate1();
        getdatamedical();
        Swal.fire(
          "Success",
          "History of Present Illness Updated Successfully",
          "success"
        );
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        "Failed to update History of Present Illness",
        "error"
      );
    }
  };
  const handleSavechief_complaint = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "chief_complaint",
      value: chiefComplaint,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleChiefCancel();
        getDataa1();
        filterdate1();
        getdatamedical();
        Swal.fire("Success", "Chief Complaint Updated Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update Chief Complaint", "error");
    }
  };
  const handlehistoryofpastillness = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "history_of_past_illness",
      value: pastIllness,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handlePastCancel();
        getDataa1();
        filterdate1();
        getdatamedical();
        Swal.fire(
          "Success",
          "History of Past Illness Updated Successfully",
          "success"
        );
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update History of Past Illness", "error");
    }
  };
  const handleexaminationgeneral = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "examination_general",
      value: examGeneral,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleExamCancel();
        getdatamedical();
        filterdate1();
        getDataa1();
        Swal.fire(
          "Success",
          "Examination General Updated Successfully",
          "success"
        );
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update advise", "error");
    }
  };
  const handleexaminationsymatic = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "examination_systemic",
      value: systemicValue1,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleCancel1();
        getDataa1();
        filterdate1();
        getdatamedical();
        Swal.fire(
          "Success",
          "Examination Systemic  Updated Successfully",
          "success"
        );
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire(
        "Error",
        "Failed to update Examination Examination Systemic ",
        "error"
      );
    }
  };
  const setIsEditingTreatmentahdsgf = () => {
    handleEditLocalclose();
  };
  const handleexaminationlocal1 = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "family_history",
      value: examinationLocal1,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleEditLocalclose1();
        getdatamedical();
        getDataa1();
        filterdate1();
        getdataapi();
        Swal.fire("Success", "Family History Updated Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update Family History", "error");
    }
  };
  const handleexaminationlocal12 = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "psychosocial",
      value: examinationLocal12,
    };

    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleEditLocalclose12();
        getdatamedical();
        filterdate1();
        getDataa1();
        Swal.fire("Success", "Psychosocial Updated Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update Psychosocial", "error");
    }
  };
  const handleexaminationlocal = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "examination_local",
      value: examinationLocal,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleEditLocalclose();
        getdatamedical();
        filterdate1();
        getDataa1();
        Swal.fire(
          "Success",
          "Examination Local Updated Successfully",
          "success"
        );
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update Examination Local", "error");
    }
  };
  const handleextranotes = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "extra_notes",
      value: note3,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        setIsEditing3(false);
        getdatamedical();
        getDataa1();
        filterdate1();
        Swal.fire("Success", "Extra Notes Updated Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update Extra Notes", "error");
    }
  };
  const handletraeatmentplan = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "treatment_plan",
      value: treatmentInput,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        setIsEditingTreatment(false);
        filterdate1();
        getdatamedical();
        getDataa1();
        Swal.fire("Success", " Treatment  Updated Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update Treatment", "error");
    }
  };
  const [isEditing3, setIsEditing3] = useState(false);
  const [note3, setNote3] = useState(dataMedical?.extra_notes || "");
  const [loading3, setLoading3] = useState(false);

  // ── Combined Visit Notes (Diagnosis ... Extra Notes) single edit flow ──
  const [isEditVisitNotesOpen, setIsEditVisitNotesOpen] = useState(false);
  const [savingAllVisitNotes, setSavingAllVisitNotes] = useState(false);
  const visitNotesFields = [
    {
      field: "chief_complaint",
      label: "Chief Complaint",
      icon: "ti ti-message-2",
      value: chiefComplaint,
      setValue: setChiefComplaint,
    },
    {
      field: "history_of_present_illness",
      label: "History of Present Illness",
      icon: "ti ti-notes",
      value: history,
      setValue: setHistory,
    },
    {
      field: "history_of_past_illness",
      label: "History of Past Illness",
      icon: "ti ti-clock",
      value: pastIllness,
      setValue: setPastIllness,
    },
    {
      field: "examination_general",
      label: "Examination [General]",
      icon: "ti ti-user-check",
      value: examGeneral,
      setValue: setExamGeneral,
    },
    {
      field: "examination_systemic",
      label: "Examination [Systemic]",
      icon: "ti ti-heart",
      value: systemicValue1,
      setValue: setSystemicValue1,
    },
    {
      field: "examination_local",
      label: "Examination [Local]",
      icon: "ti ti-zoom-check",
      value: examinationLocal,
      setValue: setExaminationLocal,
    },
    {
      field: "family_history",
      label: "Family History",
      icon: "ti ti-users",
      value: examinationLocal1,
      setValue: setExaminationLocal1,
    },
    {
      field: "psychosocial",
      label: "Psychosocial",
      icon: "ti ti-brain",
      value: examinationLocal12,
      setValue: setExaminationLocal12,
    },
    {
      field: "treatment_plan",
      label: "Treatment Plan",
      icon: "ti ti-pill",
      value: treatmentInput,
      setValue: setTreatmentInput,
    },
    {
      field: "advises",
      label: "Advises",
      icon: "ti ti-bulb",
      value: editAdvise || "",
      setValue: setEditAdvise,
    },
    {
      field: "extra_notes",
      label: "Extra Notes",
      icon: "ti ti-pencil",
      value: note3,
      setValue: setNote3,
    },
  ];
  const openEditAllVisitNotes = () => {
    setChiefComplaint(dataMedical?.chief_complaint || "");
    setHistory(dataMedical?.history_of_present_illness || "");
    setPastIllness(dataMedical?.history_of_past_illness || "");
    setExamGeneral(dataMedical?.examination_general || "");
    setSystemicValue1(dataMedical?.examination_systemic || "");
    setExaminationLocal(dataMedical?.examination_local || "");
    setExaminationLocal1(dataMedical?.family_history || "");
    setExaminationLocal12(dataMedical?.psychosocial || "");
    setTreatmentInput(dataMedical?.treatment_plan || "");
    setEditAdvise(dataMedical?.advises || "");
    setNote3(dataMedical?.extra_notes || "");
    setIsEditVisitNotesOpen(true);
  };
  const handleSaveAllVisitNotes = async () => {
    setSavingAllVisitNotes(true);
    try {
      await Promise.all(
        visitNotesFields.map((f) =>
          axiosInstance.post(`updateSingleMedicalField`, {
            id: dataMedical?.id,
            field: f.field,
            value: f.value,
          })
        )
      );
      setIsEditVisitNotesOpen(false);
      getdatamedical();
      filterdate1();
      getDataa1();
      Swal.fire("Success", "Visit Notes Updated Successfully", "success");
    } catch (error) {
      Swal.fire("Error", "Failed to update Visit Notes", "error");
    } finally {
      setSavingAllVisitNotes(false);
    }
  };
  const handleSave3 = async () => {
    try {
      setLoading3(true);
      const response = await axiosInstance.put(`updateExtraNotes`, {
        id: dataMedical?.id,
        extra_notes: note3,
      });
      if (response.data.success) {
        alert("Note updated successfully!");
        setIsEditing3(false);
      } else {
        alert("Failed to update note");
      }
    } catch (err) {
      console.error(err);
      alert("Error while updating note");
    } finally {
      setLoading3(false);
    }
  };
  const onDelete = async () => {
    if (!window.confirm("Are you sure you want to delete this note?")) return;
    try {
      setLoading3(true);
      const response = await axiosInstance.delete(
        `deleteExtraNotes/${dataMedical?.id}`
      );
      if (response.data.success) {
        alert("Note deleted successfully!");
        setNote3("");
      } else {
        alert("Failed to delete note");
      }
    } catch (err) {
      console.error(err);
      alert("Error while deleting note");
    } finally {
      setLoading3(false);
    }
  };
  const [icdList, setIcdList] = useState([]);
  const [selectedIcd, setSelectedIcd] = useState([]);
  const [icdInputValue, setIcdInputValue] = useState("");
  const getdataicd = async (searchText) => {
    try {
      const response = await axiosInstance.get(
        `searchICD10?search=${searchText}`
      );
      if (response.data.success) {
        setIcdList(response.data.data);
      } else {
        setIcdList([]);
      }
    } catch (error) {
      console.error("Error fetching ICD data:", error.message);
      setIcdList([]);
    }
  };
  const [editIndex, setEditIndex] = useState(null);
  const [icdList1, setIcdList1] = useState([]);
  const [selectedIcd1, setSelectedIcd1] = useState(null);
  const [selectedCode, setSelectedCode] = useState(null);
  const getdataicd11 = async (searchText) => {
    try {
      const response = await axiosInstance.get(
        `searchICD10?search=${searchText}`
      );
      if (response.data.success) {
        setIcdList1(
          response.data.data.map((item) => ({
            value: item.short_name,
            label: item.short_name,
            code: item.code,
          }))
        );
      } else {
        setIcdList1([]);
      }
    } catch (error) {
      console.error("Error fetching ICD data:", error.message);
      setIcdList1([]);
    }
  };
  const handleNameChange = (val) => {
    setSelectedIcd1(val);
    if (val) {
      setSelectedCode({ value: val.code, label: val.code });
    } else {
      setSelectedCode(null);
    }
  };
  const [icdSuggestions, setIcdSuggestions] = useState([]);
  const [icdSuggestionsLoading, setIcdSuggestionsLoading] = useState(false);
  const fetchIcdSuggestions = async () => {
    // `chiefComplaint` is just the edit-buffer for the chief complaint field
    // (only populated once the user clicks "Edit" there) — prefer the
    // actual saved value on the loaded note, falling back to the buffer
    // for an in-progress edit that hasn't been saved yet.
    const text = (dataMedical?.chief_complaint || chiefComplaint || "").trim();
    if (text.length < 3) {
      Swal.fire("Chief Complaint required", "Enter at least 3 characters of chief complaint to get ICD-10 suggestions.", "info");
      return;
    }
    setIcdSuggestionsLoading(true);
    try {
      const response = await axiosInstance.post(`suggestICD10`, { text });
      setIcdSuggestions(response.data.success ? response.data.data : []);
    } catch (error) {
      console.error("Error fetching ICD10 suggestions:", error.message);
      setIcdSuggestions([]);
    } finally {
      setIcdSuggestionsLoading(false);
    }
  };
  const applyIcdSuggestion = (item) => {
    handleNameChange({ value: item.short_name, label: item.short_name, code: item.code });
  };
  const handleCodeChange = (val) => {
    setSelectedCode(val);
    if (val) {
      const matchedItem = icdList1.find((item) => item.code === val.value);
      if (matchedItem) {
        setSelectedIcd1({
          value: matchedItem.value,
          label: matchedItem.label,
          code: matchedItem.code,
        });
      }
    } else {
      setSelectedIcd1(null);
    }
  };
  const handleInputChange = (value) => {
    setIcdInputValue(value);
    if (value.length >= 3) {
      getdataicd(value);
    } else {
      setIcdList([]);
    }
  };
  const handleChangemui = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedIcd(typeof value === "string" ? value.split(",") : value);
  };
  const [medicineData, setMedicineData] = useState({
    rxId: null,
    medicine_name: "",
    dose: "",
    frequency: "",
    duration: "",
    notes: "",
    dosage: "",
    form: "",
    substance: "",
    productType: "",
    packet_size: "",
    route: "",
    strength: "",
    unit: "",
  });
  const [addedMedicines, setAddedMedicines] = useState([]);
  const handleEditLabChange123 = (selectedOption) => {
    if (!selectedOption) return;
    setMedicineData((prev) => ({
      ...prev,
      rxId: selectedOption.value,
    }));
    rxapihit(selectedOption.value);
  };
  const rxapihit = async (rxId) => {
    try {
      const response = await axiosInstance.get(`getRxById/${rxId}`);
      if (response.data.success) {
        const data = response.data.data;
        setMedicineData((prev) => ({
          ...prev,
          medicine_name: data.medicine_name || "",
          dose: data.dose || "",
          frequency: data.frequency || "",
          duration: data.duration || "",
          notes: data.notes || "",
          substance: data.activeSubstances || "",
          packet_size: data.packet_size || "",
          form: data.form || "",
          product_type: data.productType || "",
          route: data.route || "",
          strength: data.strength || "",
          unit: data.unit || "",
        }));
      }
    } catch (error) {
      console.error(error.response?.data || error.message);
    }
  };
  // ///////////////////////////////////////////////////////////pan assesment
  const handleChiefEditopnelmodal = () => {
    setPainAssesmentModal(true);
  };
  const handleClosepanassesemnt = () => {
    getdatamedical();
    getDataa1();
    setPainAssesmentModal(false);
  };
  const handleMedicineChange = (e) => {
    const { name, value } = e.target;
    setMedicineData((prev) => ({ ...prev, [name]: value }));
  };
  const handleAddMedicine = async () => {
    if (!medicineData.medicine_name) {
      Swal.fire("Warning", "Please Select a medicine", "Warning");
      return;
    }

    let proceed = true;

    try {
      if (medicineData.rxId) {
        const response = await axiosInstance.post(
          `prescriptionAllergyCheckSingle`,
          {
            patient_id: patientIdentifier,
            prescriptionId: medicineData.rxId,
          }
        );
        if (response.data.success && response.data.allergy_found === 1) {
          const result = await Swal.fire({
            icon: "warning",
            title: "Warning",
            text:
              response.data.message ||
              "Allergy conflict detected. Do you want to continue?",
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          });

          if (!result.isConfirmed) {
            proceed = false;
          }
        }
      }
    } catch (error) {
      console.error("Allergy check error:", error);
    }



    if (!proceed) return;

    if (editIndex !== null) {
      const updatedList = [...addedMedicines];
      updatedList[editIndex] = { ...medicineData };
      setAddedMedicines(updatedList);
      setEditIndex(null);
    } else {
      setAddedMedicines((prev) => [...prev, { ...medicineData }]);
    }
    setMedicineData({
      rxId: null,
      medicine_name: "",
      dose: "",
      frequency: "",
      duration: "",
      notes: "",
      dosage: "",
      form: "",
      substance: "",
      product_type: "",
      packet_size: "",
      route: "",
      strength: "",
      unit: "",
    });
  };
  const handleEditMedicine = (index) => {
    setMedicineData(addedMedicines[index]);
    setEditIndex(index);
  };
  const handleDeleteMedicine = (index) => {
    setAddedMedicines((prev) => prev.filter((_, i) => i !== index));
  };


  const handlesubmitprescription = async () => {
    // Validation
    if (!addedMedicines || addedMedicines.length === 0) {
      Swal.fire("Warning", "Please add at least one medicine", "warning");
      return;
    }

    try {
      let response;

      if (isEditMode) {
        // ✅ EDIT MODE - Update existing group
        const payload = {
          patient_id: location?.state?.patientid?.id,
          medicines: addedMedicines.map(med => ({
            medicine_name: med.medicine_name,
            strength: med.strength || null,
            frequency: med.frequency || null,
            dose: med.dose || null,
            dosage: med.dosage || null,
            product_type: med.product_type || null,
            duration: med.duration || null,
            route: med.route || null,
            substance: med.substance || null,
            packet_size: med.packet_size || null,
            notes: med.notes || null,
          })),
        };

        response = await axiosInstance.put(
          `updatePrescriptionGroup/${editingGroupId}`,
          payload
        );

      } else {
        // ✅ ADD MODE - Create new group
        const payload = {
          doctor_id: userddertails?.data?.id,
          patient_id: location?.state?.patientid?.id,
          prescriptions: addedMedicines,
          branch_id: parseInt(localStorage.getItem('activeBranchId')) || (allBranchSettings.length === 1 ? allBranchSettings[0]?.id : null),
        };

        response = await axiosInstance.post(`addPrescription`, payload);
      }

      if (response.data.success) {
        setPrescriptionModalOpen(false);
        setIsEditMode(false);           // Reset
        setEditingGroupId(null);        // Reset
        setAddedMedicines([]);          // Clear form

        // Reset medicine data
        setMedicineData({
          rxId: null,
          medicine_name: "",
          dose: "",
          frequency: "",
          duration: "",
          notes: "",
          dosage: "",
          form: "",
          substance: "",
          productType: "",
          packet_size: "",
          route: "",
          strength: "",
          unit: "",
        });

        getdatamedical();
        getDataa1();

        Swal.fire(
          "Success",
          isEditMode ? "Prescription updated successfully" : "Prescription added successfully",
          "success"
        );
      } else {
        Swal.fire("Error", response.data.message || "Operation failed", "error");
      }
    } catch (error) {
      console.error("Prescription error:", error);
      Swal.fire(
        "Error",
        error?.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  const openEditIllndelet = async (plan) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this Chronic illness!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const response = await axiosInstance.delete(
          `deleteChronicIllness/${plan.illness_id ? plan.illness_id : plan.id}`
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Chronic illness has been Deleted.", "success");
          getdatamedical();
          getDataa1();
          getDataa1();
        } else {
          Swal.fire("Error", "Failed to delete Chronic illness", "error");
        }
      }
    } catch (error) {
      console.error("Delete error:", error.message);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  const openEditIxrayradio = async (plan) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this file!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const response = await axiosInstance.delete(
          `deleteXrayReport/${plan.id}`
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Deleted Successfully", "success");
          getdatamedical();
          getDataa1();
        } else {
          Swal.fire("Error", "Failed to delete", "error");
        }
      }
    } catch (error) {
      console.error("Delete error:", error.message);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  const handldeapichanganassesment = async () => {
    const jsondata = {
      id: dataMedical?.id,
      field: "pain_assessment",
      value: dataMedical?.pain_assessment,
    };
    try {
      const response = await axiosInstance.post(
        `updateSingleMedicalField`,
        jsondata
      );
      if (response.data.success === true) {
        handleClosepanassesemnt();
        getdatamedical();
        filterdate1();
        getDataa1();
        Swal.fire("Success", "Pain Assesment Updated Successfully", "success");
      } else {
        Swal.fire(
          "Error",
          response.data?.message || "Something went wrong",
          "error"
        );
      }
    } catch (error) {
      Swal.fire("Error", "Failed to update Pain Assesment", "error");
    }
  };
  const [formData13, setFormData13] = useState({
    name: "",
    description: "",
  });
  const [pAllergy, setPAllergy] = useState([]);
  const [filteredAllergyNames, setFilteredAllergyNames] = useState([]);
  const [filteredDescriptions, setFilteredDescriptions] = useState([]);
  // pAllergy is populated by fetchAllAllergies() on mount (no duplicate fetch needed)
  // Allergy name behaves like Chronic Illness: type to filter the known list, pick a
  // suggestion, or just keep typing — an unknown name is saved as-is and joins the list.
  const handleAllergyNameChange = (e) => {
    const value = e.target.value;
    setFormData13((prev) => ({ ...prev, name: value }));
    const needle = value.trim().toLowerCase();
    const matches = needle === ""
      ? pAllergy
      : pAllergy.filter((item) => (item?.name || "").toLowerCase().includes(needle));
    // Hide the list once the text is an exact match — there is nothing left to pick.
    const exact = matches.length === 1 && (matches[0]?.name || "").toLowerCase() === needle;
    setFilteredAllergyNames(exact ? [] : matches.slice(0, 20));
  };
  const handleSelectAllergyName = (item) => {
    // Called with a master-list row, so the description comes along for free.
    const picked = typeof item === "string" ? { name: item } : (item || {});
    setFormData13((prev) => ({
      ...prev,
      name: picked.name || "",
      description: prev.description || picked.description || "",
    }));
    setFilteredAllergyNames([]);
  };
  const isNewAllergyName = (() => {
    const typed = (formData13?.name || "").trim().toLowerCase();
    if (!typed) return false;
    return !pAllergy.some((item) => (item?.name || "").toLowerCase() === typed);
  })();
  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setFormData13({ ...formData13, description: value });
    if (value.trim() === "") {
      setFilteredDescriptions([]);
      return;
    }
    const filtered = pAllergy.filter((item) =>
      item.description.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredDescriptions(filtered);
  };
  const handleSelectDescription = (value) => {
    setFormData13({ ...formData13, description: value });
    setFilteredDescriptions([]);
  };
  const hadlenavigate = (id) => {
    navigate("/Admin/Prescription", {
      state: { id: id, datapatient: location?.state?.patientid },
    });
  };
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [selectedIllness, setSelectedIllness] = useState(null);
  const openEditIllness = (illness) => {
    setSelectedIllness(illness);
    setEditModalOpen(true);
  };
  const closeEditIllness = () => {
    setSelectedIllness(null);
    setEditModalOpen(false);
  };
  const handleEditChange = (e) => {
    setSelectedIllness({
      ...selectedIllness,
      [e.target.name]: e.target.value,
    });
  };
  const saveEditIllness = async () => {
    const postdata = {
      id: selectedIllness.illness_id,
      illness_text: selectedIllness.illness_text,
    };
    try {
      await axiosInstance.put(`updateChronicIllness`, postdata);
      getdatamedical();
      getDataa1();

      Swal.fire("Success", "Illness updated successfully", "success");
      closeEditIllness();
    } catch (error) {
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  const [editingAllergy, setEditingAllergy] = useState(null);
  const [isEditing9, setIsEditing9] = useState(false);
  const handleEditAllergy = (allergy) => {
    setIsEditing9(true);
    setFormData13({
      name: allergy.allergy_name,
      description: allergy.allergy_type,
    });
    setEditingAllergy(allergy.allergy_id);
    setIsEditing9(true);
    setAllergy(true);
  };
  const handleEditAlledelete = async (allergy) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this Allergy!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const response = await axiosInstance.delete(
          `deletePatientAllergy/${allergy.allergy_id ? allergy.patient_allergy_id : allergy.id
          }`
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Allergy has been deleted.", "success");
          getdatamedical();
          getDataa1();
        } else {
          Swal.fire("Error", "Failed to delete Allergy", "error");
        }
      }
    } catch (error) {
      console.error("Delete error:", error.message);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  const handleEditAlledelete123 = async (allergy) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this prescription!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const response = await axiosInstance.delete(
          `deletePatientAllergy/${allergy}`
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Chronic illness has been deleted.", "success");
          getdatamedical();
          getDataa1();
        } else {
          Swal.fire("Error", "Failed to delete Chronic illness", "error");
        }
      }
    } catch (error) {
      console.error("Delete error:", error.message);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  const hadndiagosedelete = async (allergy) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this Diagnosis!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const response = await axiosInstance.delete(
          `deleteDiagnosis/${allergy.id}`
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Diagnosis has been deleted.", "success");
          getdatamedical();
          getDataa1();
        } else {
          Swal.fire("Error", "Failed to delete Diagnosis", "error");
        }
      }
    } catch (error) {
      console.error("Delete error:", error.message);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  const hadlenavigatedelete = async (allergy) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this Prescription!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });
      if (result.isConfirmed) {
        const response = await axiosInstance.delete(
          `deletePrescription/${allergy}`
        );
        if (response.data.success) {
          Swal.fire("Deleted!", "Prescription has been deleted.", "success");
          getdatamedical();
          getDataa1();
        } else {
          Swal.fire("Error", "Failed to delete Prescription", "error");
        }
      }
    } catch (error) {
      console.error("Delete error:", error.message);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };
  const updateAllergy = async (item) => {
    const jsondata = {
      id: editingAllergy,
      allergy_name: formData13.name,
      allergy_type: formData13.description,
    };
    try {
      const response = await axiosInstance.put(
        `updatePatientAllergy`,
        jsondata
      );
      if (response.data.success) {
        getdatamedical();
        getDataa1();
        fetchAllAllergies();
        Swal.fire("Success", "Allergy updated successfully", "success");
        setIsEditing9(false);
        setEditingAllergy(null);
        closeAllergy();
      }
    } catch (error) {
      console.error("Error updating allergy:", error);
      Swal.fire("Error", "Failed to update allergy", "error");
    }
  };
  useEffect(() => {
    getPatientServiceMedical();
  }, [triggerLabRefresh, dateqq]);

  const getPatientServiceMedical = () => {
    axiosInstance.get(
      `GetPatientServices/${location?.state?.patientid?.id}?date=${dateqq || ""}`
    ).then((response) => {
      if (response.data.success) {
        setPatientServiceData(response.data.data.results);
      } else {
        setPatientServiceData([])
      }
    }).catch((error) => {
      console.error(error)
      setPatientServiceData([])
    });
  };

  const [printLoading, setPrintLoading] = useState(false);
  const [isSelectingForPrint, setIsSelectingForPrint] = useState(false);
  const [selectedPrintIds, setSelectedPrintIds] = useState([]);
  const [printModalOpen, setPrintModalOpen] = useState(false);

  // Load available services and inventory
  useEffect(() => {
    loadAvailableServices();
    loadAvailableInventory();
    loadDoctors();
    loadPatientServices();
    loadPatientInventory();
    loadLabRequestServices();
    checkPatientInsuranceCard();
    // Listen for insurance card changes elsewhere in the app
    // const off = EventBus.on("insurance:cardAdded", async (e) => {
    //   try {
    //     if (
    //       !e?.detail?.patientId ||
    //       Number(e.detail.patientId) !== Number(patientId)
    //     )
    //       return;
    //     await checkPatientInsuranceCard();
    //   } catch (_) {}
    // });
    // return () => {
    //   off && off();
    // };
  }, [patientIdentifier]);

  const nowStr = new Date().toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  });

  // const [labServices, setLabServices] = useState([]);
  const [labTotalPrice, setLabTotalPrice] = useState(0);

  const loadAvailableServices = async () => {
    try {
      // Use same endpoint backing Service.jsx
      const response = await axiosInstance.get(`getServices`);
      const raw = response.data?.data || [];
      setGetservice(raw);
      setPatients(raw);
      const list = raw.map((item) => ({
        id: item.id,
        code: item.code,
        serviceName: item.name,
        description: item.description,
        standardCost: item.standard_price,
        secondaryCost: item.secondary_price,
        insurancePrice: item.insurance_price,
        duration: item.duration,
        // VAT fields
        vatLabel: item.vat, // expected "Yes" | "No"
        vatEnabled: (item.vat || "").toString().toLowerCase() === "yes",
        vatValue: Number(item.vat_value) || 0,
      }));
      setAvailableServices(list);
    } catch (error) {
      console.error("Error loading services:", error);
    }
  };

  const serviceDropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        serviceDropdownRef.current &&
        !serviceDropdownRef.current.contains(event.target)
      ) {
        setShowServiceSuggestions(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  });

  const loadAvailableInventory = async () => {
    try {
      // Fetch drugs for inventory from external API
      const response = await axiosInstance.get(`getDrugs`);
      const list = (response.data?.data || []).map((d) => ({
        id: d.id,
        name: d.name,
        price: Number(d.price) || 0,
        quantity: Number(d.quantity) || 0,
      }));
      setAvailableInventory(list);
    } catch (error) {
      console.error("Error loading inventory:", error);
    }
  };

  const loadPatientServices = async (dateSelected = null) => {
    axiosInstance.get(
      `GetPatientServices/${patientIdentifier}?date=${(dateSelected !== "" ? dateSelected : dateqq) || ""}`
    ).then((response) => {
      const data = response.data?.data;
      const results = Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data)
          ? data
          : [];
      // Capture server-provided totals if available
      const apiPlanTotal = Number(data?.planTotal) || 0;
      const apiCompletedTotal = Number(data?.completedTotal) || 0;
      const apiTotalPlanServices = Number(data?.totalPlanServices) || 0;
      const apiTotalCompleteServices = Number(data?.totalCompleteServices) || 0;
      setPlanTotal(apiPlanTotal);
      setCompletedTotal(apiCompletedTotal);
      setTotalPlanServices(apiTotalPlanServices);
      setTotalCompleteServices(apiTotalCompleteServices);
      setServices(results);
    }).catch((error) => {
      console.error(error)
      setPlanTotal(0);
      setCompletedTotal(0);
      setTotalPlanServices(0);
      setTotalCompleteServices(0);
      setServices([]);
    })
  };

  const loadPatientInventory = async () => {
    try {
      const response = await axiosInstance.get(
        `getPharmacyByPatientId/${patientIdentifier}`
      );
      const data = response.data?.data;
      const results = Array.isArray(data?.results)
        ? data.results
        : Array.isArray(data)
          ? data
          : [];
      setInventoryItems(results);
    } catch (error) {
      console.error("Error loading patient inventory:", error);
      setInventoryItems([]);
    }
  };

  const loadLabRequestServices = async () => {
    try {
      const response = await axiosInstance.get(
        `getLabRequestsByPatient/${patientIdentifier}?date=${dateqq || ""}`
      );
      const list = Array.isArray(response.data?.data) ? response.data.data : [];
      const firstRequest = list[0] || {};
      setLabServices(
        Array.isArray(firstRequest.services) ? firstRequest.services : []
      );
      setLabTotalPrice(Number(firstRequest.total_price) || 0);
    } catch (error) {
      console.error("Error loading lab request services:", error);
      setLabServices([]);
      setLabTotalPrice(0);
    }
  };
  const loadDoctors = async () => {
    try {
      const response = await axiosInstance.get(`getActiveDoctors`);
      const data = Array.isArray(response.data?.data) ? response.data.data : [];
      setDoctors(data);
      setDoctors1(data);
    } catch (error) {
      console.error("Error loading doctors:", error);
    }
  };

  // Check if patient has active insurance card
  const checkPatientInsuranceCard = async () => {
    try {
      const response = await axiosInstance.get(
        `getInsuranceCardsByPatientId/${patientIdentifier}`
      );
      const cards = Array.isArray(response.data?.data)
        ? response.data.data
        : [];
      const activeCard = cards.find(
        (card) =>
          card.status === "Active" ||
          (card.expiry_date && new Date(card.expiry_date) > new Date())
      );
      const hasActiveCard = !!activeCard;
      setHasActiveInsuranceCard(hasActiveCard);

      if (hasActiveCard && activeCard.company_id) {
        setInsuranceCompanyId(activeCard.company_id);
        // Fetch company-specific service prices and merge into availableServices
        try {
          const priceRes = await axiosInstance.get(`getCompanyServicePrices/${activeCard.company_id}`);
          const companyPrices = {};
          (priceRes.data?.data || []).forEach(row => {
            if (row.company_price !== null && row.company_price !== undefined) {
              companyPrices[row.service_id] = Number(row.company_price);
            }
          });
          setAvailableServices(prev => prev.map(s => ({
            ...s,
            companyPrice: companyPrices[s.id] ?? null,
          })));
        } catch (_) {}
        // Fetch company-specific lab prices
        try {
          const labPriceRes = await axiosInstance.get(`getCompanyLabPrices/${activeCard.company_id}`);
          const labPrices = {};
          (labPriceRes.data?.data || []).forEach(row => {
            if (row.company_price !== null && row.company_price !== undefined) {
              labPrices[row.lab_service_id] = Number(row.company_price);
            }
          });
          setCompanyLabPriceMap(labPrices);
        } catch (_) {}
      } else {
        setInsuranceCompanyId(null);
        setCompanyLabPriceMap({});
      }
    } catch (error) {
      console.error("Error checking insurance card:", error);
      setHasActiveInsuranceCard(false);
      setInsuranceCompanyId(null);
    }
  };

  const safeServices = Array.isArray(services) ? services : [];

  const fallbackPlanTotal = safeServices
    .filter(
      (service) => (service.status || "").toString().toLowerCase() === "plan"
    )
    .reduce(
      (sum, service) => sum + (service.netAmount ?? service.net_amount ?? 0),
      0
    );

  const fallbackCompletedTotal = safeServices
    .filter((service) => {
      const s = (service.status || "").toString().toLowerCase();
      return s === "completed" || s === "complete";
    })
    .reduce(
      (sum, service) => sum + (service.netAmount ?? service.net_amount ?? 0),
      0
    );

  // State for See More modal
  const [serviceListModal, setServiceListModal] = useState(false);
  const [selectedServicesForModal, setSelectedServicesForModal] = useState([]);

  const handleSeeMoreServices = (services) => {
    setSelectedServicesForModal(services || []);
    setServiceListModal(true);
  };

  const displayPlanTotal = planTotal || fallbackPlanTotal || 0;
  const displayCompletedTotal = completedTotal || fallbackCompletedTotal || 0;
  const formatBhd = (n) => `${Number(n || 0).toLocaleString("en-US")} BHD`;

  const fallbackPlanCount = safeServices.filter(
    (s) => (s.status || "").toString().toLowerCase() === "plan"
  ).length;
  const fallbackCompleteCount = safeServices.filter((s) => {
    const st = (s.status || "").toString().toLowerCase();
    return st === "complete" || st === "completed";
  }).length;
  const displayPlanCount = totalPlanServices || fallbackPlanCount;
  const displayCompleteCount = totalCompleteServices || fallbackCompleteCount;

  const handleServiceDiscountValueChange = (e) => {
    const value = parseFloat(e.target.value) || 0;
    const totalPrice = (Number(serviceFormData.customCost) || 0) * (Number(serviceFormData.quantity) || 1);

    if (serviceFormData.discountType === "Percentage") {
      if (value > globalDiscountLimit) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Percentage discount cannot exceed ${globalDiscountLimit}%`,
        });
        return;
      }
    } else {
      const maxAllowedAmount = (totalPrice * globalDiscountLimit) / 100;
      if (value > maxAllowedAmount) {
        Swal.fire({
          icon: "warning",
          title: "Invalid Discount",
          text: `Amount discount cannot exceed ${globalDiscountLimit}% of total price (max ${maxAllowedAmount.toFixed(3)} BHD)`,
        });
        return;
      }
    }

    setServiceFormData({ ...serviceFormData, discountValue: value });
  };

  const handleAddService = () => {
    checkPatientInsuranceCard();
    setSelectedService(null);
    setServiceFormData({
      serviceId: "",
      extraNotes: "",
      discountType: "Amount",
      discountValue: 0,
      status: "Plan",
      customCost: "",
      quantity: 1,
      sent_by: "",
    });
    setSearchServiceQuery("");
    setShowServiceSuggestions(false);
    setServiceModalOpen(true);
  };

  const handleEditService = (service) => {
    setSelectedService(service);

    // Use the correct service ID field name
    const serviceId = service.serviceId || service.service_id;

    // Set the search query to show the selected service name
    const serviceData = availableServices.find((s) => s.id === serviceId);

    // Initialize customCost with the default cost based on insurance status
    // Initialize customCost from the existing service record, or fallback to default
    let initialCost = service.price || service.custom_cost || service.customCost || "";

    if (!initialCost && serviceData) {
      initialCost = hasActiveInsuranceCard
        ? serviceData.companyPrice ??
        serviceData.insurancePrice ??
        serviceData.insurance_price ??
        serviceData.standardCost
        : serviceData.standardCost;
    }
    initialCost = initialCost || "";

    setSearchServiceQuery(
      serviceData
        ? `${serviceData.code} - ${serviceData.serviceName}`
        : `${service.serviceCode || service.service_code || ""} - ${service.serviceName || service.service_name || ""
        }`
    );

    setServiceFormData({
      serviceId: serviceId,
      extraNotes: service.extraNotes || service.extra_notes || "",
      discountType: service.discountType || service.discount_type || "Amount",
      discountValue: service.discount_value || service.discount_value || 0,
      status: service.status || "Plan",
      customCost: initialCost,
      quantity: service.quantity || 1,
      sent_by: service.sent_by || service.doctor_id || "",
    });

    setShowServiceSuggestions(false);
    setServiceModalOpen(true);
  };

  const handleDeleteService = async (serviceId, serviceDefinitionId) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "This service will be removed from the patient!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, remove it!",
    });

    if (confirm.isConfirmed) {
      try {
        // Restore inventory before deleting
        if (serviceDefinitionId) {
          try {
            await axiosInstance.post(`restoreServiceInventory`, { service_id: serviceDefinitionId, patient_id: patientIdentifier });
          } catch (e) {
            console.warn("Inventory restore failed:", e);
            Swal.fire("Warning", "Service removed but inventory could not be restored. Please check stock manually.", "warning");
          }
        }
        await axiosInstance.delete(`deletePatientService/${serviceId}`);
        Swal.fire(
          "Removed!",
          "Service has been removed from patient.",
          "success"
        );
        dispatch(triggerLabRefresh());
        loadPatientServices();
      } catch (error) {
        console.error("Delete failed", error);
        Swal.fire("Error", "Something went wrong!", "error");
      }
    }
  };

  const handleServiceSubmit = async (e) => {
    e.preventDefault();

    const resolvedPatientId = Number(patientId) || null;
    const resolvedServiceId = Number(serviceFormData.serviceId) || null;

    // More specific validation messages
    if (!resolvedPatientId) {
      Swal.fire(
        "Error",
        "Patient information is missing. Please refresh the page and try again.",
        "error"
      );
      return;
    }

    if (!resolvedServiceId) {
      Swal.fire(
        "Error",
        "Please select a service from the dropdown list before adding.",
        "error"
      );
      return;
    }

    const selectedServiceData = availableServices.find(
      (s) => Number(s.id) === resolvedServiceId
    );
    if (!selectedServiceData) {
      Swal.fire("Error", "Please select a valid service", "error");
      return;
    }

    // Frontend duplicate check removed per requirement to allow adding the same service multiple times

    // const discountLimit = await fetchDiscountLimit();

    // if(serviceFormData.discountType==="Percentage"){
    //   if(serviceFormData.discountValue > discountLimit){
    //     Swal.fire("Invalid Discount",`Percentage discount cannot exceed ${discountLimit}%`,'error');
    //     return;
    //   }
    // }

    if (!selectedService) {
      const consentCheck = await checkForceConsents(resolvedServiceId, resolvedPatientId);
      if (!consentCheck.ok) {
        const result = await Swal.fire({
          icon: 'warning',
          title: 'Consent Required',
          html: `This service requires the following consent(s) to be added today before it can be added:<br/><b>${consentCheck.missing.map(m => m.name).join(', ')}</b>`,
          showCancelButton: true,
          confirmButtonText: 'Add Consent Now',
          cancelButtonText: 'Cancel',
        });
        if (result.isConfirmed) {
          setPendingMissingConsents(consentCheck.missing);
        }
        return;
      }
    }

    // Refresh insurance status before computing discount based on base cost
    await checkPatientInsuranceCard();

    // Determine the actual cost (prioritize custom cost if entered)
    const actualCost =
      serviceFormData.customCost ||
      (hasActiveInsuranceCard
        ? selectedServiceData.companyPrice ??
        selectedServiceData.insurancePrice ??
        selectedServiceData.insurance_price ??
        selectedServiceData.standardCost
        : selectedServiceData.standardCost);

    const baseCost = actualCost;

    const discountValueNum = parseFloat(serviceFormData.discountValue) || 0;

    const discount =
      serviceFormData.discountType === "Percentage"
        ? (baseCost * discountValueNum) / 100
        : discountValueNum;

    const serviceData = {
      serviceId: resolvedServiceId,
      discount_type: serviceFormData.discountType,
      discount_value: discountValueNum,
      extra_notes: serviceFormData.extraNotes,
      price: actualCost,
      custom_cost: actualCost,
      baseCost: actualCost,
      quantity: Number(serviceFormData.quantity) || 1,
      doctor_id: serviceFormData.sent_by,
      sent_by: serviceFormData.sent_by,
      branch_id: parseInt(localStorage.getItem('activeBranchId')) || (allBranchSettings.length === 1 ? allBranchSettings[0]?.id : null),
    };

    try {
      if (selectedService) {
        // Use UpdatePatientServices/:id for editing existing service record
        await axiosInstance.put(
          `UpdatePatientServices/${selectedService.id}`,
          serviceData
        );
      } else {
        // Keep add flow as-is
        await axiosInstance.post(`AddPatientServices`, {
          patientId: resolvedPatientId,
          ...serviceData,
        });
        // Deduct linked inventory items for this service
        console.log(`[deduct] Calling deductServiceInventory with service_id=${resolvedServiceId}`);
        try {
          const deductRes = await axiosInstance.post(`deductServiceInventory`, { service_id: resolvedServiceId, patient_id: resolvedPatientId });
          console.log(`[deduct] Response:`, deductRes.data);
          if (deductRes.data?.affectedRows === 0) {
            console.warn(`[deduct] service_id=${resolvedServiceId} — no inventory items linked or no rows updated`);
          }
        } catch (e) {
          console.warn("Inventory deduction failed:", e);
          Swal.fire("Warning", "Service added but inventory could not be deducted. Please check stock manually.", "warning");
        }
      }
      setServiceModalOpen(false);
      dispatch(triggerLabRefresh());
      loadPatientServices();
    } catch (error) {
      console.error("Submit failed", error);
      const msg = error.response?.data?.message || "Something went wrong!";
      Swal.fire("Error", msg, "error");
    }
  };

  const handleStatusChange = async (patientIdentifier, newStatus) => {
    try {
      const res = await axiosInstance.put(
        `updatePatientPharmacyStatus/${patientIdentifier}`,
        { status: newStatus }
      );
      if (res.data.success) {
        Swal.fire("Success", "Patient status updated successfully", "success");
      } else {
        Swal.fire(
          "Error",
          res.data.message || "failed to updated the status",
          "error"
        );
      }
    } catch (error) {
      console.error("Status change failed", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  // const truncateStyle = {
  //   maxWidth: "150px",
  //   whiteSpace: "nowrap",
  //   overflow: "hidden",
  //   textOverflow: "ellipsis",
  // };

  const handleServiceStatusChange = async (serviceId, newStatus) => {
    try {
      const res = await axiosInstance.put(
        `updatePatientServicesStatus/${serviceId}`,
        { status: newStatus }
      );
      if (res.data.success) {
        Swal.fire("Success", "Service status updated successfully", "success");
        dispatch(triggerLabRefresh());
        loadPatientServices(); // Refresh the services list
      } else {
        Swal.fire(
          "Error",
          res.data.message || "Failed to update service status",
          "error"
        );
      }
    } catch (error) {
      console.error("Service status change failed", error);
      Swal.fire("Error", "Something went wrong!", "error");
    }
  };

  // Inventory functions
  const handleAddInventory = () => {
    setSelectedInventory(null);
    setInventoryFormData({
      inventoryId: "",
      quantity: 1,
    });
    setInventoryModalOpen(true);
  };

  const handleEditInventory = (item) => {
    setSelectedInventory(item);
    setInventoryFormData({
      inventoryId: item.drugId,
      quantity: item.quantity,
    });
    try {
      const inv = availableInventory.find((i) => i.id === item.drugId);
      if (inv) {
        setSearchInventoryQuery(`${inv.id} - ${inv.name}`);
      } else {
        setSearchInventoryQuery(`${item.drugId} - ${item.drug_name}`);
      }
    } catch (_) { }
    setInventoryModalOpen(true);
  };

  // Print functionality
  const handlePrintClick = () => {
    setIsSelectingForPrint(true);
    setSelectedPrintIds([]);
    setPrintModalOpen(true);
  };

  const handleServiceSelection = (serviceId) => {
    setSelectedPrintIds((prev) => {
      if (prev.includes(serviceId)) {
        return prev.filter((id) => id !== serviceId);
      } else {
        return [...prev, serviceId];
      }
    });
  };

  const handleSelectAllServices = () => {
    if (selectedPrintIds.length === safeServices.length) {
      setSelectedPrintIds([]);
    } else {
      setSelectedPrintIds(safeServices.map((service) => service.id));
    }
  };

  const handlePrintSelected = () => {
    if (selectedPrintIds.length === 0) {
      Swal.fire(
        "No Selection",
        "Please select at least one service to print",
        "warning"
      );
      return;
    }

    const selectedServices = safeServices.filter((service) =>
      selectedPrintIds.includes(service.id)
    );

    // Generate print content
    const printContent = generatePrintContent(selectedServices);
    printServices(printContent);

    setPrintModalOpen(false);
    setIsSelectingForPrint(false);
    setSelectedPrintIds([]);
  };

  const generatePrintContent = (services) => {
    const businessSetting = JSON.parse(localStorage.getItem("businessSetting")) || {};
    const hospitalName = businessSetting?.official_name || "Hospital Name";
    const hospitalCR = businessSetting?.cr_number || "";
    const hospitalVAT = businessSetting?.vat_number || "";
    const hospitalEmail = businessSetting?.email || "abcd@gmail.com";
    const hospitalPhone = businessSetting?.telephone_1 || "+973 35135498";
    const website = businessSetting?.website || "";

    const getLogo = () => {
      if (businessSetting?.base64Image) return businessSetting.base64Image;
      if (businessSetting?.image) {
        return businessSetting.image.startsWith("http")
          ? businessSetting.image
          : `${baseurImage}${businessSetting.image}`;
      }
      return logo;
    };
    const finalLogo = getLogo();

    const patientName = personalinfo ? `${personalinfo.firstName || ""} ${personalinfo.lastName || ""}` : "Patient";
    const patientGender = personalinfo?.gender || "";
    const calculateAge = (dob) => {
      if (!dob) return "";
      const diff = Date.now() - new Date(dob).getTime();
      const ageDate = new Date(diff);
      return Math.abs(ageDate.getUTCFullYear() - 1970);
    };
    const patientAge = calculateAge(personalinfo?.dateOfBirth);
    const patientCPR = personalinfo?.civilIdNumber || personalinfo?.cpr || "";
    const patientPhone = personalinfo?.mobileNumber || personalinfo?.phone || "";

    const now = new Date();
    const currentDate = now.toLocaleDateString("en-GB");

    // Calculate total amount
    const totalAmountValue = services.reduce(
      (sum, s) => sum + Number(s.netAmount ?? s.net_amount ?? 0),
      0
    );

    const servicesRows = services.map((s, idx) => {
      const serviceData = availableServices.find(
        (avail) => avail.id === (s.serviceId ?? s.service_id)
      );
      const name = serviceData?.serviceName || s.serviceName || "";
      const code = serviceData?.code || s.serviceCode || "";

      const cost = hasActiveInsuranceCard
        ? serviceData?.companyPrice ?? s.companyPrice ?? serviceData?.insurancePrice ?? serviceData?.insurance_price ?? s.insurancePrice ?? s.insurance_price ?? 0
        : serviceData?.standardCost || s.standardCost || 0;

      const discountVal = Number(s.discountValue ?? s.discount_value ?? 0);
      const discountType = (s.discountType || s.discount_type || "Amount").toLowerCase();
      let discountAmount = discountType === "percentage" ? (Number(cost) * discountVal) / 100 : discountVal;

      const net = Number(s.netAmount ?? s.net_amount ?? Number(cost) - discountAmount);
      const vatVal = Number(s.vat_value ?? serviceData?.vatValue ?? 0);

      const dateDisplay = s.createdAt || s.created_at
        ? new Date(s.createdAt || s.created_at).toLocaleDateString("en-GB")
        : currentDate;

      return `<tr>
          <td style="border: 1px solid #000;">${idx + 1}</td>
          <td style="border: 1px solid #000;">${dateDisplay}</td>
          <td style="border: 1px solid #000;">${code}</td>
          <td style="border: 1px solid #000;">${name}</td>
          <td style="border: 1px solid #000;">${s.doctor_name || s.sent_by || "-"}</td>
          <td style="border: 1px solid #000;">${Number(cost).toFixed(3)}</td>
          <td style="border: 1px solid #000;">${Number(discountAmount).toFixed(3)}</td>
          <td style="border: 1px solid #000;">${vatVal}%</td>
          <td style="border: 1px solid #000;">${net.toFixed(3)}</td>
        </tr>`;
    }).join("");

    return `<!DOCTYPE html>
<html>
<head>
<title>Patient Services Report</title>
<style>
  @page { size: auto; margin: 20px; }
  body { font-family: Arial, sans-serif; margin: 0; padding: 20px; }
  .logo { text-align: center; margin-bottom: 20px; }
  .top-section { display: flex; justify-content: space-between; margin-bottom: 30px; }
  .hospital-info, .patient-info { font-size: 14px; line-height: 1.6; }
  .invoice-title { text-align: center; margin-bottom: 20px; }
  .invoice-title h2 { font-size: 24px; margin: 0; }
  table { width: 100%; border-collapse: collapse; margin-top: 20px; font-size: 14px; }
  table th, table td { border: 1px solid #000; padding: 8px; text-align: left; }
  table th { background-color: #f2f2f2; }
  .totals-section { display: flex; justify-content: flex-end; margin-top: 20px; }
  .totals-section p { font-size: 16px; font-weight: bold; }
  .terms-section { margin-top: 30px; }
  .terms-section h5 { margin-bottom: 10px; }
  .terms-content { font-size: 12px; line-height: 1.5; }
  .footer { position: fixed; bottom: 20px; width: 100%; text-align: center; font-size: 12px; color: #666; }
</style>
</head>
<body>
  <div class="logo">
    <img height="80" src="${finalLogo}" onError="this.style.display='none'" />
  </div>
  <div class="top-section">
    <div class="hospital-info">
      <p><strong>${hospitalName}</strong></p>
      <p><strong>CR:</strong> ${hospitalCR}</p>
      <p><strong>VAT No.</strong> ${hospitalVAT}</p>
    </div>
    <div class="patient-info">
      <strong>Patient Name: </strong> ${patientName}
      <p>${patientGender} ${patientAge ? `(${patientAge} YO)` : ""} </p>
      <p><strong>CPR:</strong> ${patientCPR} </p>
      <p><strong>Phone:</strong> ${patientPhone}</p>
    </div>
  </div>
  <div class="invoice-title">
    <h2>Services Report</h2>
    <p><strong>Date:</strong> ${currentDate}</p>
  </div>
  <table>
    <thead>
      <tr>
        <th>#</th>
        <th>Date</th>
        <th>Code</th>
        <th>Service Name</th>
        <th>Doctor</th>
        <th>Price</th>
        <th>Discount</th>
        <th>VAT</th>
        <th>Total</th>
      </tr>
    </thead>
    <tbody>
      ${servicesRows}
    </tbody>
    <tfoot>
      <tr>
        <td colspan="8" style="text-align: right;"><strong>Total Amount</strong></td>
        <td><strong>${totalAmountValue.toFixed(3)} BHD</strong></td>
      </tr>
    </tfoot>
  </table>
  <div class="terms-section">
    <h5>Terms & Conditions</h5>
    <div class="terms-content">${termsCondition?.content || "N/A"}</div>
  </div>
  <div class="footer">
    Hospital Name: ${hospitalName} | Email: ${hospitalEmail} | Phone: ${hospitalPhone} | Website: ${website}
  </div>
  <script>
    window.onload = () => { setTimeout(() => { window.print(); }, 500); };
  </script>
</body>
</html>`;
  };

  const printServices = (content) => {
    const printWindow = window.open("", "_blank");
    printWindow.document.write(content);
    printWindow.document.close();
    printWindow.focus();
  };
  const generateMedicalReport = async () => {
    // Open the window FIRST (synchronously, in the same tick as the click)
    // so the browser's popup blocker doesn't block it.
    const win = window.open("", "_blank");
    if (!win) {
      Swal.fire("Popup Blocked", "Please allow popups for this site and try again.", "warning");
      return;
    }
    win.document.write("<html><body style='font-family:Arial;padding:30px;color:#555'>Generating report…</body></html>");

    const businessSetting = JSON.parse(localStorage.getItem("businessSetting")) || {};
    const hospitalName = businessSetting?.official_name || "";
    const hospitalCR = businessSetting?.cr_number || "";
    const hospitalVAT = businessSetting?.vat_number || "";
    const hospitalPhone = businessSetting?.telephone_1 || "";
    const getLogo = () => {
      if (businessSetting?.base64Image) return businessSetting.base64Image;
      if (businessSetting?.image) {
        return businessSetting.image.startsWith("http")
          ? businessSetting.image
          : `${baseurImage}${businessSetting.image}`;
      }
      return logo;
    };
    const finalLogo = getLogo();

    // ── Fetch logged-in doctor's signature & stamp ──
    let doctorSignature = null;
    let doctorStamp = null;
    try {
      const userData = JSON.parse(localStorage.getItem("userMedical")) || {};
      const cachedDoctor = userData?.data || {};
      const doctorId = cachedDoctor?.id;

      if (doctorId) {
        const res = await axiosInstance.get("getAllDoctors");
        if (res.data?.success) {
          const found = (res.data.data || []).find((d) => d.id === doctorId);
          if (found) {
            doctorSignature = found.signature || null;
            doctorStamp = found.stamp || null;
          }
        }
      }
    } catch (_) {}

    const resolveImage = (val) => {
      if (!val) return null;
      if (val.startsWith("data:")) return val;
      return `${baseurImage}${val}`;
    };
    const sigSrc = resolveImage(doctorSignature);
    const stampSrc = resolveImage(doctorStamp);

    const signatureStampHtml = (sigSrc || stampSrc) ? `
      <div class="sig-stamp-row">
        ${sigSrc ? `<div class="sig-block"><img src="${sigSrc}" class="sig-img" /></div>` : ""}
        ${stampSrc ? `<div class="sig-block"><img src="${stampSrc}" class="sig-img stamp-img" /></div>` : ""}
      </div>` : "";

    const patientName = personalinfo ? `${personalinfo.firstName || ""} ${personalinfo.lastName || ""}`.trim() : "";
    const fileNumber = personalinfo?.fileNumber || "";
    const patientGender = personalinfo?.gender || "";
    const calcAge = (dob) => {
      if (!dob) return "";
      return Math.abs(new Date(Date.now() - new Date(dob).getTime()).getUTCFullYear() - 1970);
    };
    const patientAge = personalinfo?.age || calcAge(personalinfo?.dateOfBirth);
    const civilId = personalinfo?.civilIdNumber || personalinfo?.cpr || "";

    const reportDate = dateqq
      ? new Date(dateqq).toLocaleDateString("en-GB")
      : new Date().toLocaleDateString("en-GB");

    const esc = (val) => (val || "").toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
    const nl = (val) => (val || "").toString().replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\n/g, "<br/>");

    // Diagnosis — filter by date same as the table
    const filteredDiagnosis = (ddsafjahfl || []).filter(item =>
      dateqq ? new Date(item.created_at).toISOString().slice(0, 10) === dateqq : true
    );

    const diagnosisHtml = filteredDiagnosis.length > 0 ? `
      <div class="section">
        <h4 class="section-title">Diagnosis</h4>
        <ul class="diag-list">
          ${filteredDiagnosis.map((d, i) =>
            `<li><span class="diag-num">${i + 1}.</span> ${d.code ? `<span class="diag-code">[${esc(d.code)}]</span> ` : ""}${esc(d.diagnosis_text || "")}${d.status ? ` <span class="diag-status">(${esc(d.status)})</span>` : ""}</li>`
          ).join("")}
        </ul>
      </div>` : "";

    const vitalsHtml = dataVitals && dataVitals.pulse != null ? `
      <div class="section">
        <h4 class="section-title">Vital Signs</h4>
        <table class="vitals-table">
          <thead><tr><th>Parameter</th><th>Value</th><th>Parameter</th><th>Value</th></tr></thead>
          <tbody>
            <tr>
              <td>Pulse</td><td>${dataVitals.pulse != null ? dataVitals.pulse + " bpm" : "—"}</td>
              <td>Temperature</td><td>${dataVitals.temperature != null ? dataVitals.temperature + " °C" : "—"}</td>
            </tr>
            <tr>
              <td>Blood Pressure</td><td>${dataVitals.systolic != null ? dataVitals.systolic + "/" + dataVitals.diastolic + " mmHg" : "—"}</td>
              <td>O2 Saturation</td><td>${dataVitals.oxygen_saturation != null ? dataVitals.oxygen_saturation + "%" : "—"}</td>
            </tr>
            <tr>
              <td>Respiratory Rate</td><td>${dataVitals.respiratory_rate != null ? dataVitals.respiratory_rate + " /min" : "—"}</td>
              <td>Weight</td><td>${dataVitals.weight != null ? dataVitals.weight + " kg" : "—"}</td>
            </tr>
            <tr>
              <td>Height</td><td>${dataVitals.height != null ? dataVitals.height + " cm" : "—"}</td>
              <td>BMI</td><td>${dataVitals.bmi != null ? dataVitals.bmi : "—"}</td>
            </tr>
          </tbody>
        </table>
      </div>` : "";

    // Use dataMedical (same as what is displayed on screen — not editing state vars)
    const section = (label, value) => value
      ? `<div class="section"><h4 class="section-title">${label}</h4><div class="content">${nl(value)}</div></div>`
      : "";

    const content = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8"/>
<title>Medical Report - ${esc(patientName)}</title>
<style>
  * { -webkit-print-color-adjust: exact; print-color-adjust: exact; box-sizing: border-box; }
  @page { size: A4 portrait; margin: 15mm 15mm 15mm 15mm; }
  body { font-family: Arial, sans-serif; margin: 0; padding: 0; color: #000; font-size: 11pt; background: #fff; }
  .header { display: flex; align-items: flex-start; justify-content: space-between; border-bottom: 2px solid #000; padding-bottom: 10px; margin-bottom: 12px; }
  .header img { max-height: 70px; max-width: 160px; object-fit: contain; filter: grayscale(100%); }
  .hospital-info { text-align: right; font-size: 9pt; line-height: 1.6; }
  .hospital-info strong { font-size: 11pt; }
  .report-title { text-align: center; font-size: 14pt; font-weight: bold; margin-bottom: 10px; letter-spacing: 1px; text-transform: uppercase; border-bottom: 1px solid #000; padding-bottom: 6px; }
  .patient-grid { display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 4px 16px; border: 1px solid #000; padding: 8px 12px; margin-bottom: 14px; font-size: 10pt; }
  .patient-grid .lbl { color: #555; font-size: 9pt; }
  .patient-grid .val { font-weight: bold; }
  .section { margin-bottom: 12px; page-break-inside: avoid; }
  h4.section-title { font-size: 10pt; font-weight: bold; text-transform: uppercase; letter-spacing: 0.5px; border-bottom: 1px solid #000; padding-bottom: 3px; margin: 0 0 6px 0; }
  .content { font-size: 10pt; line-height: 1.6; padding-left: 4px; white-space: pre-wrap; word-break: break-word; }
  table.vitals-table { width: 100%; border-collapse: collapse; font-size: 10pt; }
  table.vitals-table th, table.vitals-table td { border: 1px solid #000; padding: 4px 8px; }
  table.vitals-table th { background: #eee; font-weight: bold; text-align: center; }
  table.vitals-table td:nth-child(odd) { background: #f5f5f5; font-weight: bold; width: 22%; }
  ul.diag-list { margin: 0; padding: 0 0 0 4px; list-style: none; font-size: 10pt; line-height: 1.7; }
  ul.diag-list li { padding: 1px 0; }
  .diag-num { font-weight: bold; }
  .diag-code { font-weight: bold; }
  .diag-status { color: #333; font-style: italic; font-size: 9pt; }
  .two-col { display: grid; grid-template-columns: 1fr 1fr; gap: 0 20px; }
  .sig-stamp-row { display: flex; gap: 16px; justify-content: flex-end; align-items: flex-end; margin-top: 30px; padding-top: 16px; border-top: 1px solid #000; page-break-inside: avoid; }
  .sig-block { display: flex; flex-direction: column; align-items: center; }
  .sig-img { max-height: 70px; max-width: 160px; object-fit: contain; }
  .stamp-img { max-height: 100px; max-width: 100px; }
</style>
</head>
<body>
  <div class="header">
    <img src="${finalLogo}" onerror="this.style.display='none'" />
    <div class="hospital-info">
      <strong>${esc(hospitalName)}</strong><br/>
      ${hospitalCR ? `CR No: ${esc(hospitalCR)}<br/>` : ""}
      ${hospitalVAT ? `VAT No: ${esc(hospitalVAT)}<br/>` : ""}
      ${hospitalPhone ? `Tel: ${esc(hospitalPhone)}` : ""}
    </div>
  </div>

  <div class="report-title">Medical Report</div>

  <div class="patient-grid">
    <div><div class="lbl">Patient Name</div><div class="val">${esc(patientName)}</div></div>
    <div><div class="lbl">File No.</div><div class="val">${esc(fileNumber) || "—"}</div></div>
    <div><div class="lbl">Report Date</div><div class="val">${reportDate}</div></div>
    <div><div class="lbl">Age</div><div class="val">${patientAge !== "" ? patientAge + " yrs" : "—"}</div></div>
    <div><div class="lbl">Gender</div><div class="val">${esc(patientGender) || "—"}</div></div>
    <div><div class="lbl">Civil ID</div><div class="val">${esc(civilId) || "—"}</div></div>
  </div>

  ${vitalsHtml}
  ${diagnosisHtml}

  <div class="two-col">
    ${section("Chief Complaint", dataMedical?.chief_complaint)}
    ${section("History of Present Illness", dataMedical?.history_of_present_illness)}
  </div>
  <div class="two-col">
    ${section("History of Past Illness", dataMedical?.history_of_past_illness)}
    ${section("Examination – General", dataMedical?.examination_general)}
  </div>
  <div class="two-col">
    ${section("Examination – Systemic", dataMedical?.examination_systemic)}
    ${section("Examination – Local", dataMedical?.examination_local)}
  </div>
  <div class="two-col">
    ${section("Family History", dataMedical?.family_history)}
    ${section("Psychosocial", dataMedical?.psychosocial)}
  </div>
  <div class="two-col">
    ${section("Treatment Plan", dataMedical?.treatment_plan)}
    ${section("Advises", dataMedical?.advises)}
  </div>
  ${section("Extra Notes", dataMedical?.extra_notes)}

  ${signatureStampHtml}

  <script>window.onload = () => { setTimeout(() => { window.print(); }, 400); };</script>
</body>
</html>`;

    win.document.open();
    win.document.write(content);
    win.document.close();
    win.focus();
  };

  const filteredServices = availableServices.filter(
    (service) =>
      service.serviceName
        ?.toLowerCase()
        .includes(searchServiceQuery.toLowerCase()) ||
      service.code?.toLowerCase().includes(searchServiceQuery.toLowerCase())
  );
  const filteredInventory = availableInventory.filter(
    (item) =>
      item.name?.toLowerCase().includes(searchInventoryQuery.toLowerCase()) ||
      item.id?.toString().includes(searchInventoryQuery)
  );
  const filteredServicesTable = safeServices.filter((service) => {
    if (!serviceTableSearchTerm) return true;
    const q = serviceTableSearchTerm.toLowerCase();
    const serviceData = availableServices.find(
      (s) => s.id === (service.serviceId ?? service.service_id)
    );
    return (
      (serviceData?.code && serviceData.code.toLowerCase().includes(q)) ||
      (serviceData?.serviceName &&
        serviceData.serviceName.toLowerCase().includes(q)) ||
      (serviceData?.description &&
        serviceData.description.toLowerCase().includes(q)) ||
      (service.serviceCode && service.serviceCode.toLowerCase().includes(q)) ||
      (service.serviceName && service.serviceName.toLowerCase().includes(q)) ||
      (service.description && service.description.toLowerCase().includes(q)) ||
      (service.extra_notes && service.extra_notes.toLowerCase().includes(q)) ||
      (service.status && service.status.toLowerCase().includes(q))
    );
  });
  const safeInventoryItems = Array.isArray(inventoryItems)
    ? inventoryItems
    : [];
  const filteredInventoryTable = safeInventoryItems.filter((item) => {
    if (!inventoryTableSearchTerm) return true;
    const q = inventoryTableSearchTerm.toLowerCase();
    return (
      (item.drug_name && item.drug_name.toLowerCase().includes(q)) ||
      (item.drugId && item.drugId.toString().includes(q)) ||
      (item.quantity && item.quantity.toString().includes(q)) ||
      (item.status && item.status.toLowerCase().includes(q))
    );
  });
  const totalServicePages =
    Math.ceil(filteredServicesTable.length / servicesPerPage) || 1;
  const totalInventoryPages =
    Math.ceil(filteredInventoryTable.length / inventoryPerPage) || 1;
  const paginatedServices = filteredServicesTable.slice(
    (currentServicePage - 1) * servicesPerPage,
    currentServicePage * servicesPerPage
  );
  const paginatedInventory = filteredInventoryTable.slice(
    (currentInventoryPage - 1) * inventoryPerPage,
    currentInventoryPage * inventoryPerPage
  );
  // Reset to first page if dataset size changes
  useEffect(() => {
    setCurrentServicePage(1);
  }, [services.length]);
  useEffect(() => {
    setCurrentInventoryPage(1);
  }, [safeInventoryItems.length]);
  const downloadLargePDF = async (divId) => {
    const input = document.getElementById(divId);
    const pdf = new jsPDF("p", "mm", "a4");
    const pageHeight = 295;
    const pageWidth = 210;
    const canvas = await html2canvas(input, {
      scale: 2,
      useCORS: true,
    });
    const imgData = canvas.toDataURL("image/png");
    const imgHeight = (canvas.height * pageWidth) / canvas.width;
    let heightLeft = imgHeight;
    let position = 0;
    pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
    heightLeft -= pageHeight;
    while (heightLeft > 0) {
      position = heightLeft - imgHeight;
      pdf.addPage();
      pdf.addImage(imgData, "PNG", 0, position, pageWidth, imgHeight);
      heightLeft -= pageHeight;
    }
    pdf.save("download.pdf");
  };

  const handleSelectNotesTemplate = (template) => {
    // Set values directly (no search API calls triggered)
    if (template.chief_complaint !== undefined) setInputValue(template.chief_complaint);
    if (template.history_of_present_illness !== undefined) setInputValue1(template.history_of_present_illness);
    if (template.history_of_past_illness !== undefined) setInputValue2(template.history_of_past_illness);
    if (template.examination_general !== undefined) setInputValue3(template.examination_general);
    if (template.examination_systemic !== undefined) setInputValue4(template.examination_systemic);
    if (template.examination_local !== undefined) setInputValue5(template.examination_local);
    if (template.treatment_plan !== undefined) setInputValue6(template.treatment_plan);
    if (template.advises !== undefined) setInputValue7(template.advises);
    if (template.extra_notes !== undefined) setInputValue8(template.extra_notes);
    if (template.family_history !== undefined) setInputValue10(template.family_history);
    if (template.psychosocial !== undefined) setInputValue111(template.psychosocial);
    if (template.pain_assessment) {
      setMedicalNotes((prev) => ({ ...prev, pain_assessment: template.pain_assessment }));
    }
  };

  const handleSelectPerscriptionTemplate = async (template) => {
    try {
      await template.rxList.forEach(async (item) => {
        item.rxId = item.id;
        axiosInstance.post(
          `prescriptionAllergyCheckSingle`,
          {
            patient_id: patientIdentifier,
            prescriptionId: item.id,
          }
        ).then(async (response) => {
          if (response.data.success && response.data.allergy_found === 1) {
            const result = await Swal.fire({
              icon: "warning",
              title: "Warning",
              text: `Allergy conflict detected for ${item.medicine_name}. Do you want to continue?`,
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            })
            if (result.isConfirmed) {
              setAddedMedicines((prev) => [...prev, { ...item }]);
            }
          } else if (response.data.success) {
            item.substance = item.active_substances
            item.form = item.pharmaceutical_form
            item.productType = item.product_type
            setAddedMedicines((prev) => [...prev, { ...item }]);
          } else {
            const result = await Swal.fire({
              icon: "warning",
              title: "Warning",
              text: `Could not check allergies for ${item.medicine_name}. Do you want to continue?`,
              showCancelButton: true,
              confirmButtonText: "Yes",
              cancelButtonText: "No",
            })
            if (result.isConfirmed) {
              setAddedMedicines((prev) => [...prev, { ...item }]);
            }
          }
        }).catch(async (error) => {
          console.error("Allergy check error:", error);
          const result = await Swal.fire({
            icon: "warning",
            title: "Warning",
            text: `Could not check allergies for ${item.medicine_name}. Do you want to continue?`,
            showCancelButton: true,
            confirmButtonText: "Yes",
            cancelButtonText: "No",
          })
          if (result.isConfirmed) {
            setAddedMedicines((prev) => [...prev, { ...item }]);
          }
        });
      });

    } catch (error) {
      console.error("Error applying prescription template:", error);
    }






  };
  return (
    <div className="pc-container">
      <div className="pc-content">
        <div className="patientTab">
          <div>
            <ul
              className="nav justify-content-between nav-tabs"
              id="myTab"
              role="tablist"
            >
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "personaldata" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("personaldata")}
                  id="personaldata-tab"
                  type="button"
                  role="tab"
                  aria-controls="personaldata"
                  aria-selected={activeTab === "personaldata"}
                  disabled={!hasSubModulePermission(2)}
                  style={{
                    opacity: !hasSubModulePermission(2) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(2)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(2) ? "none" : "auto",
                    display: !hasSubModulePermission(2) ? "none" : "flex",
                  }}
                >
                  <span>
                    <div className="tabSvg">
                      <i className="fas fa-server"></i>
                    </div>
                  </span>{" "}
                  <p>Personal Data</p>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "Appointment" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("Appointment")}
                  id="Appointment-tab"
                  type="button"
                  role="tab"
                  aria-controls="Appointment"
                  aria-selected={activeTab === "Appointment"}
                  disabled={!hasSubModulePermission(3)}
                  style={{
                    opacity: !hasSubModulePermission(3) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(3)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(3) ? "none" : "auto",
                    display: !hasSubModulePermission(3) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i className="far fa-calendar-check"></i>
                  </div>
                  <p>Appointment</p>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "vitalsings" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("vitalsings")}
                  id="vitalsings-tab"
                  type="button"
                  role="tab"
                  aria-controls="vitalsings"
                  aria-selected={activeTab === "vitalsings"}
                  disabled={!hasSubModulePermission(4)}
                  style={{
                    opacity: !hasSubModulePermission(4) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(4)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(4) ? "none" : "auto",
                    display: !hasSubModulePermission(4) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fas fa-procedures"></i>
                  </div>
                  <p>Vital Signs</p>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "forms" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("forms")}
                  id="forms-tab"
                  type="button"
                  role="tab"
                  aria-controls="forms"
                  aria-selected={activeTab === "forms"}
                  disabled={!hasSubModulePermission(5)}
                  style={{
                    opacity: !hasSubModulePermission(5) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(5)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(5) ? "none" : "auto",
                    display: !hasSubModulePermission(5) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fas fa-file-alt"></i>
                  </div>
                  <p>Forms</p>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "patientfiles" ? "active" : ""}`}
                  onClick={() => setActiveTab("patientfiles")}
                  id="patientfiles-tab"
                  type="button"
                  role="tab"
                  aria-controls="patientfiles"
                  aria-selected={activeTab === "patientfiles"}
                  disabled={!hasSubModulePermission(7)}
                  style={{
                    opacity: !hasSubModulePermission(7) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(7) ? "not-allowed" : "pointer",
                    pointerEvents: !hasSubModulePermission(7) ? "none" : "auto",
                    display: !hasSubModulePermission(7) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i className="fas fa-folder-open"></i>
                  </div>
                  <p>Files</p>
                </button>
              </li>

              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "labs" ? "active" : ""}`}
                  onClick={() => setActiveTab("labs")}
                  id="labs-tab"
                  type="button"
                  role="tab"
                  aria-controls="labs"
                  aria-selected={activeTab === "labs"}
                  disabled={!hasSubModulePermission(6)}
                  style={{
                    opacity: !hasSubModulePermission(6) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(6)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(6) ? "none" : "auto",
                    display: !hasSubModulePermission(6) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fas fa-flask"></i>
                  </div>
                  <p>Labs</p>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "medicalhistory" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("medicalhistory")}
                  id="medicalhistory-tab"
                  type="button"
                  role="tab"
                  aria-controls="medicalhistory"
                  aria-selected={activeTab === "medicalhistory"}
                  disabled={!hasSubModulePermission(7)}
                  style={{
                    opacity: !hasSubModulePermission(7) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(7)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(7) ? "none" : "auto",
                    display: !hasSubModulePermission(7) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fas fa-file-medical"></i>
                  </div>
                  <p>Medical History</p>
                </button>
              </li>
              {dentalModuleEnabled && (
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "dental" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("dental")}
                  id="dental-tab"
                  type="button"
                  role="tab"
                  aria-controls="dental"
                  aria-selected={activeTab === "dental"}
                  disabled={!hasSubModulePermission(8)}
                  style={{
                    opacity: !hasSubModulePermission(8) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(8)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(8) ? "none" : "auto",
                    display: !hasSubModulePermission(8) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fas fa-tooth"></i>
                  </div>
                  <p>Dental</p>
                </button>
              </li>
              )}
              {dermatologyEnabled && (
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "dermatology" ? "active" : ""}`}
                  onClick={() => setActiveTab("dermatology")}
                  id="dermatology-tab"
                  type="button"
                  role="tab"
                  aria-controls="dermatology"
                  aria-selected={activeTab === "dermatology"}
                  disabled={!hasSubModulePermission(8)}
                  style={{
                    opacity: !hasSubModulePermission(8) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(8) ? "not-allowed" : "pointer",
                    pointerEvents: !hasSubModulePermission(8) ? "none" : "auto",
                    display: !hasSubModulePermission(8) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fas fa-allergies"></i>
                  </div>
                  <p>Dermatology</p>
                </button>
              </li>
              )}
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "service" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("service")}
                  id="service-tab"
                  type="button"
                  role="tab"
                  aria-controls="service"
                  aria-selected={activeTab === "service"}
                  disabled={!hasSubModulePermission(9)}
                  style={{
                    opacity: !hasSubModulePermission(9) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(9)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(9) ? "none" : "auto",
                    display: !hasSubModulePermission(9) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fab fa-servicestack"></i>
                  </div>
                  <p>Services</p>
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "billing" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("billing")}
                  id="billing-tab"
                  type="button"
                  role="tab"
                  aria-controls="billing"
                  aria-selected={activeTab === "billing"}
                  disabled={!hasSubModulePermission(10)}
                  style={{
                    opacity: !hasSubModulePermission(10) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(10)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(10)
                      ? "none"
                      : "auto",
                    display: !hasSubModulePermission(10) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="far fa-money-bill-alt"></i>
                  </div>
                  <p>Billing</p>
                </button>
              </li>
              {insuranceModuleEnabled && (
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${activeTab === "insurance" ? "active" : ""
                    }`}
                  onClick={() => setActiveTab("insurance")}
                  id="insurance-tab"
                  type="button"
                  role="tab"
                  aria-controls="insurance"
                  aria-selected={activeTab === "insurance"}
                  disabled={!hasSubModulePermission(11)}
                  style={{
                    opacity: !hasSubModulePermission(11) ? 0.5 : 1,
                    cursor: !hasSubModulePermission(11)
                      ? "not-allowed"
                      : "pointer",
                    pointerEvents: !hasSubModulePermission(11)
                      ? "none"
                      : "auto",
                    display: !hasSubModulePermission(11) ? "none" : "flex",
                  }}
                >
                  <div className="tabSvg">
                    <i class="fas fa-user-shield"></i>
                  </div>
                  <p>Insurance</p>
                </button>
              </li>
              )}
            </ul>
            {personalinfo && !Array.isArray(personalinfo) && (
              <div style={{
                display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px 14px",
                padding: "10px 16px", borderBottom: "1px solid #e9ecef",
                background: "#f8f9fb",
              }}>
                {/* File number badge */}
                <span style={{
                  background: "#4680ff", color: "#fff",
                  borderRadius: 6, padding: "2px 10px", fontSize: 12, fontWeight: 600,
                  letterSpacing: "0.03em", whiteSpace: "nowrap",
                }}>
                  # {personalinfo?.fileNumber}
                </span>

                {/* Divider */}
                <span style={{ color: "#d0d7e2", fontWeight: 300 }}>|</span>

                {/* Name */}
                <span style={{ fontSize: 14, fontWeight: 600, color: "#1a202c" }}>
                  {personalinfo?.firstName} {personalinfo?.lastName}
                </span>

                {/* Age */}
                {personalinfo?.age && (
                  <span style={{
                    background: "#eef2ff", color: "#4680ff",
                    borderRadius: 20, padding: "2px 9px", fontSize: 12, fontWeight: 500,
                  }}>
                    {personalinfo.age}y
                  </span>
                )}

                {/* Gender */}
                {personalinfo?.gender && (
                  <span style={{
                    background: personalinfo.gender?.toLowerCase() === "male" ? "#e8f4fd" : "#fce8f3",
                    color: personalinfo.gender?.toLowerCase() === "male" ? "#2980b9" : "#c0392b",
                    borderRadius: 20, padding: "2px 9px", fontSize: 12, fontWeight: 500,
                  }}>
                    {personalinfo.gender}
                  </span>
                )}

                {/* Mobile */}
                {personalinfo?.mobileNumber && (
                  <>
                    <span style={{ color: "#d0d7e2", fontWeight: 300 }}>|</span>
                    <span style={{ fontSize: 13, color: "#5B6B79", display: "flex", alignItems: "center", gap: 4 }}>
                      <i className="ti ti-phone" style={{ fontSize: 13 }} />
                      {personalinfo.mobileNumber}
                    </span>
                  </>
                )}
              </div>
            )}
            <div className="tab-content" id="myTabContent">
              <div
                className={`tab-pane fade ${activeTab === "insurance" ? "show active" : ""
                  }`}
                id="insurance"
                role="tabpanel"
                aria-labelledby="insurance-tab"
              >
                <PatientInsurance patientId={location?.state?.patientid?.id} />
              </div>
              <div
                className={`tab-pane fade ${activeTab === "billing" ? "show active" : ""
                  }`}
                id="billing"
                role="tabpanel"
                aria-labelledby="billing-tab"
              >
                <PatientBilling patientId={location?.state?.patientid?.id} />
              </div>
              {/* <div
                className="tab-pane fade show active"
                id="personaldata"
                role="tabpanel"
                aria-labelledby="personaldata-tab analytics-tab-1"
                tabIndex={0}
              >
                <div className="col-12">
                  <div>
                    <div className="card-header">
                      <div className="d-sm-flex align-items-center justify-content-between"></div>
                    </div>
                    <div className="mt-5 commonCard pt-5">
                      <div className="row g-3">
                        <div className="col-md-8">
                          <div
                            className="card mb-3"
                            style={{ position: "relative" }}
                          >
                            <div className="personaimg text-center">
                              <img
                                style={{ width: "100px", height: "100px" }}
                                src={
                                  personalinfo.profileImage === null
                                    ? perImg
                                    : ` ${baseurImage}${personalinfo.profileImage}`
                                }
                                alt="1"
                              />
                            </div>
                            <div>
                              <h5 className="card-title">Personal Info</h5>
                              <div className="row p20">
                                <div className="col-md-6">
                                  <label className="form-label">
                                    File Number
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    value={personalinfo.fileNumber}
                                    placeholder="File Number"
                                    disabled
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Name</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Name"
                                    disabled
                                    value={personalinfo.firstName}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Medical ID
                                  </label>
                                  <input
                                    type="text"
                                    disabled
                                    className="form-control"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Date of Birth
                                  </label>
                                  <input
                                    type="date"
                                    disabled
                                    className="form-control"
                                    value={
                                      personalinfo.dateOfBirth
                                        ? new Date(personalinfo.dateOfBirth)
                                            .toISOString()
                                            .split("T")[0]
                                        : ""
                                    }
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Age</label>
                                  <input
                                    type="number"
                                    className="form-control"
                                    value={personalinfo.age}
                                    disabled
                                    placeholder="Age"
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label">Civil ID</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Civil ID"
                                    disabled
                                    value={personalinfo.civilIdNumber}
                                  />
                                </div>
                                <div className="col-md-4">
                                  <label className="form-label d-block">
                                    Gender
                                  </label>
                                  <div className="d-flex">
                                    <input
                                      type="text"
                                      className="form-control"
                                      placeholder="Gender"
                                      disabled
                                      value={personalinfo.gender}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Passport ID
                                  </label>
                                  <input
                                    type="text"
                                    value={personalinfo.passportNumber}
                                    className="form-control"
                                    disabled
                                    placeholder=" Passport ID"
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">
                                    Nationality
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled
                                    value={personalinfo.nationality}
                                    placeholder="Nationality"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-3">
                            <div>
                              <h5 className="card-title">Contact Details</h5>
                              <div className="row p20">
                                <div className="col-md-6">
                                  <label className="form-label">Mobile</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled
                                    placeholder="Mobile"
                                    value={personalinfo.mobileNumber}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Email</label>
                                  <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Email"
                                    disabled
                                    value={personalinfo.email}
                                  />
                                </div>
                                <div className="col-md-6">
                                  <label className="form-label">Address</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    disabled
                                    value={personalinfo.address}
                                    placeholder="Address"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4 rightSidePer">
                          <div className="card mb-3">
                            <div>
                              <h5 className="card-title">Emergency Contact</h5>
                              <div className="p20">
                                <div className="row">
                                  <div className="col-lg-6">
                                    <label class="form-label">Name</label>
                                    <input
                                      type="text"
                                      value={personalinfo.emContactName}
                                      className="form-control"
                                      disabled
                                      placeholder="Name"
                                    />
                                  </div>
                                  <div className="col-lg-6">
                                    <label class="form-label">Relation</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      disabled
                                      value={personalinfo.emContactRelation}
                                      placeholder="Relation"
                                    />
                                  </div>
                                  <div className="col-lg-6">
                                    <label class="form-label">Phone 1</label>
                                    <input
                                      type="text"
                                      disabled
                                      className="form-control"
                                      value={personalinfo.emContactPhone1}
                                      placeholder="Phone 1"
                                    />
                                  </div>
                                  <div className="col-lg-6">
                                    <label class="form-label">Phone 2</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      disabled
                                      placeholder="Phone 2"
                                      value={personalinfo.emContactPhone2}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-3">
                            <div>
                              <h5 className="card-title">Documents</h5>
                              <div className="p20">
                                <div className="row ">
                                  <div className="col-lg-12 docPatient">
                                    <div className="mb-1">
                                      <label className="form-label mb-3">
                                        {" "}
                                        CPR Scan{" "}
                                      </label>
                                      {personalinfo.CPR_scan_doc ? (
                                        <a
                                          href={`${baseurImage}/${personalinfo.CPR_scan_doc}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="borderBtn"
                                        >
                                          View CPR Scan
                                        </a>
                                      ) : (
                                        <span>No document available</span>
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-lg-12 docPatient">
                                    <div className="mb-1">
                                      <label className="form-label mb-3">
                                        Passport Copy
                                      </label>

                                      {personalinfo.passport_copy ? (
                                        <a
                                          href={`${baseurImage}/${personalinfo.passport_copy}`}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="borderBtn"
                                        >
                                          View Passport
                                        </a>
                                      ) : (
                                        <span>No document available</span>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card mb-3 ">
                            <div className="card-body  p-3">
                              <div className="d-flex">
                                <p>
                                  <label className="form-label">
                                    Last Visit:
                                  </label>{" "}
                                  {new Date(
                                    personalinfo.lastVisitDate
                                  ).toLocaleDateString("en-GB") === "01/01/1970"
                                    ? ""
                                    : new Date(
                                        personalinfo.lastVisitDate
                                      ).toLocaleDateString("en-GB")}
                                </p>
                              </div>
                              <p>
                                <label className="form-label">
                                  File Opening:
                                </label>{" "}
                                {new Date(
                                  personalinfo.fileOpenedDate
                                ).toLocaleDateString("en-GB")}
                              </p>
                              <label className="form-label">
                                Primary Doctor
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                disabled
                                placeholder="Phone 2"
                                value={personalinfo.Primary_Doctor}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div
                className={`tab-pane fade ${activeTab === "personaldata" ? "show active" : ""
                  }`}
                id="personaldata"
                role="tabpanel"
                aria-labelledby="personaldata-tab analytics-tab-1"
                tabIndex={0}
              >
                <div className="col-12">
                  <div className="mt-4">

                    {/* ── Top Profile Card ───────────────────────────────────────── */}
                    <div className="card mb-4" style={{ borderRadius: "14px", overflow: "hidden", boxShadow: "0 2px 12px rgba(0,0,0,0.07)" }}>
                      <div className="card-body p-4">
                        <div className="d-flex gap-4 align-items-start">

                          {/* Photo — 240×320 rounded rectangle */}
                          <div style={{ flexShrink: 0 }}>
                            <img
                              src={personalinfo?.profileImage ? `${baseurImage}${personalinfo.profileImage}` : perImg}
                              alt="Patient"
                              style={{
                                width: "240px",
                                height: "320px",
                                objectFit: "cover",
                                borderRadius: "12px",
                                border: "1px solid #e9ecef",
                                display: "block",
                              }}
                            />
                          </div>

                          {/* Profile Info */}
                          <div style={{ flex: 1, minWidth: 0 }}>

                            {/* Name + Edit button */}
                            <div className="d-flex align-items-center justify-content-between mb-1">
                              <h4 style={{ fontWeight: "700", margin: 0, color: "#1a1f36" }}>
                                {`${personalinfo?.firstName || ""} ${personalinfo?.lastName || ""}`.trim() || "—"}
                              </h4>
                              <button
                                className="bgBtn btn-sm d-flex align-items-center gap-1"
                                style={{ fontSize: 13, padding: "5px 12px" }}
                                onClick={() => navigate("/Admin/EditPatient", { state: { patientid: personalinfo } })}
                              >
                                <i className="ti ti-edit" />
                                Edit Profile
                              </button>
                            </div>

                            {/* File number badge */}
                            <div className="mb-3">
                              <span style={{ background: "#f0f4ff", color: "#4680ff", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", fontWeight: "600" }}>
                                File # {personalinfo?.fileNumber || "—"}
                              </span>
                              {personalinfo?.legacyf && (
                                <span style={{ background: "#fff7e6", color: "#B5962A", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", fontWeight: "600", marginLeft: "6px" }}>
                                  Legacy File # {personalinfo.legacyf}
                                </span>
                              )}
                              {personalinfo?.gender && (
                                <span style={{ background: personalinfo.gender?.toLowerCase() === "female" ? "#fff0f6" : "#f0f7ff", color: personalinfo.gender?.toLowerCase() === "female" ? "#c2185b" : "#1565c0", borderRadius: "6px", padding: "3px 10px", fontSize: "12px", fontWeight: "600", marginLeft: "6px" }}>
                                  {personalinfo.gender}
                                </span>
                              )}
                            </div>

                            {/* Fields grid — 3 columns */}
                            {(() => {
                              const Field = ({ label, value, icon }) => (
                                <div style={{ marginBottom: "14px" }}>
                                  <div style={{ fontSize: "11px", fontWeight: "600", color: "#9aa0ac", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" }}>
                                    {icon && <i className={`ti ${icon}`} style={{ marginRight: "4px" }} />}{label}
                                  </div>
                                  <div style={{ fontSize: "14px", color: "#1a1f36", fontWeight: "500" }}>
                                    {value || <span style={{ color: "#ccc" }}>—</span>}
                                  </div>
                                </div>
                              );

                              const dob = personalinfo?.dateOfBirth && personalinfo.dateOfBirth !== "0000-00-00"
                                ? new Date(personalinfo.dateOfBirth).toLocaleDateString("en-GB")
                                : null;

                              const lastVisit = (() => {
                                const d = new Date(personalinfo?.lastVisitDate).toLocaleDateString("en-GB");
                                return d === "01/01/1970" ? null : d;
                              })();

                              return (
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "0 24px" }}>
                                  <Field label="Date of Birth"  icon="ti-calendar"     value={dob} />
                                  <Field label="Age"            icon="ti-user"         value={personalinfo?.age ? `${personalinfo.age} yrs` : null} />
                                  <Field label="Nationality"    icon="ti-flag"         value={personalinfo?.nationality} />
                                  <Field label="Civil ID"       icon="ti-id-badge"     value={personalinfo?.civilIdNumber} />
                                  <Field label="Passport ID"    icon="ti-passport"     value={personalinfo?.passportNumber} />
                                  <Field label="Primary Doctor" icon="ti-stethoscope"  value={personalinfo?.Primary_Doctor} />
                                  <Field label="Mobile"         icon="ti-phone"        value={personalinfo?.mobileNumber} />
                                  <Field label="Email"          icon="ti-mail"         value={personalinfo?.email} />
                                  <Field label="Address"        icon="ti-map-pin"      value={personalinfo?.address} />
                                  <Field label="Last Visit"     icon="ti-clock"        value={lastVisit} />
                                  <Field label="File Opened"    icon="ti-folder"       value={new Date(personalinfo?.fileOpenedDate).toLocaleDateString("en-GB")} />
                                  <div style={{ marginBottom: "14px" }}>
                                    <div style={{ fontSize: "11px", fontWeight: "600", color: "#9aa0ac", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "2px" }}>
                                      <i className="ti ti-lock" style={{ marginRight: "4px" }} />Password
                                    </div>
                                    <div style={{ fontSize: "14px", color: "#1a1f36", fontWeight: "500", display: "flex", alignItems: "center", gap: "8px" }}>
                                      {showPassword ? decodedPassword : "••••••••"}
                                      <i
                                        className={`ti ${showPassword ? "ti-eye-off" : "ti-eye"}`}
                                        onClick={() => setShowPassword(!showPassword)}
                                        style={{ cursor: "pointer", fontSize: "15px", color: "#9aa0ac" }}
                                      />
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ── Bottom Row: Emergency Contact | Documents ──────────────── */}
                    <div className="row g-3">

                      {/* Emergency Contact */}
                      <div className="col-md-4">
                        <div className="card h-100" style={{ borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                          <div className="card-body p-4">
                            <h6 style={{ fontWeight: "700", color: "#1a1f36", marginBottom: "18px", display: "flex", alignItems: "center", gap: "8px" }}>
                              <i className="ti ti-emergency-bed" style={{ color: "#e53935", fontSize: "18px" }} />
                              Emergency Contact
                            </h6>
                            {[
                              { label: "Name",     value: personalinfo?.emContactName },
                              { label: "Relation", value: personalinfo?.emContactRelation },
                              { label: "Phone 1",  value: personalinfo?.emContactPhone1 },
                              { label: "Phone 2",  value: personalinfo?.emContactPhone2 },
                            ].map(({ label, value }) => (
                              <div key={label} className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: "1px solid #f5f5f5" }}>
                                <span style={{ fontSize: "12px", color: "#9aa0ac", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.4px" }}>{label}</span>
                                <span style={{ fontSize: "13.5px", color: "#1a1f36", fontWeight: "500" }}>{value || <span style={{ color: "#ccc" }}>—</span>}</span>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                      {/* Documents */}
                      <div className="col-md-4">
                        <div className="card h-100" style={{ borderRadius: "12px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
                          <div className="card-body p-4">
                            <h6 style={{ fontWeight: "700", color: "#1a1f36", marginBottom: "18px", display: "flex", alignItems: "center", gap: "8px" }}>
                              <i className="ti ti-file-description" style={{ color: "#4680ff", fontSize: "18px" }} />
                              Documents
                            </h6>
                            {[
                              { label: "CPR Scan",      key: "CPR_scan_doc",   btnText: "View CPR Scan" },
                              { label: "Passport Copy", key: "passport_copy",  btnText: "View Passport" },
                            ].map(({ label, key, btnText }) => (
                              <div key={key} className="d-flex justify-content-between align-items-center py-2" style={{ borderBottom: "1px solid #f5f5f5" }}>
                                <span style={{ fontSize: "12px", color: "#9aa0ac", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.4px" }}>{label}</span>
                                {personalinfo?.[key] ? (
                                  <a
                                    href={`${baseurImage}/${personalinfo[key]}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{ fontSize: "13px", color: "#4680ff", fontWeight: "600", textDecoration: "none" }}
                                  >
                                    {btnText} <i className="ti ti-external-link" style={{ fontSize: "12px" }} />
                                  </a>
                                ) : (
                                  <span style={{ fontSize: "13px", color: "#ccc" }}>Not available</span>
                                )}
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane fade ${activeTab === "dental" ? "show active" : ""
                  }`}
                id="dental"
                role="tabpanel"
                aria-labelledby="dental-tab"
                tabIndex={0}
              >
                <div className="col-12">
                  <Dental
                    patientId={location?.state?.patientid?.id}
                    patientDetails={personalinfo}
                    dateSelectData={dateSelectData}
                    onAddMedicalNote={handlecMedical}
                    dataAllergy={dataAllergy}
                    chronicillness1={chronicillness1}
                    onOpenAllergy={openAllergy}
                    onDeleteAllergy={handleEditAlledelete}
                    onOpenChronicIllness={openChronicillness}
                    onEditChronicIllness={openEditIllness}
                    onDeleteChronicIllness={openEditIllndelet}
                  />
                </div>
              </div>
              <div
                className={`tab-pane fade ${activeTab === "dermatology" ? "show active" : ""}`}
                id="dermatology"
                role="tabpanel"
                aria-labelledby="dermatology-tab"
                tabIndex={0}
              >
                <Derma
                  patientId={location?.state?.patientid?.id}
                  patientDetails={personalinfo}
                  services={services}
                  availableServices={availableServices}
                  handleAddService={handleAddService}
                  handlePrintClick={handlePrintClick}
                  handleEditService={handleEditService}
                  handleDeleteService={handleDeleteService}
                  handleServiceStatusChange={handleServiceStatusChange}
                  prescriptions={dataVitals123}
                  recordLockHours={recordLockHours}
                  dateqq={dateqq}
                  handleAddPrescription={handlemodaldpresctiption}
                  handleViewPrescription={hadlenavigate}
                  handleEditPrescription={handleEditPrescription}
                  handleDeletePrescription={hadlenavigatedelete}
                />
              </div>
              <div
                className={`tab-pane p-0 fade ${activeTab === "Appointment" ? "show active" : ""
                  }`}
                id="Appointment"
                role="tabpanel"
                aria-labelledby="Appointment-tab"
              >
                <div className="d-flex justify-content-end p-3">
                  {showModalDoctor && (
                    <div
                      className="modal fade show"
                      style={{
                        backgroundColor: "rgba(0,0,0,0.5)",
                        display: "block",
                      }}
                    >
                      <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              Edit Appointment
                            </h5>
                          </div>
                          <div className="modal-body appointmentDetails">
                            <div className="row  py-2 ">
                              <div className="col-lg-6">
                                <label className="form-label">
                                  Doctor
                                </label>
                                <select
                                  className={`form-select ${errors.doctorId ? "is-invalid" : ""
                                    }`}
                                  name="doctorId"
                                  value={appointmentdata.doctorId}
                                  onChange={handleChange23}
                                >
                                  <option value="">Select Doctor</option>
                                  {doctors.map((doctor) => (
                                    <option
                                      key={doctor.id}
                                      value={doctor.id}
                                    >
                                      {doctor.displayName}
                                    </option>
                                  ))}
                                </select>
                              </div>

                              <div className="col-lg-6">
                                <label className="form-label">
                                  Appointment Date 
                                </label>
                                <input
                                  type="date"
                                  name="appointmentDate"
                                  className="form-control"
                                  onChange={handleChange23}
                                  value={
                                    appointmentdata?.appointmentDate
                                      ? new Date(
                                        appointmentdata?.appointmentDate
                                      )
                                        .toISOString()
                                        .split("T")[0]
                                      : ""
                                  }
                                />
                              </div>
                              <div className="col-lg-6">
                                <label className="form-label">
                                  Appointment Type
                                </label>
                                <div className="d-flex align-items-center gap-3 mb-3">
                                  <label
                                    className="form-check-label d-flex align-items-center gap-2"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <input
                                      type="checkbox"
                                      name="status"
                                      value="Waiting"
                                      onChange={handleChange23}
                                      style={{ cursor: "pointer" }}
                                      checked={appointmentdata.status?.includes(
                                        "Waiting"
                                      )}
                                    />
                                    Waiting
                                  </label>
                                  <label
                                    className="form-check-label d-flex align-items-center gap-2"
                                    style={{ cursor: "pointer" }}
                                  >
                                    <input
                                      type="checkbox"
                                      name="status"
                                      value="Emergency"
                                      onChange={handleChange23}
                                      style={{ cursor: "pointer" }}
                                      checked={appointmentdata.status?.includes(
                                        "Emergency"
                                      )}
                                    />
                                    Emergency
                                  </label>
                                </div>
                              </div>

                              <div className="col-md-6">
                                <label className="form-label">
                                  Start Time
                                </label>
                                <input
                                  type="time"
                                  className={`form-control ${errors.startTime ? "is-invalid" : ""
                                    }`}
                                  name="startTime"
                                  value={appointmentdata.startTime}
                                  onChange={handleChange23}
                                />
                              </div>
                              <div className="col-md-12">
                                <label className="form-label">
                                  End Time
                                </label>
                                <input
                                  type="time"
                                  className={`form-control ${errors.endTime ? "is-invalid" : ""
                                    }`}
                                  name="endTime"
                                  value={appointmentdata.endTime}
                                  onChange={handleChange23}
                                />
                              </div>
                              <div className="col-lg-12">
                                <label className="form-label">
                                  Notes
                                </label>
                                <input
                                  type="text"
                                  placeholder="Notes"
                                  className={`form-control ${errors.reason ? "is-invalid" : ""
                                    }`}
                                  name="reason"
                                  value={appointmentdata.reason}
                                  onChange={handleChange23}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="d-flex modal-footer justify-content-end">
                            <button
                              type="button"
                              className="cancelText"
                              onClick={handleclose111}
                            >
                              Cancel
                            </button>
                            <button
                              className="bgBtn btn-sm"
                              onClick={() => {
                                handleclickddappointment();
                              }}
                            >
                              Edit Appointment
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                  <button
                    className="bgBtn btn-sm d-flex align-items-center gap-1"
                   style={{ fontSize: 13, padding: "5px 12px" }}
                    onClick={handleclickpopusopenn}
                  >
                    New Appointment
                  </button>
                </div>
                <div className="table-responsive m-0" style={{ fontSize: 13 }}>
                  <table className="table table-sm m-0" id="pc-dt-simple">
                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                      <tr>
                        <th style={{ whiteSpace: "nowrap" }}>#</th>
                        <th style={{ whiteSpace: "nowrap", width: 100 }}>Date</th>
                        <th style={{ whiteSpace: "nowrap" }}>Doctor</th>
                        <th style={{ whiteSpace: "nowrap" }}>Time</th>
                        <th>Reason</th>
                        <th style={{ whiteSpace: "nowrap" }}>Status</th>
                        <th style={{ whiteSpace: "nowrap" }}>No-show Risk</th>
                        <th style={{ whiteSpace: "nowrap" }}>Added By</th>
                        <th style={{ whiteSpace: "nowrap" }}>Branch</th>
                        <th className="text-center" style={{ whiteSpace: "nowrap" }}>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentPatients && currentPatients.length > 0 ? (
                        currentPatients.map((item, index) => {
                          const isLocked = recordLockHours && item.createdAt
                            ? (Date.now() - new Date(item.createdAt).getTime()) > recordLockHours * 60 * 60 * 1000
                            : false;

                          const status = (item.status || "").toLowerCase();
                          const statusConfig = {
                            waiting:   { bg: "#fff8e1", badge: "#f59e0b", label: "Waiting" },
                            scheduled: { bg: "#e8f5e9", badge: "#22c55e", label: "Scheduled" },
                            completed: { bg: "#e8f5e9", badge: "#16a34a", label: "Completed" },
                            cancelled: { bg: "#fef2f2", badge: "#ef4444", label: "Cancelled" },
                            "no show": { bg: "#f3f4f6", badge: "#6b7280", label: "No Show" },
                          };
                          const sc = statusConfig[status] || { bg: "#f0f4ff", badge: "#6366f1", label: item.status || "-" };
                          const riskBadgeConfig = {
                            low: { bg: "#f1f3f5", color: "#5B6B79", label: "Low" },
                            medium: { bg: "#fff3cd", color: "#9c7705", label: "Medium" },
                            high: { bg: "#f8d7da", color: "#a01c2b", label: "High" },
                          };
                          const risk = noShowRiskById[item.id];

                          const branchName = (() => {
                            const branchId = item.branch_id;
                            if (!branchId) return null;
                            if (allBranchSettings && allBranchSettings.length > 0) {
                              const idx = allBranchSettings.findIndex(b => b.id === branchId);
                              if (idx !== -1) return allBranchSettings[idx]?.official_name || `Branch ${idx + 1}`;
                            }
                            const active = JSON.parse(localStorage.getItem('activeBranchSettings') || 'null');
                            if (active && active.id === branchId) return active.official_name || "Main Branch";
                            return `Branch #${branchId}`;
                          })();

                          const startFmt = item?.startTime
                            ? new Date(`1970-01-01T${item.startTime}`).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
                            : null;
                          const endFmt = item?.endTime
                            ? new Date(`1970-01-01T${item.endTime}`).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
                            : null;

                          return (
                            <tr key={index} style={{ backgroundColor: sc.bg, borderLeft: `3px solid ${sc.badge}` }}>
                              <td style={{ color: "#888" }}>{(currentPage - 1) * 10 + index + 1}</td>
                              <td style={{ whiteSpace: "nowrap", fontWeight: 500 }}>
                                {item?.appointmentDate
                                  ? new Date(item.appointmentDate).toLocaleDateString("en-GB")
                                  : "-"}
                              </td>
                              <td style={{ whiteSpace: "nowrap" }}>{item?.displayName || "-"}</td>
                              <td style={{ whiteSpace: "nowrap" }}>
                                {startFmt && endFmt ? `${startFmt} – ${endFmt}` : startFmt || endFmt || "-"}
                              </td>
                              <td style={{ maxWidth: 200, whiteSpace: "normal", wordBreak: "break-word" }}
                                dangerouslySetInnerHTML={{ __html: nl2br(item.reason) }} />
                              <td>
                                <span style={{
                                  display: "inline-block",
                                  padding: "2px 8px",
                                  borderRadius: 10,
                                  backgroundColor: sc.badge,
                                  color: "#fff",
                                  fontSize: 11,
                                  fontWeight: 600,
                                  whiteSpace: "nowrap",
                                }}>
                                  {sc.label}
                                </span>
                              </td>
                              <td>
                                {(item.status === "Booked" || item.status === "Confirmed") && risk ? (
                                  <span
                                    title={risk.reasons?.join(" | ")}
                                    style={{
                                      display: "inline-block",
                                      padding: "2px 8px",
                                      borderRadius: 10,
                                      fontSize: 11,
                                      fontWeight: 600,
                                      whiteSpace: "nowrap",
                                      opacity: risk.confidence === "low" ? 0.6 : 1,
                                      cursor: "default",
                                      ...(riskBadgeConfig[risk.bucket]
                                        ? { backgroundColor: riskBadgeConfig[risk.bucket].bg, color: riskBadgeConfig[risk.bucket].color }
                                        : { backgroundColor: "#f1f3f5", color: "#5B6B79" }),
                                    }}
                                  >
                                    {riskBadgeConfig[risk.bucket]?.label || "Low"}
                                    {risk.confidence === "low" ? " (new)" : ""}
                                  </span>
                                ) : (
                                  <span style={{ color: "#adb5bd", fontSize: 11 }}>—</span>
                                )}
                              </td>
                              <td style={{ whiteSpace: "nowrap", color: "#555" }}>{item.sent_by_name || "-"}</td>
                              <td style={{ whiteSpace: "nowrap", color: "#555" }}>{branchName || "-"}</td>
                              <td className="text-center">
                                <div
                                  style={{ cursor: "pointer" }}
                                  onClick={() => handleclicknavi(item)}
                                  className="viewIcon avtar avtar-xs btn-link-secondary"
                                >
                                  <i className="ti ti-eye f-20" />
                                  <span>View</span>
                                </div>
                                <div
                                  style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.4 : 1, pointerEvents: isLocked ? "none" : "auto" }}
                                  onClick={isLocked ? undefined : () => handlimodalopen(item)}
                                  className="avtar avtar-xs btn-link-secondary editIcon"
                                  title={isLocked ? "Record is locked and cannot be edited" : "Edit"}
                                >
                                  <i className="ti ti-edit f-20" />
                                  <span>Edit</span>
                                </div>
                                <div
                                  style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.4 : 1, pointerEvents: isLocked ? "none" : "auto" }}
                                  className="avtar avtar-xs btn-link-secondary deleteIcon"
                                  onClick={isLocked ? undefined : () => handleclikdeleteapp(item)}
                                  title={isLocked ? "Record is locked and cannot be deleted" : "Delete"}
                                >
                                  <i className="ti ti-trash f-20" />
                                  <span>Delete</span>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="10" className="text-center text-muted py-3">
                            No appointments found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {totalPages > 1 && (
                    <nav className="tablepagination">
                      <ul className="pagination justify-content-end mb-2 me-3">
                        <li
                          className={`page-item ${currentPage === 1 ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              currentPage > 1 &&
                              setCurrentPage(currentPage - 1)
                            }
                          >
                            &laquo;
                          </button>
                        </li>
                        <li className="pageNmbr">{`${currentPage} of ${totalPages}`}</li>
                        <li
                          className={`page-item ${currentPage === totalPages ? "disabled" : ""
                            }`}
                        >
                          <button
                            className="page-link"
                            onClick={() =>
                              currentPage < totalPages &&
                              setCurrentPage(currentPage + 1)
                            }
                          >
                            &raquo;
                          </button>
                        </li>
                      </ul>
                    </nav>
                  )}
                  {/* ── Packages Section ─────────────────────────────── */}
                  <div className="mt-4 px-2 pb-3">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <h6 className="fw-semibold mb-0" style={{ fontSize: 15 }}>
                        <i className="ti ti-package me-2 text-primary"></i>Packages
                      </h6>
                      <button
                        className="bgBtn btn-sm d-flex align-items-center gap-1"
                        style={{ fontSize: 13, padding: "5px 12px" }}
                        onClick={() => setShowAddPackageModal(true)}
                      >
                        <i className="ti ti-plus"></i> Add Package
                      </button>
                    </div>

                    {packagesLoading ? (
                      <div className="text-center py-3 text-muted" style={{ fontSize: 13 }}>Loading packages...</div>
                    ) : packages.length === 0 ? (
                      <div className="text-center py-3 text-muted" style={{ fontSize: 13 }}>No packages found</div>
                    ) : (
                      <div className="d-flex flex-column gap-2">
                        {packages.map(pkg => {
                          const isExpanded = expandedPackage === pkg.id;
                          const progressPct = Math.round((pkg.used_sessions / pkg.total_sessions) * 100);
                          return (
                            <div key={pkg.id} className="card border" style={{ borderRadius: 8 }}>
                              <div
                                className="card-header bg-white d-flex align-items-center justify-content-between py-2 px-3"
                                style={{ cursor: "pointer", borderRadius: 8 }}
                                onClick={() => setExpandedPackage(isExpanded ? null : pkg.id)}
                              >
                                <div className="d-flex align-items-center gap-3">
                                  <i className={`ti ti-chevron-${isExpanded ? "up" : "down"} text-muted`}></i>
                                  <div>
                                    <div className="fw-semibold" style={{ fontSize: 14 }}>{pkg.package_name}</div>
                                    <div className="text-muted" style={{ fontSize: 12 }}>
                                      {pkg.doctor_name ? `Dr. ${pkg.doctor_name}` : "No doctor assigned"}
                                    </div>
                                  </div>
                                </div>
                                <div className="d-flex align-items-center gap-3">
                                  <div style={{ minWidth: 120 }}>
                                    <div className="d-flex justify-content-between mb-1" style={{ fontSize: 12 }}>
                                      <span className="text-muted">Sessions</span>
                                      <span className="fw-semibold">{pkg.used_sessions}/{pkg.total_sessions}</span>
                                    </div>
                                    <div className="progress" style={{ height: 6 }}>
                                      <div
                                        className="progress-bar"
                                        style={{ width: `${progressPct}%`, backgroundColor: pkg.status === "completed" ? "#28a745" : "#4a90e2" }}
                                      ></div>
                                    </div>
                                  </div>
                                  <span className={`badge ${pkg.status === "completed" ? "bg-success" : pkg.status === "cancelled" ? "bg-secondary" : "bg-primary"}`}
                                    style={{ fontSize: 11 }}>
                                    {pkg.status.charAt(0).toUpperCase() + pkg.status.slice(1)}
                                  </span>
                                  <button
                                    className="btn btn-sm"
                                    style={{ color: "#dc3545", background: "transparent", border: "none", padding: "2px 6px" }}
                                    onClick={e => { e.stopPropagation(); handleDeletePackage(pkg.id); }}
                                    title="Delete Package"
                                  >
                                    <i className="ti ti-trash"></i>
                                  </button>
                                </div>
                              </div>

                              {isExpanded && (
                                <div className="card-body p-0">
                                  {pkg.notes && (
                                    <div className="px-3 py-2 text-muted border-bottom" style={{ fontSize: 12 }}>
                                      <i className="ti ti-note me-1"></i>{pkg.notes}
                                    </div>
                                  )}
                                  <table className="table table-sm mb-0" style={{ fontSize: 13 }}>
                                    <thead className="table-light">
                                      <tr>
                                        <th style={{ width: 60 }}>Session</th>
                                        <th>Status</th>
                                        <th>Booked Date</th>
                                        <th>Appointment Date</th>
                                        <th className="text-center">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {pkg.sessions.map(sess => (
                                        <tr key={sess.id}>
                                          <td className="fw-semibold">{sess.session_number} / {pkg.total_sessions}</td>
                                          <td>
                                            {sess.status === "pending" && <span className="badge bg-warning text-dark">Pending</span>}
                                            {sess.status === "booked" && <span className="badge bg-primary">Booked</span>}
                                            {sess.status === "completed" && <span className="badge bg-success">Completed</span>}
                                            {sess.status === "cancelled" && <span className="badge bg-secondary">Cancelled</span>}
                                          </td>
                                          <td>{sess.booked_date ? new Date(sess.booked_date).toLocaleDateString("en-GB") : "-"}</td>
                                          <td>{sess.appointmentDate ? new Date(sess.appointmentDate).toLocaleDateString("en-GB") : "-"}</td>
                                          <td className="text-center">
                                            {sess.status === "pending" && (
                                              <button
                                                className="bgBtn btn-sm d-flex align-items-center gap-1 mx-auto"
                                                style={{ fontSize: 12, padding: "3px 10px" }}
                                                onClick={() => {
                                                  setSelectedSession(sess);
                                                  setBookSessionForm({ appointmentDate: "", startTime: "", endTime: "", doctorId: pkg.doctor_id || "", reason: `${pkg.package_name} : Session ${sess.session_number}/${pkg.total_sessions}`, branchId: parseInt(localStorage.getItem('activeBranchId')) || (allBranchSettings.length === 1 ? String(allBranchSettings[0]?.id) : "") });
                                                  setShowBookSessionModal(true);
                                                }}
                                              >
                                                <i className="ti ti-calendar-plus"></i> Book
                                              </button>
                                            )}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                  {/* ── End Packages Section ──────────────────────────── */}

                  {/* Add Package Modal */}
                  {showAddPackageModal && (
                    <div className="modal fade show" style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}>
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">Add Package</h5>
                            <button className="btn-close" onClick={() => setShowAddPackageModal(false)}></button>
                          </div>
                          <div className="modal-body">
                            <div className="mb-3">
                              <label className="form-label">Package Name <span className="text-danger">*</span></label>
                              <input className="form-control" value={packageForm.package_name}
                                onChange={e => setPackageForm(f => ({ ...f, package_name: e.target.value }))}
                                placeholder="e.g. Physiotherapy, Dental Cleaning" />
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Number of Sessions <span className="text-danger">*</span></label>
                              <input type="number" min="1" className="form-control" value={packageForm.total_sessions}
                                onChange={e => setPackageForm(f => ({ ...f, total_sessions: e.target.value }))} />
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Doctor (optional)</label>
                              <select className="form-select" value={packageForm.doctor_id}
                                onChange={e => setPackageForm(f => ({ ...f, doctor_id: e.target.value }))}>
                                <option value="">-- No doctor assigned --</option>
                                {doctors.map(d => (
                                  <option key={d.id} value={d.id}>{d.fullName}</option>
                                ))}
                              </select>
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Notes (optional)</label>
                              <textarea className="form-control" rows={2} value={packageForm.notes}
                                onChange={e => setPackageForm(f => ({ ...f, notes: e.target.value }))} />
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button className="cancelText btn" onClick={() => setShowAddPackageModal(false)}>Cancel</button>
                            <button className="bgBtn btn-sm d-flex align-items-center gap-1"
                              style={{ fontSize: 13, padding: "5px 12px" }}
                              onClick={handleCreatePackage}
                              disabled={!packageForm.package_name || !packageForm.total_sessions}>
                              <i className="ti ti-check"></i> Create Package
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Book Session Modal */}
                  {showBookSessionModal && selectedSession && (
                    <div className="modal fade show" style={{ backgroundColor: "rgba(0,0,0,0.5)", display: "block" }}>
                      <div className="modal-dialog">
                        <div className="modal-content">
                          <div className="modal-header">
                            <h5 className="modal-title">
                              Book Session {selectedSession.session_number}
                            </h5>
                            <button className="btn-close" onClick={() => setShowBookSessionModal(false)}></button>
                          </div>
                          <div className="modal-body">
                            <div className="mb-3">
                              <label className="form-label">Appointment Date <span className="text-danger">*</span></label>
                              <input type="date" className="form-control" value={bookSessionForm.appointmentDate}
                                onChange={e => setBookSessionForm(f => ({ ...f, appointmentDate: e.target.value }))} />
                            </div>
                            <div className="row">
                              <div className="col-6 mb-3">
                                <label className="form-label">Start Time</label>
                                <input type="time" className="form-control" value={bookSessionForm.startTime}
                                  onChange={e => setBookSessionForm(f => ({ ...f, startTime: e.target.value }))} />
                              </div>
                              <div className="col-6 mb-3">
                                <label className="form-label">End Time</label>
                                <input type="time" className="form-control" value={bookSessionForm.endTime}
                                  onChange={e => setBookSessionForm(f => ({ ...f, endTime: e.target.value }))} />
                              </div>
                            </div>
                            <div className="mb-3">
                              <label className="form-label">Doctor</label>
                              <select className="form-select" value={bookSessionForm.doctorId}
                                onChange={e => setBookSessionForm(f => ({ ...f, doctorId: e.target.value }))}>
                                <option value="">-- Select doctor --</option>
                                {doctors.map(d => (
                                  <option key={d.id} value={d.id}>{d.fullName}</option>
                                ))}
                              </select>
                            </div>
                            {allBranchSettings.length > 1 && (
                              <div className="mb-3">
                                <label className="form-label">Branch <span className="text-danger">*</span></label>
                                <select className="form-select" value={bookSessionForm.branchId}
                                  onChange={e => setBookSessionForm(f => ({ ...f, branchId: e.target.value }))}>
                                  <option value="">-- Select branch --</option>
                                  {allBranchSettings.map(b => (
                                    <option key={b.id} value={b.id}>{b.name || b.clinic_name}</option>
                                  ))}
                                </select>
                              </div>
                            )}
                            <div className="mb-3">
                              <label className="form-label">Reason / Notes</label>
                              <input className="form-control" value={bookSessionForm.reason}
                                onChange={e => setBookSessionForm(f => ({ ...f, reason: e.target.value }))}
                                placeholder="Optional session notes" />
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button className="cancelText btn" onClick={() => setShowBookSessionModal(false)}>Cancel</button>
                            <button className="bgBtn btn-sm d-flex align-items-center gap-1"
                              style={{ fontSize: 13, padding: "5px 12px" }}
                              onClick={handleBookSession}
                              disabled={!bookSessionForm.appointmentDate}>
                              <i className="ti ti-calendar-check"></i> Book Session
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {addpatinemodal && (
                    <div
                      className="modal fade show"
                      style={{
                        backgroundColor: "rgba(81, 81, 81, 0.5)",
                        display: "block",
                      }}
                    >
                      <div className="modal-dialog modal-lg">
                        <div
                          className="modal-content"
                          style={{ borderRadius: 12, border: "1px solid #e8ecf0", overflow: "hidden" }}
                        >
                          <div className="modal-header mn-header">
                            <div className="d-flex align-items-center gap-2">
                              <i className="ti ti-calendar-plus mn-header-icon"></i>
                              <div>
                                <div className="mn-title">New Appointment</div>
                                <div className="mn-subtitle">Schedule an appointment for this patient</div>
                              </div>
                            </div>
                            <button
                              className="mn-close-btn"
                              onClick={handleclickpopusopenn11}
                              type="button"
                              aria-label="Close"
                            >
                              <i className="ti ti-x"></i>
                            </button>
                          </div>
                          <div className="modal-body" style={{ padding: "20px 24px" }}>
                            {/* Doctor & Date */}
                            <div
                              style={{
                                fontSize: 11, fontWeight: 700, color: "#5B6B79", textTransform: "uppercase",
                                letterSpacing: "0.07em", marginBottom: 10, paddingBottom: 6, borderBottom: "1px solid #f0f2f5",
                              }}
                            >
                              Doctor & Date
                            </div>
                            <div className="row" style={{ marginBottom: 18 }}>
                              {formData1.status !== "Waiting" && (
                                <div className="col-lg-6 mb-3 mb-lg-0">
                                  <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 5 }}>
                                    Doctor<span style={{ color: "#e74c3c", marginLeft: 2 }}>*</span>
                                  </label>
                                  <select
                                    className={`form-select ${errors.doctorId ? "is-invalid" : ""}`}
                                    name="doctorId"
                                    value={formData1.doctorId}
                                    onChange={handleChange1}
                                    style={{ fontSize: 13, borderColor: "#d0d5dd", borderRadius: 8, lineHeight: 1.5 }}
                                  >
                                    <option value="">Select Doctor</option>
                                    {doctors1.map((doctor) => (
                                      <option key={doctor.id} value={doctor.id}>
                                        {doctor.displayName}
                                      </option>
                                    ))}
                                  </select>
                                  <div className="invalid-feedback">{errors.doctorId}</div>
                                </div>
                              )}
                              <div className={formData1.status === "Waiting" ? "col-lg-12" : "col-lg-6"}>
                                <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 5 }}>
                                  Appointment Date<span style={{ color: "#e74c3c", marginLeft: 2 }}>*</span>
                                </label>
                                <input
                                  type="date"
                                  className={`form-control ${errors?.appointmentDate ? "is-invalid" : ""}`}
                                  name="appointmentDate"
                                  value={formData1?.appointmentDate}
                                  onChange={handleChange1}
                                  min={new Date().toISOString().split("T")[0]}
                                  style={{ height: 36, fontSize: 13, borderColor: "#d0d5dd", borderRadius: 8 }}
                                />
                                <div className="invalid-feedback">{errors?.appointmentDate}</div>
                              </div>
                            </div>

                            {/* Appointment Type */}
                            <div
                              style={{
                                fontSize: 11, fontWeight: 700, color: "#5B6B79", textTransform: "uppercase",
                                letterSpacing: "0.07em", marginBottom: 10, paddingBottom: 6, borderBottom: "1px solid #f0f2f5",
                              }}
                            >
                              Appointment Type
                            </div>
                            <div style={{ display: "flex", gap: 8, marginBottom: 18, flexWrap: "wrap" }}>
                              {[
                                { value: "Waiting", label: "Waiting", icon: "ti-clock", color: "#f39c12" },
                                { value: "Emergency", label: "Emergency", icon: "ti-urgent", color: "#e74c3c" },
                              ].map(({ value, label, icon, color }) => {
                                const active = formData1.status === value;
                                return (
                                  <button
                                    key={value}
                                    type="button"
                                    onClick={() =>
                                      handleChange1({
                                        target: { name: "status", value: active ? "" : value },
                                      })
                                    }
                                    style={{
                                      padding: "6px 14px", borderRadius: 20, border: `1.5px solid ${color}`,
                                      background: active ? color : "transparent", color: active ? "#fff" : color,
                                      cursor: "pointer", fontSize: 12, fontWeight: 500,
                                      display: "flex", alignItems: "center", gap: 5, transition: "all 0.15s",
                                    }}
                                  >
                                    <i className={`ti ${icon}`} style={{ fontSize: 13 }} />
                                    {label}
                                  </button>
                                );
                              })}
                              <div style={{ fontSize: 11, color: "#9CA3AF", alignSelf: "center" }}>
                                {formData1.status === "Waiting" && "Patient waits in queue — no time slot needed."}
                                {formData1.status === "Emergency" && "Urgent — will be prioritised."}
                                {!formData1.status && "Leave blank for a regular scheduled appointment."}
                              </div>
                            </div>

                            {/* Time Slot */}
                            {formData1.status !== "Waiting" && (
                              <>
                                <div
                                  style={{
                                    fontSize: 11, fontWeight: 700, color: "#5B6B79", textTransform: "uppercase",
                                    letterSpacing: "0.07em", marginBottom: 10, paddingBottom: 6, borderBottom: "1px solid #f0f2f5",
                                  }}
                                >
                                  Time Slot
                                </div>
                                <div className="row" style={{ marginBottom: 18 }}>
                                  <div className="col-md-6 mb-3 mb-md-0">
                                    <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 5 }}>
                                      Start Time<span style={{ color: "#e74c3c", marginLeft: 2 }}>*</span>
                                    </label>
                                    <input
                                      type="time"
                                      className={`form-control ${errors.startTime ? "is-invalid" : ""}`}
                                      name="startTime"
                                      value={formData1.startTime}
                                      onChange={handleChange1}
                                      style={{ height: 36, fontSize: 13, borderColor: "#d0d5dd", borderRadius: 8 }}
                                    />
                                    <div className="invalid-feedback">{errors.startTime}</div>
                                  </div>
                                  <div className="col-md-6">
                                    <label style={{ fontSize: 12, fontWeight: 600, color: "#374151", display: "block", marginBottom: 5 }}>
                                      End Time<span style={{ color: "#e74c3c", marginLeft: 2 }}>*</span>
                                    </label>
                                    <input
                                      type="time"
                                      className={`form-control ${errors.endTime ? "is-invalid" : ""}`}
                                      name="endTime"
                                      value={formData1.endTime}
                                      onChange={handleChange1}
                                      style={{ height: 36, fontSize: 13, borderColor: "#d0d5dd", borderRadius: 8 }}
                                    />
                                    <div className="invalid-feedback">{errors.endTime}</div>
                                  </div>
                                </div>
                              </>
                            )}

                            {/* Notes */}
                            <div
                              style={{
                                fontSize: 11, fontWeight: 700, color: "#5B6B79", textTransform: "uppercase",
                                letterSpacing: "0.07em", marginBottom: 10, paddingBottom: 6, borderBottom: "1px solid #f0f2f5",
                              }}
                            >
                              Notes
                            </div>
                            <div className="row">
                              <div className="col-lg-12">
                                <input
                                  type="text"
                                  className={`form-control ${errors.reason ? "is-invalid" : ""}`}
                                  name="reason"
                                  value={formData1.reason}
                                  onChange={handleChange1}
                                  placeholder="e.g. Follow-up, checkup, consultation…"
                                  style={{ fontSize: 13, borderColor: "#d0d5dd", borderRadius: 8 }}
                                />
                                <div className="invalid-feedback">{errors.reason}</div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="modal-footer justify-content-end"
                            style={{ borderTop: "1px solid #f0f2f5" }}
                          >
                            <button
                              type="button"
                              className="cancelBtn"
                              onClick={handleclickpopusopenn11}
                              style={{ padding: "6px 16px", fontSize: 13 }}
                            >
                              Cancel
                            </button>
                            <button
                              className="bgBtn"
                              onClick={handleSubmit}
                              style={{ padding: "6px 16px", fontSize: 13 }}
                            >
                              <i className="ti ti-calendar-check me-1"></i>
                              Book
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div
                className={`tab-pane p-0 fade ${activeTab === "labs" ? "show active" : ""
                  }`}
                id="labs"
                role="labs"
                aria-labelledby="lab-tab"
              >
                <div className="d-sm-flex align-items-center justify-content-between p-3">
                  <div className="tableSearch">
                    <input
                      type="text"
                      placeholder="Search by name, or mobile"
                      className="form-control"
                      value={labSearch}
                      onChange={(e) => setLabSearch(e.target.value)}
                    />
                    <span className="searchIcon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="gray"
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "10px",
                          transform: "translateY(-50%)",
                          pointerEvents: "none",
                        }}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                        />
                      </svg>
                    </span>
                  </div>
                  <div className="tableHeaderBtn">
                    <button
                      className="bgBtn btn-sm d-flex align-items-center gap-1"
                      style={{ fontSize: 13, padding: "5px 12px" }}
                      onClick={handleclickopentestadd}
                    >
                      <i className="fas fa-plus"></i>
                      Add Test
                    </button>
                  </div>
                </div>
                <div className="pb-0">
                  <div className="table-responsive serviceTable">
                    <table className="table m-0">
                      <thead>
                        <tr>
                          <th>Date</th>
                          <th>Lab Name</th>
                          <th>Title</th>
                          <th>Description</th>
                          <th>Added By</th>
                          <th>Status</th>
                          <th className="text-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredLabs.length > 0 ? (
                          filteredLabs.map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <tr>
                                  <td>{item.request_date}</td>
                                  <td>{item.lab_name}</td>

                                  <td>{item.title}</td>
                                  <td>{item.description}</td>
                                  <td>{item.doctor_name}</td>
                                  <td>
                                    {item.status ||
                                      item.report_status ||
                                      "-"}
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2 justify-content-center">
                                      <div
                                        onClick={() =>
                                          handleLabView(item)
                                        }
                                        style={{ cursor: "pointer" }}
                                        className="avtar avtar-xs btn-link-secondary viewIcon"
                                      >
                                        <i className="ti ti-eye f-20" />
                                        <span>View</span>
                                      </div>
                                      <div
                                        onClick={() =>
                                          handleLabEdit(item)
                                        }
                                        style={{ cursor: "pointer" }}
                                        className="avtar avtar-xs btn-link-secondary editIcon"
                                      >
                                        <i className="ti ti-edit f-20" />
                                        <span>Edit</span>
                                      </div>
                                      <div
                                        style={{ cursor: "pointer" }}
                                        className="avtar avtar-xs btn-link-secondary deleteIcon"
                                        onClick={() =>
                                          handleLabDelete(item)
                                        }
                                      >
                                        <i className="ti ti-trash f-20" />
                                        <span>Delete</span>
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    Service
                                  </td>
                                  <td colSpan={10} className="wrapText">
                                    {item.services &&
                                      item.services.length > 0 ? (
                                      <div className="d-flex flex-wrap gap-1">
                                        <span>
                                          {item.services
                                            .slice(0, 2)
                                            .map(service => service.serviceName)
                                            .join(", ")}
                                        </span>
                                        {item.services.length > 2 && (
                                          <span
                                            className="badge bg-primary"
                                            style={{
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              handleSeeMoreServices(
                                                item.services
                                              )
                                            }
                                          >
                                            +{item.services.length - 2}{" "}
                                            More
                                          </span>
                                        )}
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                </tr>
                              </React.Fragment>

                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="10" className="text-center">
                              No request found.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                {openmodaltest && (
                  <div
                    className="modal fade show"
                    tabIndex="-1"
                    style={{
                      backgroundColor: "rgba(81, 81, 81, 0.5)",
                      display: "block",
                    }}
                    aria-modal="true"
                  >
                    <div className="modal-dialog modal-dialog-scrollable addTestModal" style={{ maxWidth: "960px" }}>
                      <style>{`
                        .addTestModal .form-control,
                        .addTestModal .form-select {
                          font-size: 12px;
                          height: 32px;
                          padding: 4px 10px;
                        }
                        .addTestModal textarea.form-control {
                          height: auto;
                        }
                        .addTestModal .form-label {
                          font-size: 11px;
                          margin-bottom: 4px;
                        }
                      `}</style>
                      <div className="modal-content">
                        <div className="modal-header" style={{ background: "#E8F0FE" }}>
                          <h5 className="modal-title d-flex align-items-center gap-2" style={{ color: "#1A3A70" }}>
                            <i className="ti ti-flask f-18" />
                            Add Test
                          </h5>
                        </div>
                        <div className="modal-body">
                          <div className="row">
                            <div className="col-md-6">
                              <label className="form-label">
                                Title
                              </label>
                              <input
                                type="text"
                                name="title"
                                onChange={handlechange}
                                placeholder="Title"
                                className="form-control"
                              />
                            </div>
                            <div className="col-md-6">
                              <label className="form-label">
                                Description
                              </label>
                              <textarea
                                type="text"
                                name="description"
                                placeholder="Description"
                                onChange={handlechange}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-6">
                              <label className="form-label">
                                Select Lab
                              </label>
                              <select
                                className="form-select"
                                name="category"
                                value={inpval.category || ""}
                                onChange={handlechange}
                              >
                                {data2 &&
                                  data2 &&
                                  data2.map((item, index) => {
                                    return (
                                      <>
                                        <option
                                          key={index}
                                          value={item.id}
                                        >
                                          {item.lab_name}
                                        </option>
                                      </>
                                    );
                                  })}
                              </select>
                            </div>
                            <div className="col-md-6">
                              <label className="form-label">
                                Select Doctor
                              </label>
                              <select
                                name="doctor_id"
                                onChange={handlechange}
                                className="form-control"
                                value={inpval.doctor_id || ""}
                              >
                                <option value="">Select Doctor</option>
                                {enhancedDoctors.map((doc, index) => (
                                  <option key={index} value={doc.id}>
                                    {doc.displayName || doc.fullName || doc.name}
                                    {doc.isLoggedInUser ? "" : ""}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12 autoComplete">
                              <label className="form-label">
                                Select Services
                              </label>
                              <Autocomplete
                                id="services-selection"
                                multiple
                                options={labServices || []}
                                isOptionEqualToValue={(option, value) => option.id === value.id}
                                getOptionLabel={(option) => {
                                  const serviceName =
                                    option.serviceName ||
                                    option.service ||
                                    option.name ||
                                    "Unknown Service";
                                  const category =
                                    option.category || "";
                                  const price = option.price
                                    ? `${Number(option.price).toFixed(3)} BHD`
                                    : "";
                                  let label = serviceName;
                                  if (category)
                                    label += ` (${category})`;
                                  if (price) label += ` - ${price}`;
                                  return label;
                                }}
                                value={selectedServices}
                                onChange={handleServicesChange}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    placeholder="Search and select services..."
                                  />
                                )}
                                noOptionsText="No services found"
                                loadingText="Loading services..."
                                disabled={
                                  labServices.length === 0 ||
                                  !inpval.category
                                }
                                renderOption={(props, option) => {
                                  const serviceName =
                                    option.serviceName ||
                                    option.service ||
                                    option.name ||
                                    "Unknown Service";
                                  const category =
                                    option.category || "";
                                  const price = option.price || 0;
                                  return (
                                    <li {...props}>
                                      <div>
                                        <strong>{serviceName}</strong>
                                        {category && (
                                          <small className="text-muted d-block">
                                            Category: {category}
                                          </small>
                                        )}
                                        {price > 0 && (
                                          <small className="text-success d-block">
                                            Price: {price} BHD
                                          </small>
                                        )}
                                      </div>
                                    </li>
                                  );
                                }}
                              />
                            </div>
                          </div>
                          {/* Price summary and discount section */}
                          {selectedServices.length > 0 && (
                            <div className="row mt-3">
                              <div className="col-md-12">
                                <div className="card" style={{ background: "#FFF8E1", border: "1px solid #7A5C00" }}>
                                  <div className="card-body">
                                    <h6 className="card-title mb-3" style={{ color: "#7A5C00" }}>
                                      <i className="ti ti-calculator me-2"></i>
                                      Price Summary
                                    </h6>
                                    <div className="mb-3">
                                      {selectedServices.map((s) => {
                                        const serviceName = s.serviceName || s.service || s.name || "Unknown Service";
                                        const price = companyLabPriceMap[s.id] ?? Number(s.price) ?? 0;
                                        const qty = parseInt(s.quantity, 10) || 1;
                                        return (
                                          <div key={s.id} className="d-flex justify-content-between align-items-center" style={{ fontSize: 13, padding: "3px 0" }}>
                                            <span>{serviceName}{s.category ? ` (${s.category})` : ''}</span>
                                            <span className="d-flex align-items-center" style={{ gap: 8 }}>
                                              <span>{price.toFixed(3)} BHD</span>
                                              <span className="text-muted">×</span>
                                              <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                style={{ width: 60 }}
                                                min="1"
                                                value={qty}
                                                onChange={(e) => handleServiceQuantityChange(s.id, e.target.value)}
                                              />
                                              <span className="fw-semibold" style={{ minWidth: 70, textAlign: "right" }}>
                                                {(price * qty).toFixed(3)} BHD
                                              </span>
                                            </span>
                                          </div>
                                        );
                                      })}
                                    </div>
                                    <div className="row g-3">
                                      <div className="col-md-3">
                                        <label className="form-label text-muted small">Total Price</label>
                                        <div className="h5 fw-bold" style={{ color: "#7A5C00" }}>
                                          {testTotalPrice.toFixed(3)} BHD
                                        </div>
                                      </div>
                                      <div className="col-md-3">
                                        <label className="form-label small">Discount Type</label>
                                        <select
                                          className="form-select form-select-sm"
                                          value={inpval.discount_type || "Amount"}
                                          onChange={handleDiscountTypeChange}
                                        >
                                          <option value="Amount">By Amount (BHD)</option>
                                          <option value="Percentage">By Percentage (%)</option>
                                        </select>
                                      </div>
                                      <div className="col-md-3">
                                        <label className="form-label small">
                                          Discount Value
                                          {inpval.discount_type === "Percentage" && globalDiscountLimit > 0 && (
                                            <small className="text-muted ms-1">(Max: {globalDiscountLimit}%)</small>
                                          )}
                                        </label>
                                        <input
                                          type="number"
                                          className="form-control form-control-sm"
                                          min="0"
                                          value={inpval.discount_value || ""}
                                          onChange={handleDiscountValueChange}
                                        />
                                      </div>
                                      <div className="col-md-3">
                                        <label className="form-label text-muted small">Net Amount</label>
                                        <div className="h5 text-success fw-bold">
                                          {testNetAmount.toFixed(3)} BHD
                                        </div>
                                        {testDiscountAmont > 0 && (
                                          <small className="text-success">
                                            You save {testDiscountAmont.toFixed(3)} BHD
                                          </small>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                          <div className="row">
                            <div className="col-md-12">
                              <label className="form-label">
                                Attachment
                              </label>
                              <input
                                type="file"
                                name="file"
                                onChange={handlechange}
                                className="form-control"
                                accept="image/*,application/pdf,.doc,.docx"
                              />
                              {inpval.file && (
                                <small className="text-muted">
                                  Selected file: {inpval.file.name}
                                </small>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="modal-footer justify-content-end">
                          <button
                            type="button"
                            className="cancelText"
                            onClick={closeModaladdtest}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="bgBtn btn-sm"
                            onClick={handletest}
                          >
                            Add test
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
                {serviceListModal && (
                  <div
                    className="modal fade show"
                    style={{
                      backgroundColor: "rgba(0,0,0,0.5)",
                      display: "block",
                      zIndex: 1055,
                    }}
                  >
                    <div className="modal-dialog modal-md">
                      <div className="modal-content">
                        <div className="modal-header">
                          <h5 className="modal-title">Lab Services</h5>
                          <button
                            type="button"
                            className="btn-close"
                            onClick={() => setServiceListModal(false)}
                          ></button>
                        </div>
                        <div className="modal-body">
                          <ul className="list-group">
                            {selectedServicesForModal.map(
                              (service, index) => (
                                <li
                                  key={index}
                                  className="list-group-item d-flex justify-content-between align-items-center"
                                >
                                  {service.serviceName}
                                  {service.category && (
                                    <span className="badge bg-secondary rounded-pill">
                                      {service.category}
                                    </span>
                                  )}
                                </li>
                              )
                            )}
                          </ul>
                        </div>
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="cancelText"
                            onClick={() => setServiceListModal(false)}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <VitalSignsTab
                activeTab={activeTab}
                patinetvitals={patinetvitals}
                formData={formData}
                handleChange={handleChange}
                calculateBMI={calculateBMI}
                openmodalforvital={openmodalforvital}
                openmodalforvital1={openmodalforvital1}
                openVital={openVital}
                handleclickopenvital={handleclickopenvital}
                handleclickpen={handleclickpen}
                handleclickpen123={handleclickpen123}
                handleclickdeletevital={handleclickdeletevital}
                handlecloseVitaledit={handlecloseVitaledit}
                handdeditvital={handdeditvital}
                handlecloseVitaleditclose={handlecloseVitaleditclose}
                handlecloseVital={handlecloseVital}
                handleapisubmit={handleapisubmit}
                isSubmitting={isSubmitting}
                nurseName={nurseName}
                date={date}
                time={time}
              />
              <div
                className={`tab-pane p-0 fade ${activeTab === "medicalhistory" ? "show active" : ""
                  }`}
                id="medicalhistory"
                role="tabpanel"
                aria-labelledby="medicalhistory-tab"
              >

                <div className="col-12">
                  <div>
                    <div className="tableHeader mh-visit-toolbar">
                      <div className="d-sm-flex align-items-center justify-content-between flex-flow-row mh-visit-toolbar-row">
                        <div className="mh-visit-bar">
                          <button
                            className={'mh-visit-chip mh-visit-chip-all' + (dateqq === null ? ' active' : '')}
                            onClick={() => handledategetsaddt(null)}>
                            <i className="ti ti-list-details"></i>
                            All Visits
                          </button>
                          {visitChips &&
                            visitChips.length > 0 &&
                            visitChips.slice().sort((a, b) => new Date(b.appointmentDate) - new Date(a.appointmentDate)).map((item, index) => {
                              const onlyDate = moment(item?.appointmentDate, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YYYY");
                              const onlyDate2 = moment(item?.appointmentDate, "YYYY-MM-DDTHH:mm:ss").format("YYYY-MM-DD");
                              const visitTime = item?.startTime ? moment(item.startTime, "HH:mm:ss").format("hh:mm A") : null;
                              const isActive = item?.appointment_id != null
                                ? appointmentqq === item.appointment_id
                                : dateqq === onlyDate2 && String(doctorqq ?? '') === String(item?.doctor_id ?? '');
                              return (
                                <button key={item?.appointment_id ?? `${onlyDate2}-${item?.doctor_id ?? 'na'}-${index}`}
                                  className={'mh-visit-chip' + (isActive ? ' active' : '')}
                                  onClick={() => handledategetsaddt(onlyDate2, item?.doctor_id ?? null, item?.appointment_id ?? null)}
                                  title={[onlyDate, visitTime, item?.doctor_name].filter(Boolean).join(' — ')}
                                >
                                  <span className="mh-visit-date">
                                    <i className="ti ti-calendar-event"></i>
                                    {onlyDate}
                                    {visitTime && <small className="ms-1">{visitTime}</small>}
                                  </span>
                                  {item?.doctor_name && (
                                    <span className="mh-visit-doctor">
                                      <i className="ti ti-stethoscope"></i>
                                      {item.doctor_name}
                                    </span>
                                  )}
                                </button>
                              );
                            })}
                        </div>
                        <div className="mh-visit-actions">
                          <button
                            className="mh-action-btn"
                            onClick={handlecMedical}
                          >
                            <i className="fas fa-plus"></i>
                            Medical Notes
                          </button>
                          <button
                            className="mh-action-btn mh-action-btn-outline"
                            onClick={generateMedicalReport}
                          >
                            <i className="fas fa-print"></i>
                            Print
                          </button>
                        </div>
                        {openMedical && createPortal(
                          <div
                            className="modal fade show"
                            style={{
                              backgroundColor: "rgba(81, 81, 81, 0.5)",
                              display: "block",
                            }}
                          >
                            <div className="modal-dialog modal-dialog-scrollable modal-xl addMedicalF">
                              <div className="modal-content mn-modal-content">
                                <div className="modal-header mn-header">
                                  <div className="d-flex align-items-center gap-2">
                                    <i className="ti ti-notes-medical mn-header-icon"></i>
                                    <div>
                                      <div className="mn-title">Medical Notes</div>
                                      <div className="mn-subtitle">
                                        {personalinfo?.firstName} {personalinfo?.lastName}
                                        {selectedVisit && (
                                          <>
                                            {" · "}
                                            {moment(selectedVisit.appointmentDate, "YYYY-MM-DDTHH:mm:ss").format("DD/MM/YYYY")}
                                            {selectedVisit.startTime
                                              ? ` ${moment(selectedVisit.startTime, "HH:mm:ss").format("hh:mm A")}`
                                              : ""}
                                            {selectedVisit.doctor_name ? ` · ${selectedVisit.doctor_name}` : ""}
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                  <button className="mn-close-btn" onClick={handlecloseMedical} type="button" aria-label="Close">
                                    <i className="ti ti-x"></i>
                                  </button>
                                </div>
                                <div className="modal-body mn-body">
                                  <div className="row h-100">
                                    <div className="col-lg-2 col-md-3 mn-sidebar">
                                      <MedicalTemplateList onSelect={handleSelectNotesTemplate} templateType="medical_notes" />
                                    </div>
                                    <div className="col-lg-10 col-md-9">
                                      <div className="row notesList g-2">
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-message-2"></i>Chief Complaint{" "}
                                            <span className="text-danger">*</span>
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue}
                                              onChange={handleChange1111}
                                              onBlur={() => setTimeout(() => { setSuggestions([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick(item.text)}>{item?.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>

                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-notes"></i>History of Present Illness{" "}
                                            <span className="text-danger">*</span>
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue1}
                                              onChange={handleChange11111}
                                              onBlur={() => setTimeout(() => { setSuggestions1([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions1.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions1.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick1(item?.text)}>{item?.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-clock"></i>History of Past Illness
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue2}
                                              onChange={handleChange1112}
                                              onBlur={() => setTimeout(() => { setSuggestions2([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions2.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions2.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick2(item?.text)}>{item?.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-user-check"></i>Examination [General]
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue3}
                                              onChange={handleChange1113}
                                              onBlur={() => setTimeout(() => { setSuggestions3([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions3.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions3.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick3(item?.text)}>{item?.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-heart"></i>Examination [Systemic]
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue4}
                                              onChange={handleChange1114}
                                              onBlur={() => setTimeout(() => { setSuggestions4([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions4.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions4.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick4(item?.text)}>{item?.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-zoom-check"></i>Examination [Local]{" "}
                                            <span className="text-danger">*</span>
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue5}
                                              onChange={handleChange1115}
                                              onBlur={() => setTimeout(() => { setSuggestions5([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control w-100"
                                            />
                                            {suggestions5.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions5.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick5(item?.text)}>{item?.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>

                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-pill"></i>Treatment Plan
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue6}
                                              onChange={handleChange1116}
                                              onBlur={() => setTimeout(() => { setSuggestions6([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions6.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions6.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick6(item?.text)}>{item?.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-bulb"></i>Advises
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue7}
                                              onChange={handleChange1117}
                                              onBlur={() => setTimeout(() => { setSuggestions7([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions7.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions7.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick7(item.text)}>{item.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-pencil"></i>Extra Notes
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue8}
                                              onChange={handleChange1118}
                                              onBlur={() => setTimeout(() => { setSuggestions8([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions8.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions8.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick8(item.text)}>{item.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-users"></i>Family History
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue10}
                                              onChange={handleChange111910}
                                              onBlur={() => setTimeout(() => { setSuggestions10([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions10.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions10.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick10(item.text)}>{item.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>
                                        <div
                                          className="col-md-6"
                                          style={{ position: "relative" }}
                                        >
                                          <label className="form-label mn-label">
                                            <i className="ti ti-brain"></i>Psychosocial
                                          </label>
                                          <div style={{ position: "relative" }}>
                                            <textarea
                                              value={inputValue111}
                                              onChange={handleChange1119111}
                                              onBlur={() => setTimeout(() => { setSuggestions111([]); }, 200)}
                                              placeholder="Type to search suggestions or enter text..."
                                              className="form-control"
                                            />
                                            {suggestions111.length > 0 && (
                                              <ul style={{ background: "white", border: "1px solid #ccc", zIndex: 10000, width: "100%", maxHeight: "180px", overflowY: "auto", padding: 0, listStyle: "none", margin: 0, boxShadow: "0px 2px 5px rgba(0,0,0,0.2)", position: "absolute", top: "100%", left: 0 }}>
                                                {suggestions111.map((item, index) => (
                                                  <li key={item.id || index} style={{ padding: "8px", cursor: "pointer", borderBottom: "1px solid #eee", backgroundColor: "#fff" }} onClick={() => handleSuggestionClick111(item.text)}>{item.text}</li>
                                                ))}
                                              </ul>
                                            )}
                                          </div>
                                        </div>

                                        <div className="col-md-6">
                                          <label className="form-label mn-label">
                                            <i className="ti ti-activity-heartbeat"></i>Pain Assessment
                                          </label>
                                          {medicalNotes?.pain_assessment}
                                          {/* <input
                                        type="range"
                                        className="form-control"
                                        placeholder="Range 1 to 10"
                                        min="1"
                                        max="10"
                                        style={{ cursor: "pointer" }}
                                        name="pain_assessment"
                                        onChange={hhandlechangeaddnotes}
                                        id="vol"
                                      ></input> */}
                                          <Box>
                                            <Slider
                                              aria-label="Pain Assessment"
                                              name="pain_assessment"
                                              value={medicalNotes?.pain_assessment || 0}
                                              min={0}
                                              max={10}
                                              step={1}
                                              valueLabelDisplay="auto"
                                              onChange={handlePainAssessmentChange}
                                              marks={marks1}
                                              sx={{
                                                color: "#2a5478",
                                                height: 4,
                                                "& .MuiSlider-rail": {
                                                  height: 4,
                                                  borderRadius: 4,
                                                  backgroundColor: "rgba(42,84,120,0.15)",
                                                },
                                                "& .MuiSlider-track": {
                                                  height: 4,
                                                  borderRadius: 4,
                                                },
                                                "& .MuiSlider-thumb": {
                                                  height: 16,
                                                  width: 16,
                                                  backgroundColor: "#2a5478",
                                                  border: "2px solid white",
                                                  boxShadow: "0 1px 4px rgba(42,84,120,0.35)",
                                                },
                                                "& .MuiSlider-markLabel": {
                                                  fontSize: 10,
                                                  color: "#6b7280",
                                                },
                                              }}
                                            />
                                          </Box>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="modal-footer mn-footer justify-content-end">
                                  <button
                                    className="cancelText"
                                    onClick={handlecloseMedical}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="bgBtn btn-sm mn-save-btn"
                                    onClick={apihitmedical}
                                  >
                                    <i className="ti ti-check"></i> Save Notes
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        , document.body)}
                      </div>
                    </div>
                    <div id="pdfContent" style={{ padding: "20px" }}>
                      <div className="p20">
                        <div className="mh-section">
                          <span className="mh-section-badge"><i className="ti ti-stethoscope"></i>Patient Baseline</span>
                          <div className="mh-section-line" />
                        </div>
                        <div className="row g-3 mb-3">
                          <div className="col-lg-6">
                            <div className="cardBorder medicalVital h-100">
                              <div className="tableHeader d-flex justify-content-between align-items-center">
                                <h5><i className="ti ti-activity"></i>Vital Signs</h5>
                                {!dataVitals?.pulse && (
                                  <span className="vitals-badge">
                                    <i className="ti ti-alert-circle" style={{ fontSize: 11 }}></i>Not Taken
                                  </span>
                                )}
                              </div>
                              <div className="p20">
                                <div className="row parentHuman">
                                  <div className="col-lg-7">
                                    <div className="borderVital">
                                      <div className="parentCardVital">
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">
                                              Pulse
                                            </h6>
                                            {/* <div className="d-flex">
                                              <h3
                                                style={{
                                                  color:
                                                    dataVitals?.pulse >= 40 &&
                                                      dataVitals?.pulse <= 60
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {dataVitals?.pulse}{" "}
                                                <small
                                                  className="ms-1"
                                                  style={{
                                                    color:
                                                      dataVitals?.pulse >= 40 &&
                                                        dataVitals?.pulse <= 60
                                                        ? "green"
                                                        : "red",
                                                    fontWeight: "bold",
                                                  }}
                                                >
                                                  Bpm
                                                </small>
                                              </h3>
                                              {/* <small className="ms-1">Bpm</small> */}
                                            {/* </div> */}
                                            <div className="d-flex">
                                              <h3
                                                style={{
                                                  fontWeight: "bold",
                                                  color:
                                                    dataVitals?.age < 1
                                                      ? dataVitals?.pulse >=
                                                        100 &&
                                                        dataVitals?.pulse <= 160
                                                        ? "green"
                                                        : "red"
                                                      : dataVitals?.age >= 1 &&
                                                        dataVitals?.age <= 10
                                                        ? dataVitals?.pulse >=
                                                          60 &&
                                                          dataVitals?.pulse <= 140
                                                          ? "green"
                                                          : "red"
                                                        : dataVitals?.age > 10 &&
                                                          dataVitals?.age <= 60
                                                          ? dataVitals?.pulse >=
                                                            60 &&
                                                            dataVitals?.pulse <= 100
                                                            ? "green"
                                                            : "red"
                                                          : dataVitals?.pulse >=
                                                            40 &&
                                                            dataVitals?.pulse <= 60
                                                            ? "green"
                                                            : "red",
                                                }}
                                              >
                                                {dataVitals?.pulse}
                                                <small
                                                  className="ms-1"
                                                  style={{
                                                    fontWeight: "bold",
                                                    color:
                                                      dataVitals?.age < 1
                                                        ? dataVitals?.pulse >=
                                                          100 &&
                                                          dataVitals?.pulse <=
                                                          160
                                                          ? "green"
                                                          : "red"
                                                        : dataVitals?.age >=
                                                          1 &&
                                                          dataVitals?.age <= 10
                                                          ? dataVitals?.pulse >=
                                                            60 &&
                                                            dataVitals?.pulse <=
                                                            140
                                                            ? "green"
                                                            : "red"
                                                          : dataVitals?.age >
                                                            10 &&
                                                            dataVitals?.age <= 60
                                                            ? dataVitals?.pulse >=
                                                              60 &&
                                                              dataVitals?.pulse <=
                                                              100
                                                              ? "green"
                                                              : "red"
                                                            : dataVitals?.pulse >=
                                                              40 &&
                                                              dataVitals?.pulse <=
                                                              60
                                                              ? "green"
                                                              : "red",
                                                  }}
                                                >
                                                  Bpm
                                                </small>
                                              </h3>
                                            </div>
                                          </div>
                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              version="1.1"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="originPulseStatic"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stopColor="#00E5FF"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stopColor="#0066FF"
                                                  />
                                                </linearGradient>
                                              </defs>

                                              <path
                                                d="M14.33 8l-1.876-4.377-3.438 9.783-4.015-13.11-2.37 7.704h-2.631v1h3.369l1.63-5.296 3.95 12.903 3.597-10.23 1.124 2.623h3.33v-1z"
                                                fill="url(#originPulseStatic)"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">
                                              Temperature
                                            </h6>
                                            <div className="d-flex">
                                              <h3
                                                style={{
                                                  color:
                                                    dataVitals?.temperature >=
                                                      36 &&
                                                      dataVitals?.temperature <=
                                                      37.5
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {dataVitals?.temperature}
                                              </h3>
                                              <small>°C</small>
                                            </div>
                                          </div>

                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="tempGradient"
                                                  x1="0"
                                                  x2="0"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stopColor="#FF0000"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stopColor="#FFA500"
                                                  />
                                                </linearGradient>
                                              </defs>
                                              <path
                                                d="M10.625 9.66V3.57a2.125 2.125 0 0 0-4.25 0v6.09A3.54 3.54 0 1 0 10.625 9.66zM8.5 15.3a2.12 2.12 0 0 1-.71-4.11V3.57a.71.71 0 0 1 1.42 0v7.62A2.12 2.12 0 0 1 8.5 15.3z"
                                                fill="url(#tempGradient)"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="parentCardVital">
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">
                                              Blood Pressure
                                            </h6>

                                            {(() => {
                                              // Split blood pressure string into systolic and diastolic
                                              const [systolic, diastolic] =
                                                dataVitals?.blood_pressure
                                                  ? dataVitals.blood_pressure
                                                    .split("/")
                                                    .map(Number)
                                                  : [0, 0];

                                              const isNormal =
                                                systolic >= 90 &&
                                                systolic <= 120 &&
                                                diastolic >= 60 &&
                                                diastolic <= 80;

                                              return (
                                                <div
                                                  className={`d-flex ${isNormal
                                                    ? "text-success"
                                                    : "text-danger"
                                                    }`}
                                                >
                                                  <h3>
                                                    {dataVitals?.blood_pressure}{" "}
                                                    <small
                                                      className={
                                                        isNormal
                                                          ? "text-success"
                                                          : "text-danger"
                                                      }
                                                    >
                                                      mm/Hg
                                                    </small>
                                                  </h3>
                                                </div>
                                              );
                                            })()}
                                          </div>

                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="bpGradient"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stopColor="#FF005C"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stopColor="#FF8A00"
                                                  />
                                                </linearGradient>
                                              </defs>
                                              <path
                                                d="M8.5 14.9s-5.2-3.2-7.05-6.06C.86 7.34 1.47 5.12 3.5 3.86c1.3-.74 3 0 4.12 1.12C8.74 3.12 10.44 2.48 11.75 3.22c2.03 1.26 2.64 3.48 2.05 5.0C13.7 11.7 8.5 14.9 8.5 14.9z"
                                                fill="url(#bpGradient)"
                                              />
                                              <polyline
                                                points="3.3 8.5 5.6 8.5 6.2 6.7 7.5 10.1 8.8 7.8 12.3 7.8"
                                                fill="none"
                                                stroke="white"
                                                strokeWidth="0.9"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </div>
                                        </div>

                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">
                                              Respiratory Rate
                                            </h6>
                                            <div className="d-flex">
                                              <h3>
                                                {dataVitals?.respiratory_rate}
                                              </h3>
                                              <small>Breaths per Minute</small>
                                            </div>
                                          </div>
                                          <div></div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* <hr /> */}
                                    <h5>Blood Sugar : </h5>
                                    <div className="borderVital">
                                      <div className="parentCardVital">
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">
                                              Fasting
                                            </h6>
                                            <div className="d-flex">
                                              <h3>{dataVitals?.rbs_nmol} </h3>
                                              <small>mg/dl</small>
                                            </div>
                                          </div>
                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              version="1.1"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="bloodSugarFastingGradient"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stop-color="#00C9FF"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stop-color="#005BEA"
                                                  />
                                                </linearGradient>
                                              </defs>
                                              <path
                                                d="M8.5 1.5c-.2.3-4.1 4.4-4.1 7.6a4.1 4.1 0 1 0 8.2 0c0-3.2-3.9-7.3-4.1-7.6zM8.5 13a3 3 0 0 1-3-3c0-2.2 2.3-5.2 3-6.1.7.9 3 3.9 3 6.1a3 3 0 0 1-3 3z"
                                                fill="url(#bloodSugarFastingGradient)"
                                              />
                                              <circle
                                                cx="8.5"
                                                cy="10"
                                                r="0.8"
                                                fill="#fff"
                                                opacity="0.95"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">
                                              Random
                                            </h6>
                                            <div className="d-flex">
                                              <h3>{dataVitals?.rbs_mg} </h3>
                                              <small>mg/dl</small>
                                            </div>
                                          </div>

                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              version="1.1"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="bloodSugarRandomGradient"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stop-color="#FF6A00"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stop-color="#EE0979"
                                                  />
                                                </linearGradient>
                                              </defs>
                                              <path
                                                d="M8.5 1.5c-.2.3-4.1 4.4-4.1 7.6a4.1 4.1 0 1 0 8.2 0c0-3.2-3.9-7.3-4.1-7.6zM8.5 13a3 3 0 0 1-3-3c0-2.2 2.3-5.2 3-6.1.7.9 3 3.9 3 6.1a3 3 0 0 1-3 3z"
                                                fill="url(#bloodSugarRandomGradient)"
                                              />
                                              <circle
                                                cx="8.5"
                                                cy="10"
                                                r="0.8"
                                                fill="#fff"
                                                opacity="0.95"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    {/* <hr /> */}
                                    <h5>Body Measurements : </h5>
                                    <div
                                      className="borderVital"
                                      style={{ borderBottom: "unset" }}
                                    >
                                      <div className="parentCardVital">
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">
                                              Weight
                                            </h6>
                                            <div className="d-flex">
                                              <h3>{dataVitals?.weight}</h3>
                                              <small>Kg</small>
                                            </div>
                                          </div>
                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              aria-label="weight vital"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="wtGradient"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stop-color="#00C6FF"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stop-color="#7B61FF"
                                                  />
                                                </linearGradient>
                                              </defs>

                                              <g transform="scale(0.7083333333)">
                                                <path
                                                  d="M3 8.5C3 7.12 4.12 6 5.5 6h13c1.38 0 2.5 1.12 2.5 2.5V17c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V8.5z"
                                                  fill="url(#wtGradient)"
                                                />

                                                <rect
                                                  x="7"
                                                  y="3.5"
                                                  width="10"
                                                  height="2"
                                                  rx="0.8"
                                                  fill="url(#wtGradient)"
                                                />

                                                <circle
                                                  cx="12"
                                                  cy="11.5"
                                                  r="3"
                                                  fill="none"
                                                  stroke="white"
                                                  strokeWidth="1.5"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />

                                                <line
                                                  x1="12"
                                                  y1="11.5"
                                                  x2="14.2"
                                                  y2="9.3"
                                                  stroke="white"
                                                  strokeWidth="1.5"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                />

                                                <g
                                                  fill="none"
                                                  stroke="white"
                                                  strokeWidth="1.5"
                                                  strokeLinecap="round"
                                                  strokeLinejoin="round"
                                                >
                                                  <line
                                                    x1="8"
                                                    y1="16"
                                                    x2="10.6"
                                                    y2="16"
                                                  />
                                                  <line
                                                    x1="13.4"
                                                    y1="16"
                                                    x2="16"
                                                    y2="16"
                                                  />
                                                </g>
                                              </g>
                                            </svg>
                                          </div>
                                        </div>
                                        <div
                                          className="cardVital"
                                          style={{ borderRight: "unset" }}
                                        >
                                          <div>
                                            <h6 className="text-muted">
                                              Height
                                            </h6>
                                            <div className="d-flex">
                                              <h3>{dataVitals?.height}</h3>
                                              <small>Cm</small>
                                            </div>
                                          </div>
                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              aria-label="height vital"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="htGradient"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stop-color="#00D084"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stop-color="#009688"
                                                  />
                                                </linearGradient>
                                              </defs>

                                              <circle
                                                cx="8.5"
                                                cy="4.5"
                                                r="1.2"
                                                fill="url(#htGradient)"
                                              />
                                              <path
                                                d="M8.5 6.2v2.5m0 0l-1.5 4m1.5-4l1.5 4"
                                                stroke="url(#htGradient)"
                                                strokeWidth="1.4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                              <line
                                                x1="13"
                                                y1="2.5"
                                                x2="13"
                                                y2="14.5"
                                                stroke="url(#htGradient)"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                              />
                                              <line
                                                x1="12"
                                                y1="4"
                                                x2="13.5"
                                                y2="4"
                                                stroke="url(#htGradient)"
                                                stroke-width="1"
                                              />
                                              <line
                                                x1="12"
                                                y1="7"
                                                x2="13.5"
                                                y2="7"
                                                stroke="url(#htGradient)"
                                                stroke-width="1"
                                              />
                                              <line
                                                x1="12"
                                                y1="10"
                                                x2="13.5"
                                                y2="10"
                                                stroke="url(#htGradient)"
                                                stroke-width="1"
                                              />
                                              <line
                                                x1="12"
                                                y1="13"
                                                x2="13.5"
                                                y2="13"
                                                stroke="url(#htGradient)"
                                                stroke-width="1"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="parentCardVital">
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">BMI</h6>
                                            <div className="d-flex">
                                              <h3>{dataVitals?.bmi}</h3>
                                              <small>kg/m2</small>
                                            </div>
                                          </div>
                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              aria-label="bmi vital"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="bmiGradient"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stop-color="#9C27B0"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stop-color="#E91E63"
                                                  />
                                                </linearGradient>
                                              </defs>

                                              <circle
                                                cx="8.5"
                                                cy="4"
                                                r="1.1"
                                                fill="url(#bmiGradient)"
                                              />
                                              <path
                                                d="M6.5 6c-.5.8-.6 1.5-.6 2.3 0 1.3.6 2.4 1.2 3.5.4.7.8 1.5.9 2.3.1.6.2 1 .5 1h1.2c.3 0 .4-.4.5-1 .1-.8.5-1.6.9-2.3.6-1.1 1.2-2.2 1.2-3.5 0-.8-.1-1.5-.6-2.3"
                                                stroke="url(#bmiGradient)"
                                                strokeWidth="1.4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                fill="none"
                                              />
                                              <circle
                                                cx="8.5"
                                                cy="13.2"
                                                r="2.5"
                                                stroke="url(#bmiGradient)"
                                                strokeWidth="1.3"
                                                fill="none"
                                              />
                                              <line
                                                x1="8.5"
                                                y1="13.2"
                                                x2="9.9"
                                                y2="11.8"
                                                stroke="url(#bmiGradient)"
                                                strokeWidth="1.2"
                                                strokeLinecap="round"
                                              />
                                            </svg>
                                          </div>
                                        </div>
                                        <div className="cardVital">
                                          <div>
                                            <h6 className="text-muted">SPO2</h6>
                                            <div className="d-flex">
                                              <h3
                                                style={{
                                                  color:
                                                    dataVitals?.spo2 >= 95 &&
                                                      dataVitals?.spo2 <= 100
                                                      ? "green"
                                                      : "red",
                                                  fontWeight: "bold",
                                                }}
                                              >
                                                {dataVitals?.spo2}%
                                              </h3>
                                            </div>
                                          </div>
                                          <div>
                                            <svg
                                              viewBox="0 0 17 17"
                                              xmlns="http://www.w3.org/2000/svg"
                                              fill="none"
                                              aria-label="spo2 vital"
                                            >
                                              <defs>
                                                <linearGradient
                                                  id="spo2Gradient"
                                                  x1="0"
                                                  x2="1"
                                                  y1="0"
                                                  y2="1"
                                                >
                                                  <stop
                                                    offset="0%"
                                                    stop-color="#00BCD4"
                                                  />
                                                  <stop
                                                    offset="100%"
                                                    stop-color="#1976D2"
                                                  />
                                                </linearGradient>
                                              </defs>

                                              <path
                                                d="M1.5 9h2l1.2-2.5 1.8 5 1.5-4 1.3 3h2.5"
                                                stroke="url(#spo2Gradient)"
                                                strokeWidth="1.4"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                fill="none"
                                              />

                                              <circle
                                                cx="13.5"
                                                cy="9"
                                                r="2.2"
                                                stroke="url(#spo2Gradient)"
                                                stroke-width="1.3"
                                                fill="none"
                                              />

                                              <text
                                                x="12"
                                                y="10.3"
                                                fontSize="3.3"
                                                fill="url(#spo2Gradient)"
                                                fontFamily="Arial, sans-serif"
                                              >
                                                O₂
                                              </text>
                                            </svg>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-lg-5">
                                    <div className="vitalHumanM d-flex flex-column align-items-center">
                                      <p style={{ fontSize: 11, color: "#64748b", textAlign: "center", marginBottom: 4 }}>BP position</p>
                                      <svg viewBox="0.5 0.5 31 92" style={{ width: "100%", maxWidth: 140 }} xmlns="http://www.w3.org/2000/svg">
                                        <g fill="#dde4ed" stroke="#9aaab8" strokeWidth="0.25">
                                          <path d="m 11.671635,6.3585449 -0.0482,-2.59085 4.20648,-2.46806 4.42769,2.95361 -0.0405,1.94408 0.24197,-3.34467 -2.03129,-2.31103004 -2.84508,-0.51629 -2.20423,0.52915 -1.9363,2.63077004 z" />
                                          <path d="m 19.748825,6.7034949 0.0203,-2.20747 -3.96689,-2.7637 -3.74099,2.23559 -0.006,2.63528 -0.60741,0.0403 0.27408,1.82447 0.97635,0.33932 0.44244,2.1802901 1.82222,2.06556 2.03518,-0.0607 1.79223,-1.94408 0.35957,-2.2406601 0.97616,-0.33932 0.25159,-1.78416 z" />
                                          <path d="m 13.304665,11.910505 1.64975,2.35202 0.74426,2.62159 -1.73486,-1.38354 -0.86649,-2.97104 z m 5.08047,0 -1.64975,2.35202 -0.74538,2.62234 1.73486,-1.38354 0.86649,-2.97104 z" />
                                          <path d="m 20.337455,17.085495 1.72942,3.09103 1.89346,0.94785 -1.15295,0.90662 -0.90604,2.63773 -2.09968,0.86537 -3.34524,-1.655 0.83425,-6.50527 z" />
                                          <path d="m 11.351215,17.085495 -1.7294199,3.09103 -1.89346,0.94785 1.15295,0.90662 0.90586,2.63773 2.0996699,0.86537 3.34636,-1.655 -0.83462,-6.50527 z" />
                                          <path d="m 19.288925,26.151995 -3.11202,-1.40604 0.0937,2.27965 2.80119,1.43603 z m 1.93471,1.66849 -1.29355,0.7212 0.14997,-1.70898 z m -1.05303,-1.63718 2.47968,-1.03241 -0.9336,2.52093 z m 1.53164,1.73729 -1.69005,1.03372 -0.28871,2.0678 1.64975,-1.07533 z m -2.91143,1.10421 -0.0622,1.62387 -2.30308,-0.49961 -0.12448,-2.21722 z m -0.1556,2.4045 0.0311,1.99844 -2.20953,0.59391 -0.0311,-3.1227 z m 2.65459,-0.98535 -1.48383,1.03372 -0.20622,2.10905 1.64862,-1.32355 z" />
                                          <path d="m 12.399365,26.152365 3.11202,-1.40603 -0.0937,2.27965 -2.80138,1.4364 z m -1.93508,1.6685 1.29355,0.72139 -0.14997,-1.70899 z m 1.05303,-1.637 -2.4793099,-1.03259 0.93361,2.52148 z m -1.5316399,1.73729 1.6900499,1.03372 0.28871,2.06743 -1.64881,-1.07515 z m 2.9114199,1.10421 0.0623,1.62387 2.30327,-0.49961 0.12448,-2.21703 z m 0.15561,2.40432 -0.0309,1.99844 2.20973,0.59353 0.0311,-3.1227 z m -2.6546,-0.98516 1.48384,1.0339 0.20622,2.10905 -1.64975,-1.32355 z" />
                                          <path d="m 19.641935,34.707615 1.81341,-1.36479 0.15748,1.83347 1.28642,2.37338 -1.98044,2.73652 -1.03109,0.16554 -0.37026,-3.88816 z" />
                                          <path d="m 12.045985,34.707615 -1.81341,-1.36479 -0.15748,1.83347 -1.2856799,2.37432 1.9804499,2.73595 1.03109,0.16554 0.37119,-3.88721 z" />
                                          <path d="m 15.636055,44.919735 -0.60647,-5.91209 -0.015,-3.84879 -2.18479,-1.07533 -0.24746,7.03017 z m 0.41581,-5.7e-4 0.60628,-5.91209 0.0154,-3.84915 2.18404,-1.07515 0.24746,7.03017 z" />
                                          <path d="m 14.404465,45.040075 0.0221,-0.0277 -0.14866,-0.37945 -3.10172,-3.40449 -0.23283,-0.0825 2.05918,5.32009 z m -1.17263,2.01833 1.27705,3.29948 0.42631,-4.04862 -0.25196,-0.64303 z m 4.05219,-2.01795 -0.0221,-0.0281 0.14867,-0.37926 3.10171,-3.40449 0.23246,-0.0825 -2.05843,5.3199 z m 1.17263,2.01795 -1.27706,3.29948 -0.42631,-4.04843 0.25197,-0.64303 z" />
                                        </g>
                                        <g fill={dataVitals?.bp_position === "Right Arm" ? "#2ca87f" : "#c8d4e0"} stroke={dataVitals?.bp_position === "Right Arm" ? "#1a7e5a" : "#8a9ab0"} strokeWidth="0.25">
                                          <path d="m 12.624785,13.248365 -3.5574599,1.97916 -0.72653,-0.35074 z m 0.107,0.43288 0.37119,1.73073 -2.18459,0.53561 -1.4011499,-0.49436 z m -3.9814899,1.97595 -0.75814,-0.41 -2.40806,1.66799 -1.17364,1.50707 -0.62662,1.56259 0.0464,3.70195 1.3284,-1.72153 -0.0407,-2.59376 0.48843,-0.5005 c 0,0 3.09777,-3.19057 3.1437,-3.214 z m 0.2409,0.10873 c 0.002,0.0525 -3.32987,3.54733 -3.32987,3.54733 l -0.10067,3.10396 1.15426,-1.97782 2.22547,-0.94804 1.5657499,-2.88481 z" />
                                          <path d="m 4.0746451,30.814715 0.33838,1.70499 1.81931,-2.54418 0.66289,-1.26895 z m 2.8527,-2.6096 c 0.0259,-0.0144 0.0536,-0.0254 0.0824,-0.0324 l 1.48332,-4.95503 -1.00455,-2.08428 -1.65509,1.74532 -2.23034,6.67667 -0.0415,0.93739 c 1.06528,-0.84215 2.18961,-1.60679 3.36433,-2.28803 z m -1.6945,-5.75654 -1.64891,6.43421 0.36468,-4.92266 z" />
                                          <path d="m 4.5752651,32.969125 -1.30083,10.28927 1.10778,0.01 1.89387,-7.99609 -0.19174,-4.53719 z m -1.21978,-1.94971 0.58728,2.58635 -1.11875,9.15614 -0.55849,-0.21663 -0.2304,-6.77018 z" />
                                          <path d="m 3.2054751,27.370125 0.005,3.09419 -0.57959,1.91184 -0.54539,-2.41185 z" />
                                          <path d="m 4.3904451,43.563145 -1.5198,0.0506 -0.76631,-0.67112 -1.21261996,2.15767 -0.86245,3.32873 0.49386,0.22113 0.59814996,-2.20238 0.50016,0.25356 -0.35639,2.49422 0.62382,0.24345 0.41402,-2.49194 0.55839,0.17851 -0.2262,2.76603 0.76938,0.32268 0.25788,-2.86764 0.4578,-0.0181 0.16611,2.65239 0.65997,0.2633 0.0712,-4.56643 0.34158,-0.19428 1.35316,1.68367 0.32832,-0.34354 -0.72644,-2.0551 z" />
                                        </g>
                                        <text x="3.8" y="38.5" fontSize="2.1" fill={dataVitals?.bp_position === "Right Arm" ? "#fff" : "#556070"} textAnchor="middle" fontWeight="bold" style={{ pointerEvents: "none", userSelect: "none" }}>R</text>
                                        <text x="3.8" y="41" fontSize="1.7" fill={dataVitals?.bp_position === "Right Arm" ? "#d0f5e8" : "#8090a0"} textAnchor="middle" style={{ pointerEvents: "none", userSelect: "none" }}>Arm</text>
                                        <g fill={dataVitals?.bp_position === "Left Arm" ? "#2ca87f" : "#c8d4e0"} stroke={dataVitals?.bp_position === "Left Arm" ? "#1a7e5a" : "#8a9ab0"} strokeWidth="0.25">
                                          <path d="m 19.047795,13.248365 3.55748,1.97916 0.72653,-0.35074 z m -0.107,0.43288 -0.37119,1.73073 2.1846,0.53561 1.40116,-0.49436 z m 3.98151,1.97595 0.75814,-0.41 2.40806,1.66799 1.17364,1.50707 0.62662,1.5626 -0.0464,3.70194 -1.3284,-1.72153 0.0407,-2.59376 -0.48842,-0.50049 c 0,0 -3.09778,-3.19058 -3.14371,-3.21401 z m -0.2409,0.10873 c -0.001,0.0525 3.32987,3.54733 3.32987,3.54733 l 0.10067,3.10396 -1.15426,-1.97782 -2.22547,-0.94804 -1.56576,-2.88481 z" />
                                          <path d="m 27.621665,30.814715 -0.33838,1.70499 -1.81932,-2.54418 -0.6629,-1.26895 z m -2.85271,-2.6096 c -0.0259,-0.0144 -0.0536,-0.0254 -0.0824,-0.0324 l -1.48333,-4.95503 1.00456,-2.08428 1.65511,1.74532 2.23034,6.67667 0.0415,0.93739 c -1.06528,-0.84215 -2.18962,-1.60679 -3.36434,-2.28803 z m 1.6945,-5.75654 1.64893,6.43421 -0.36469,-4.92266 z" />
                                          <path d="m 26.955425,32.969125 1.30083,10.28927 -1.10778,0.01 -1.89387,-7.99609 0.19174,-4.53719 z m 1.21978,-1.94971 -0.58729,2.58635 1.11876,9.15614 0.55849,-0.21663 0.2304,-6.77018 z" />
                                          <path d="m 28.325215,27.370125 -0.005,3.09419 0.57959,1.91184 0.54538,-2.41185 z" />
                                          <path d="m 27.140245,43.563145 1.5198,0.0506 0.76631,-0.67111 1.21262,2.15766 0.86245,3.32873 -0.49386,0.22113 -0.59815,-2.20238 -0.50016,0.25356 0.35639,2.49422 -0.62382,0.24345 -0.41402,-2.49194 -0.55839,0.17851 0.2262,2.76603 -0.76938,0.32268 -0.25788,-2.86764 -0.4578,-0.0181 -0.16611,2.6524 -0.65997,0.26329 -0.0712,-4.56643 -0.34158,-0.19428 -1.35316,1.68368 -0.32832,-0.34355 0.72644,-2.0551 z" />
                                        </g>
                                        <text x="27.8" y="38.5" fontSize="2.1" fill={dataVitals?.bp_position === "Left Arm" ? "#fff" : "#556070"} textAnchor="middle" fontWeight="bold" style={{ pointerEvents: "none", userSelect: "none" }}>L</text>
                                        <text x="27.8" y="41" fontSize="1.7" fill={dataVitals?.bp_position === "Left Arm" ? "#d0f5e8" : "#8090a0"} textAnchor="middle" style={{ pointerEvents: "none", userSelect: "none" }}>Arm</text>
                                        <g fill={dataVitals?.bp_position === "Right Leg" ? "#2ca87f" : "#c8d4e0"} stroke={dataVitals?.bp_position === "Right Leg" ? "#1a7e5a" : "#8a9ab0"} strokeWidth="0.25">
                                          <path d="m 8.2694651,50.399125 0.15504,4.75053 2.4026299,6.60968 -0.73638,1.90021 -2.3640099,-8.34435 z m 0.58117,-11.60768 0.15503,4.00684 -1.31754,7.93154 -0.61978,-6.40308 z m 0.38769,5.1223 2.7515099,6.07239 0.61997,4.87425 -1.16232,6.85771 -2.5190499,-6.98163 -0.15504,-7.18801 z" />
                                          <path d="m 9.6258251,39.369415 v 4.21363 l 2.9451699,5.8253 1.86028,5.78349 -0.19366,-4.0072 z m 3.2488699,13.42559 0.0647,0.15485 1.21294,2.90207 -0.78307,7.18803 -1.23618,-0.66102 1.0714,-6.69273 z" />
                                          <path d="m 10.284405,64.784375 -0.12448,1.12295 0.87118,1.08171 0.29058,1.70599 0.58116,0.24933 0.49774,-2.57866 0.33182,-0.91486 -0.29058,-0.58247 z m 3.85854,0.0832 -0.62241,1.74685 -1.32767,2.57867 0.33182,2.37095 0.95423,-2.66209 0.78832,-1.4964 z m -4.9786799,-2.37058 0.9542299,5.11609 -0.6223999,-0.33313 -0.49793,1.6638 z" />
                                          <path d="m 13.437675,70.440945 -0.29058,0.91486 -0.62241,3.86828 -0.0829,5.15733 0.87174,5.03304 -0.0418,-6.44714 0.91298,-2.57848 0.1243,-2.82837 z m -1.99151,2.32914 0.20735,7.73637 1.65968,6.23904 -1.80497,-0.85299 -3.0079799,-10.83584 1.03728,-6.82095 z" />
                                          <path d="m 14.433335,87.868265 -0.12448,3.45228 -0.29058,1.20637 h -0.87118 l -0.24877,-0.83181 -0.29059,-0.0416 0.0623,0.83181 -1.09934,-0.33333 -0.29058,-0.16629 -1.2448,-0.27033 -0.0412,-0.97747 1.2031899,-2.03781 0.82975,-1.04009 2.03294,-0.83181 z" />
                                        </g>
                                        <text x="10.5" y="77" fontSize="2.1" fill={dataVitals?.bp_position === "Right Leg" ? "#fff" : "#556070"} textAnchor="middle" fontWeight="bold" style={{ pointerEvents: "none", userSelect: "none" }}>R</text>
                                        <text x="10.5" y="79.5" fontSize="1.7" fill={dataVitals?.bp_position === "Right Leg" ? "#d0f5e8" : "#8090a0"} textAnchor="middle" style={{ pointerEvents: "none", userSelect: "none" }}>Leg</text>
                                        <g fill={dataVitals?.bp_position === "Left Leg" ? "#2ca87f" : "#c8d4e0"} stroke={dataVitals?.bp_position === "Left Leg" ? "#1a7e5a" : "#8a9ab0"} strokeWidth="0.25">
                                          <path d="m 23.419015,50.399125 -0.15504,4.75091 -2.40263,6.60949 0.7362,1.90021 2.36401,-8.34435 z m -0.58154,-11.60825 -0.15485,4.00722 1.31793,7.93154 0.61977,-6.40308 z m -0.38731,5.12268 -2.75152,6.07258 -0.62015,4.87425 1.16232,6.85771 2.51886,-6.98144 0.15504,-7.18764 z" />
                                          <path d="m 22.063225,39.369605 v 4.21363 l -2.94574,5.82511 -1.86027,5.78349 0.19365,-4.0072 z m -3.24944,13.42596 -0.0649,0.15467 -1.21294,2.90207 0.78325,7.18803 1.23619,-0.66122 -1.0714,-6.69272 z" />
                                          <path d="m 21.404635,64.784375 0.1243,1.12295 -0.87118,1.08171 -0.29058,1.70599 -0.58116,0.24933 -0.49774,-2.57866 -0.33182,-0.91486 0.29058,-0.58247 z m -3.85853,0.0832 0.6224,1.74685 1.3273,2.57867 -0.33182,2.37095 -0.95423,-2.66209 -0.78738,-1.49734 z m 4.97811,-2.37039 -0.95423,5.11609 0.62241,-0.33295 0.49773,1.66381 z" />
                                          <path d="m 18.251375,70.441125 0.29058,0.91486 0.6224,3.8681 0.0829,5.15733 -0.87136,5.03304 0.0412,-6.44714 -0.91242,-2.57848 -0.12561,-2.82837 z m 1.9915,2.32915 -0.20753,7.73637 -1.65949,6.23904 1.80478,-0.853 3.00816,-10.83583 -1.03727,-6.82095 z" />
                                          <path d="m 17.255895,87.868445 0.1243,3.45228 0.28983,1.20638 h 0.87136 l 0.24897,-0.83181 0.29058,-0.0416 -0.0624,0.83181 1.09914,-0.33332 0.29058,-0.16629 1.24444,-0.27033 0.0416,-0.97748 -1.20319,-2.03743 -0.82974,-1.0399 -2.03294,-0.83181 z" />
                                        </g>
                                        <text x="21" y="77" fontSize="2.1" fill={dataVitals?.bp_position === "Left Leg" ? "#fff" : "#556070"} textAnchor="middle" fontWeight="bold" style={{ pointerEvents: "none", userSelect: "none" }}>L</text>
                                        <text x="21" y="79.5" fontSize="1.7" fill={dataVitals?.bp_position === "Left Leg" ? "#d0f5e8" : "#8090a0"} textAnchor="middle" style={{ pointerEvents: "none", userSelect: "none" }}>Leg</text>
                                      </svg>
                                    </div>
                                    <PainBarChart painassesment={dataMedical?.pain_assessment || 0} />
                                  </div>
                                </div>

                                <div className="d-flex parentBottomVital">
                                  <div
                                    className="me-5"
                                    style={{ paddingTop: "20px" }}
                                  >
                                    <div className="bottomVital">
                                      <div className="d-flex">
                                        <h6 className="text-muted">
                                          BP Position
                                        </h6>
                                        <h6>{dataVitals?.bp_position}</h6>
                                      </div>
                                    </div>

                                    <div className="bottomVital">
                                      <div className="d-flex">
                                        <h6 className="text-muted">Urgency</h6>
                                        <div>
                                          {dataVitals?.urgency ===
                                            "Moderate" ? (
                                            <h6 className="text-warning">
                                              {dataVitals?.urgency}
                                            </h6>
                                          ) : dataVitals?.urgency === "High" ? (
                                            <h6 className="text-danger">
                                              {dataVitals?.urgency}
                                            </h6>
                                          ) : (
                                            <h6 className="text-success">
                                              {dataVitals?.urgency}
                                            </h6>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="bottomVital">
                                      <div className="d-flex">
                                        <h6 className="text-muted">Added By</h6>
                                        <h6>{dataVitals?.doctor_name}</h6>
                                      </div>
                                    </div>
                                  </div>
                                  <div
                                    className="mb-0"
                                    style={{ paddingTop: "20px" }}
                                  >
                                    <div className="bottomVital">
                                      <div className="d-flex">
                                        <h6 className="text-muted">
                                          Risk of Fall
                                        </h6>
                                        <div>
                                          {/* <td>{dataVitals?.risk_of_fall}</td> */}
                                          {dataVitals?.risk_of_fall ===
                                            "Medium" ? (
                                            <h6 className="text-warning">
                                              {dataVitals?.risk_of_fall}
                                            </h6>
                                          ) : dataVitals?.risk_of_fall ===
                                            "High" ? (
                                            <h6 className="text-danger">
                                              {dataVitals?.risk_of_fall}
                                            </h6>
                                          ) : (
                                            <h6 className="text-success">
                                              {dataVitals?.risk_of_fall}
                                            </h6>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                    <div className="bottomVital">
                                      <div className="d-flex">
                                        <h6 className="text-muted">Notes</h6>
                                        <div>
                                          <h6 className="small" dangerouslySetInnerHTML={{ __html: nl2br(dataVitals?.notes) }}></h6>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <table>
                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                          background: "#fff",
                                        }}
                                      >
                                        Pulse
                                      </th>
                                      <td>{dataVitals?.pulse} BPM</td>
                                    </tr> */}
                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Temperature
                                      </th>
                                      <td>{dataVitals?.temperature} C</td>
                                    </tr> */}
                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Blood Pressure
                                      </th>
                                      <td>
                                        {dataVitals?.blood_pressure} mm/Hg
                                      </td>
                                    </tr> */}

                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Blood Sugar (Fasting)
                                      </th>
                                      <td>{dataVitals?.rbs_nmol} mg/dl</td>
                                    </tr>
                                    <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Blood Sugar (Random)
                                      </th>
                                      <td>{dataVitals?.rbs_mg} mmol/l</td>
                                    </tr> */}
                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Weight
                                      </th>
                                      <td>{dataVitals?.weight} KG</td>
                                    </tr> */}
                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        Height
                                      </th>
                                      <td>{dataVitals?.height} cm</td>
                                    </tr> */}
                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        BMI
                                      </th>
                                      <td>{dataVitals?.bmi}</td>
                                    </tr> */}
                                  {/* <tr>
                                      <th
                                        style={{
                                          textTransform: "uppercase",
                                        }}
                                      >
                                        RR
                                      </th>
                                      <td>
                                       bpm
                                      </td>
                                    </tr> */}
                                  {/* <tr>
                                  <th
                                    style={{
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    BP Position
                                  </th>
                                  <td>{dataVitals?.bp_position}</td>
                                </tr> */}
                                  {/* <tr>
                                  <th
                                    style={{
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Risk of Fall
                                  </th>
                                  
                                  {dataVitals?.risk_of_fall === "Medium" ? (
                                    <td className="text-warning">
                                      {dataVitals?.risk_of_fall}
                                    </td>
                                  ) : dataVitals?.risk_of_fall === "High" ? (
                                    <td className="text-danger">
                                      {dataVitals?.risk_of_fall}
                                    </td>
                                  ) : (
                                    <td className="text-success">
                                      {dataVitals?.risk_of_fall}
                                    </td>
                                  )}
                                </tr> */}
                                  {/* <tr>
                                  <th
                                    style={{
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Urgency
                                  </th>
                                  {dataVitals?.urgency === "Moderate" ? (
                                    <td className="text-warning">
                                      {dataVitals?.urgency}
                                    </td>
                                  ) : dataVitals?.urgency === "High" ? (
                                    <td className="text-danger">
                                      {dataVitals?.urgency}
                                    </td>
                                  ) : (
                                    <td className="text-success">
                                      {dataVitals?.urgency}
                                    </td>
                                  )}
                                </tr> */}
                                  {/* <tr>
                                  <th
                                    style={{
                                      textTransform: "uppercase",
                                    }}
                                  >
                                    Notes
                                  </th>
                                  <td>{dataVitals?.notes}</td>
                                </tr> */}
                                </table>
                              </div>
                            </div>
                          </div>
                              <div className="col-lg-6 d-flex flex-column gap-3">
                                {patinetvitals && patinetvitals.length > 1 && (
                                  <div className="cardBorder">
                                    <div className="tableHeader">
                                      <div className="d-flex justify-content-between">
                                        <h5><i className="ti ti-trending-up" style={{ color: "#9E6B00" }}></i>Vitals Trend Alerts</h5>
                                      </div>
                                    </div>
                                    <div className="card-body p-0 bg-white rounded-bottom-4">
                                      {patinetvitals[0]?.trend && patinetvitals[0].trend.length > 0 ? (
                                        <div style={{ padding: "10px 16px" }}>
                                          {patinetvitals[0].trend.map((flag, i) => (
                                            <div
                                              key={i}
                                              style={{
                                                fontSize: 13,
                                                color: "#7a5c00",
                                                padding: "5px 0",
                                                borderBottom: i < patinetvitals[0].trend.length - 1 ? "1px solid #f2e9d0" : "none",
                                              }}
                                            >
                                              <i className="ti ti-alert-triangle me-1" style={{ color: "#c99a00" }} />
                                              {flag.message}
                                            </div>
                                          ))}
                                        </div>
                                      ) : (
                                        <div style={{ padding: "10px 16px", fontSize: 13, color: "#9ca3af" }}>
                                          No significant vitals trends detected.
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                                <div className="cardBorder">
                                  <div className="tableHeader">
                                    {allergy && createPortal(
                                      <div
                                        className="modal fade show"
                                        style={{
                                          backgroundColor:
                                            "rgba(81, 81, 81, 0.5)",
                                          display: "block",
                                        }}
                                      >
                                        <div className="modal-dialog">
                                          <div className="modal-content" style={{ borderRadius: 10, overflow: 'hidden', border: 'none', boxShadow: '0 8px 32px rgba(42,84,120,0.18)' }}>
                                            <div className="modal-header" style={{ background: 'linear-gradient(135deg,#f0f5fa 0%,#f8fafc 100%)', borderBottom: '1px solid rgba(219,224,229,0.8)', padding: '12px 16px' }}>
                                              <h5 className="modal-title" style={{ fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--green)', display: 'flex', alignItems: 'center', gap: 6, marginBottom: 0 }}>
                                                <i className="ti ti-alert-triangle" style={{ fontSize: 15, color: '#9E2B25' }}></i>
                                                {isEditing9 ? "Edit Allergy" : "Add Allergy"}
                                              </h5>
                                              <button type="button" onClick={closeAllergy} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: 18, lineHeight: 1, padding: '0 2px' }}>
                                                <i className="ti ti-x"></i>
                                              </button>
                                            </div>
                                            <div className="modal-body" style={{ padding: '16px' }}>
                                              <div className="row g-3">
                                                <div className="col-md-12" style={{ position: "relative" }}>
                                                  <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>
                                                    Allergy Name
                                                  </label>
                                                  <input
                                                    type="text"
                                                    name="name"
                                                    autoComplete="off"
                                                    placeholder="Type to search, or enter a new allergy"
                                                    value={formData13.name || ""}
                                                    onChange={handleAllergyNameChange}
                                                    onFocus={handleAllergyNameChange}
                                                    onBlur={() => setTimeout(() => setFilteredAllergyNames([]), 150)}
                                                    className="form-control"
                                                    style={{ fontSize: 13 }}
                                                  />
                                                  {filteredAllergyNames.length > 0 && (
                                                    <ul style={{ position: "absolute", top: "100%", left: 0, width: "100%", background: "#fff", border: "1px solid rgba(219,224,229,0.9)", borderRadius: 6, zIndex: 10000, maxHeight: 200, overflowY: "auto", padding: 0, margin: '4px 0 0', listStyle: "none", boxShadow: "0 4px 12px rgba(42,84,120,0.12)" }}>
                                                      {filteredAllergyNames.map((item, i) => (
                                                        <li key={item.id || i} onMouseDown={() => handleSelectAllergyName(item)}
                                                          style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontSize: 12, color: '#374151' }}
                                                          onMouseEnter={e => e.currentTarget.style.background = "rgba(42,84,120,0.06)"}
                                                          onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                                                          <i className="ti ti-search" style={{ fontSize: 11, marginRight: 6, color: 'var(--green)', opacity: 0.6 }}></i>
                                                          {item.name}
                                                        </li>
                                                      ))}
                                                    </ul>
                                                  )}
                                                  {isNewAllergyName && (
                                                    <small style={{ fontSize: 11, color: 'var(--green)', display: 'flex', alignItems: 'center', gap: 4, marginTop: 4 }}>
                                                      <i className="ti ti-plus" style={{ fontSize: 12 }}></i>
                                                      New allergy &mdash; it will be added to the list
                                                    </small>
                                                  )}
                                                </div>
                                                <div className="col-md-12">
                                                  <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>
                                                    Description
                                                  </label>
                                                  <input
                                                    type="text"
                                                    name="description"
                                                    placeholder="e.g. rash, difficulty breathing..."
                                                    value={formData13.description}
                                                    onChange={(e) => setFormData13({ ...formData13, description: e.target.value })}
                                                    className="form-control"
                                                    style={{ fontSize: 13 }}
                                                  />
                                                </div>
                                              </div>
                                            </div>
                                            <div className="modal-footer justify-content-end" style={{ padding: '10px 16px', borderTop: '1px solid rgba(219,224,229,0.8)', gap: 8 }}>
                                              <button type="button" className="cancelText" onClick={closeAllergy}>
                                                Cancel
                                              </button>
                                              {isEditing9 ? (
                                                <button type="button" className="bgBtn btn-sm" onClick={() => updateAllergy(formData13)}>
                                                  <i className="ti ti-check" style={{ marginRight: 4 }}></i>Update Allergy
                                                </button>
                                              ) : (
                                                <button type="button" className="bgBtn btn-sm" onClick={addxray}>
                                                  <i className="ti ti-plus" style={{ marginRight: 4 }}></i>Add Allergy
                                                </button>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    , document.body)}
                                    <div className="d-flex justify-content-between">
                                      <h5><i className="ti ti-alert-triangle" style={{ color: '#9E2B25' }}></i>Allergies</h5>

                                      <div
                                        className="addBtnIcon"
                                        onClick={openAllergy}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i class="borderBtn ti ti-plus f-20" style={{ padding: "5px 12px" }}></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-body p-0 bg-white rounded-bottom-4">
                                    <div className="table-responsive">
                                      <table className="table">
                                        <thead>
                                          <tr>
                                            <th>SR</th>
                                            <th>Allergy</th>
                                            <th>Description</th>
                                            <th>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {dataAllergy &&
                                            dataAllergy.length > 0 ? (
                                            dataAllergy.map((plan, index) => (
                                              <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                  {plan?.allergy_name || "N/A"}
                                                </td>
                                                <td>
                                                  {plan?.allergy_type || "N/A"}
                                                </td>
                                                <td className="text-center d-flex gap-2">
                                                  {/* <button
                                                    type="button"
                                                    className="avtar avtar-xs btn-link-secondary viewIcon"
                                                    onClick={() =>
                                                      handleEditAllergy(plan)
                                                    }
                                                    style={{
                                                      background: "none",
                                                      border: "none",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <i className="ti ti-edit f-20" />
                                                    <span>Edit</span>
                                                  </button> */}

                                                  <button
                                                    type="button"
                                                    className="avtar avtar-xs btn-link-secondary deleteIcon"
                                                    onClick={() =>
                                                      handleEditAlledelete(plan)
                                                    }
                                                    style={{
                                                      background: "none",
                                                      border: "none",
                                                      cursor: "pointer",
                                                    }}
                                                  >
                                                    <i className="ti ti-trash f-20" />
                                                    <span>Delete</span>
                                                  </button>
                                                </td>
                                              </tr>
                                            ))
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan="4"
                                                className="text-center"
                                              >
                                                N/A
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                                <div className="cardBorder">
                                  <div className="tableHeader">
                                    <div className="d-flex justify-content-between">
                                      {chronicillness && createPortal(
                                        <div
                                          className="modal fade show"
                                          style={{
                                            backgroundColor:
                                              "rgba(81, 81, 81, 0.5)",
                                            display: "block",
                                          }}
                                        >
                                          <div className="modal-dialog">
                                            <div className="modal-content" style={{ borderRadius: 10, overflow: 'hidden', border: 'none', boxShadow: '0 8px 32px rgba(42,84,120,0.18)' }}>
                                              <div className="modal-header" style={{ background: 'linear-gradient(135deg,#f0f5fa 0%,#f8fafc 100%)', borderBottom: '1px solid rgba(219,224,229,0.8)', padding: '12px 16px' }}>
                                                <h5 className="modal-title" style={{ fontSize: 13, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.07em', color: 'var(--green)', display: 'flex', alignItems: 'center', gap: 6, marginBottom: 0 }}>
                                                  <i className="ti ti-heart-rate-monitor" style={{ fontSize: 15 }}></i>
                                                  Add Chronic Illness
                                                </h5>
                                                <button type="button" onClick={closeChronicillness} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280', fontSize: 18, lineHeight: 1, padding: '0 2px' }}>
                                                  <i className="ti ti-x"></i>
                                                </button>
                                              </div>
                                              <div className="modal-body" style={{ padding: '16px' }}>
                                                <div className="col-md-12">
                                                  <label className="form-label mb-1" style={{ fontSize: 12, fontWeight: 600, color: '#374151' }}>
                                                    Illness Name
                                                  </label>
                                                  <div style={{ position: "relative" }}>
                                                    <input
                                                      type="text"
                                                      name="illness_text"
                                                      placeholder="Type or search illness..."
                                                      value={chronic.illness_text || ""}
                                                      onChange={handlechnageillbness}
                                                      onBlur={() => setTimeout(() => setIllnessSuggestions([]), 150)}
                                                      className="form-control"
                                                      autoComplete="off"
                                                      style={{ fontSize: 13 }}
                                                    />
                                                    {illnessSuggestions.length > 0 && (
                                                      <ul style={{ position: "absolute", top: "100%", left: 0, width: "100%", background: "#fff", border: "1px solid rgba(219,224,229,0.9)", borderRadius: 6, zIndex: 10000, maxHeight: 200, overflowY: "auto", padding: 0, margin: '4px 0 0', listStyle: "none", boxShadow: "0 4px 12px rgba(42,84,120,0.12)" }}>
                                                        {illnessSuggestions.map((item, i) => (
                                                          <li key={item.id || i} onMouseDown={() => handleIllnessSuggestionClick(item.text)}
                                                            style={{ padding: "8px 12px", cursor: "pointer", borderBottom: "1px solid #f0f0f0", fontSize: 12, color: '#374151' }}
                                                            onMouseEnter={e => e.currentTarget.style.background = "rgba(42,84,120,0.06)"}
                                                            onMouseLeave={e => e.currentTarget.style.background = "#fff"}>
                                                            <i className="ti ti-search" style={{ fontSize: 11, marginRight: 6, color: 'var(--green)', opacity: 0.6 }}></i>
                                                            {item.text}
                                                          </li>
                                                        ))}
                                                      </ul>
                                                    )}
                                                  </div>
                                                </div>
                                              </div>
                                              <div className="modal-footer justify-content-end" style={{ padding: '10px 16px', borderTop: '1px solid rgba(219,224,229,0.8)', gap: 8 }}>
                                                <button type="button" className="cancelText" onClick={closeChronicillness}>
                                                  Cancel
                                                </button>
                                                <button type="button" className="bgBtn btn-sm" onClick={Addchronicillness}>
                                                  <i className="ti ti-plus" style={{ marginRight: 4 }}></i>Add Chronic Illness
                                                </button>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      , document.body)}
                                      <h5><i className="ti ti-heart-rate-monitor"></i>Chronic Illness</h5>

                                      <div
                                        className="addBtnIcon"
                                        onClick={openChronicillness}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <i class="borderBtn ti ti-plus f-20" style={{ padding: "5px 12px" }}></i>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="card-body p-0 bg-white rounded-bottom">
                                    <div className="table-responsive rounded-bottom">
                                      <table className="table">
                                        <thead>
                                          <tr>
                                            <th>SR</th>
                                            <th>Illness</th>
                                            <th>Action</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {chronicillness1 &&
                                            chronicillness1.length > 0 ? (
                                            chronicillness1.map(
                                              (plan, index) => (
                                                <tr key={index}>
                                                  <td>{index + 1}</td>
                                                  <td>
                                                    {plan?.illness_text ||
                                                      "N/A"}
                                                  </td>
                                                  <td className="text-center d-flex gap-2">
                                                    <button
                                                      type="button"
                                                      className="avtar avtar-xs btn-link-secondary editIcon"
                                                      onClick={() =>
                                                        openEditIllness(plan)
                                                      }
                                                      style={{
                                                        background: "none",
                                                        border: "none",
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <i className="ti ti-edit f-20" />
                                                      <span>Edit</span>
                                                    </button>

                                                    <button
                                                      type="button"
                                                      className="avtar avtar-xs btn-link-secondary deleteIcon"
                                                      onClick={() =>
                                                        openEditIllndelet(plan)
                                                      }
                                                      style={{
                                                        background: "none",
                                                        border: "none",
                                                        cursor: "pointer",
                                                      }}
                                                    >
                                                      <i className="ti ti-trash f-20" />
                                                      <span>Delete</span>
                                                    </button>
                                                  </td>
                                                </tr>
                                              )
                                            )
                                          ) : (
                                            <tr>
                                              <td
                                                colSpan="3"
                                                className="text-center"
                                              >
                                                N/A
                                              </td>
                                            </tr>
                                          )}
                                        </tbody>
                                        {editModalOpen && (
                                          <div
                                            className="modal fade show"
                                            style={{
                                              backgroundColor:
                                                "rgba(81, 81, 81, 0.5)",
                                              display: "block",
                                            }}
                                          >
                                            <div className="modal-dialog">
                                              <div className="modal-content p-0">
                                                <div className="modal-header">
                                                  <h5 className="modal-title">
                                                    Edit Chronic Illness
                                                  </h5>
                                                </div>
                                                <div className="modal-body">
                                                  <div className="row">
                                                    <div className="col-md-12">
                                                      <label className="form-label">
                                                        Title
                                                      </label>
                                                      <input
                                                        type="text"
                                                        name="illness_text"
                                                        value={
                                                          selectedIllness?.illness_text ||
                                                          ""
                                                        }
                                                        onChange={
                                                          handleEditChange
                                                        }
                                                        className="form-control"
                                                      />
                                                    </div>
                                                  </div>
                                                </div>
                                                <div className="modal-footer justify-content-end">
                                                  <button
                                                    type="button"
                                                    className="cancelText"
                                                    onClick={closeEditIllness}
                                                  >
                                                    Cancel
                                                  </button>
                                                  {editModalOpen ? (
                                                    <button
                                                      type="button"
                                                      className="bgBtn btn-sm"
                                                      onClick={() => {
                                                        saveEditIllness(
                                                          selectedIllness
                                                        );
                                                      }}
                                                    >
                                                      Update Chronic illness
                                                    </button>
                                                  ) : (
                                                    <button
                                                      type="button"
                                                      className="bgBtn btn-sm"
                                                      onClick={addxray}
                                                    >
                                                      Add Allergy
                                                    </button>
                                                  )}
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                        </div>
                        <div className="mh-section">
                          <span className="mh-section-badge"><i className="ti ti-notes-medical"></i>Visit Notes</span>
                          <div className="mh-section-line" />
                        </div>
                        <div className="row g-3 mb-3">
                          <div className="col-12">
                            {diagonisemodal && (
                              <div
                                className="modal fade show"
                                style={{
                                  backgroundColor: "rgba(81, 81, 81, 0.5)",
                                  display: "block",
                                }}
                              >
                                <div className="modal-dialog">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">
                                        Add Diagnosis
                                      </h5>
                                    </div>
                                    <div className="modal-body">
                                      <div>
                                        <div className="mb-3">
                                          <label>
                                            <input
                                              type="radio"
                                              name="toggleData"
                                              value="show"
                                              checked={show}
                                              onChange={() => setShow(true)}
                                            />{" "}
                                            ICD(10)
                                          </label>
                                          <label style={{ marginLeft: "15px" }}>
                                            <input
                                              type="radio"
                                              name="toggleData"
                                              value="hide"
                                              checked={!show}
                                              onChange={() => setShow(false)}
                                            />{" "}
                                            Manual
                                          </label>
                                          <div className="mb-3">
                                            <label className="form-label">
                                              Status
                                            </label>
                                            <Select
                                              isClearable
                                              options={[
                                                {
                                                  value: "provisional",
                                                  label: "Provisional",
                                                },
                                                {
                                                  value: "confirmed",
                                                  label: "Confirmed",
                                                },
                                              ]}
                                              value={
                                                diagnosisStatus
                                                  ? {
                                                    value: diagnosisStatus,
                                                    label:
                                                      diagnosisStatus ===
                                                        "provisional"
                                                        ? "Provisional"
                                                        : "Confirmed",
                                                  }
                                                  : null
                                              }
                                              onChange={(option) =>
                                                setDiagnosisStatus(
                                                  option ? option.value : ""
                                                )
                                              }
                                              placeholder="Select status..."
                                            />
                                          </div>
                                        </div>
                                        {show ? (
                                          <div className="row">
                                            <div className="mb-2 col-12">
                                              <button
                                                type="button"
                                                className="borderBtn btn-sm"
                                                style={{ fontSize: 12, padding: "4px 10px", marginBottom: 8 }}
                                                onClick={fetchIcdSuggestions}
                                                disabled={icdSuggestionsLoading}
                                              >
                                                <i className="ti ti-bulb me-1" />
                                                {icdSuggestionsLoading ? "Suggesting..." : "Suggest ICD-10 from Chief Complaint"}
                                              </button>
                                              {icdSuggestions.length > 0 && (
                                                <div className="d-flex flex-wrap gap-2" style={{ marginBottom: 8 }}>
                                                  {icdSuggestions.map((item) => (
                                                    <span
                                                      key={item.id}
                                                      onClick={() => applyIcdSuggestion(item)}
                                                      title={item.code}
                                                      style={{
                                                        cursor: "pointer",
                                                        display: "inline-block",
                                                        padding: "3px 10px",
                                                        borderRadius: 12,
                                                        fontSize: 12,
                                                        backgroundColor: "#e8f0fe",
                                                        color: "#1a56db",
                                                        border: "1px solid #c3d9fb",
                                                      }}
                                                    >
                                                      {item.code} — {item.short_name}
                                                    </span>
                                                  ))}
                                                </div>
                                              )}
                                            </div>
                                            <div className="mb-2 col-12">
                                              <label className="form-label">
                                                ICD Name
                                              </label>
                                              <Select
                                                isSearchable
                                                isClearable
                                                options={icdList1}
                                                value={selectedIcd1}
                                                onChange={handleNameChange}
                                                onInputChange={(value) => {
                                                  setInputValue1(value);
                                                  if (value.length >= 2) {
                                                    getdataicd11(value);
                                                  } else {
                                                    setIcdList1([]);
                                                  }
                                                }}
                                                placeholder="Search by ICD Name..."
                                                noOptionsMessage={() =>
                                                  inputValue1.length < 2
                                                    ? "Type at least 3 characters..."
                                                    : "No results"
                                                }
                                              />
                                            </div>
                                            <div className="mb-2 col-12">
                                              <label className="form-label">
                                                ICD Code
                                              </label>
                                              <Select
                                                isSearchable
                                                isClearable
                                                options={icdList1.map(
                                                  (item) => ({
                                                    value: item.code,
                                                    label: item.code,
                                                  })
                                                )}
                                                value={selectedCode}
                                                onChange={handleCodeChange}
                                                onInputChange={(value) => {
                                                  setInputValueCode(value);
                                                  if (value.length >= 2) {
                                                    getdataicd11(value);
                                                  } else {
                                                    setIcdList1([]);
                                                  }
                                                }}
                                                placeholder="Search by ICD Code..."
                                                noOptionsMessage={() =>
                                                  inputValueCode.length < 2
                                                    ? "Type at least 3 characters..."
                                                    : "No results"
                                                }
                                              />
                                            </div>
                                          </div>
                                        ) : (
                                          <div
                                            className="col-md-12"
                                            style={{ position: "relative" }}
                                          >
                                            <label className="form-label">
                                              Diagnosis:
                                            </label>
                                            <div
                                              style={{ position: "relative" }}
                                            >
                                              <textarea
                                                value={inputValue9}
                                                onChange={handleChange1119}
                                                placeholder="Free Text"
                                                className="form-control"
                                                style={{
                                                  position: "relative",
                                                }}
                                              />
                                              {services19.length > 0 && (
                                                <ul
                                                  style={{
                                                    background: "white",
                                                    border: "1px solid #ccc",
                                                    zIndex: 99999999999999999999999999999999999999999999999999999, // Max possible to stay on top
                                                    width: "100%",
                                                    maxHeight: "200px",
                                                    overflowY: "auto",
                                                    padding: 0,
                                                    listStyle: "none",
                                                    margin: 0,
                                                    boxShadow:
                                                      "0px 2px 5px rgba(0,0,0,0.2)",
                                                  }}
                                                >
                                                  {suggestions9.map(
                                                    (item, index) => {
                                                      return (
                                                        <>
                                                          <li
                                                            key={
                                                              item.id || index
                                                            }
                                                            style={{
                                                              padding: "8px",
                                                              cursor: "pointer",
                                                              borderBottom:
                                                                "1px solid #eee",
                                                              backgroundColor:
                                                                "#fff",
                                                            }}
                                                            onClick={() =>
                                                              handleSuggestionClick9(
                                                                item?.text
                                                              )
                                                            }
                                                          >
                                                            {item?.text}
                                                          </li>
                                                        </>
                                                      );
                                                    }
                                                  )}
                                                </ul>
                                              )}
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="modal-footer  justify-content-end">
                                      <button
                                        type="button"
                                        className="cancelText"
                                        onClick={hndleclosddddd}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        className="bgBtn btn-sm"
                                        onClick={apihitmedicdeagonil}
                                      >
                                        Add
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            {isEditVisitNotesOpen && (
                              <div
                                className="modal fade show"
                                style={{
                                  backgroundColor: "rgba(81, 81, 81, 0.5)",
                                  display: "block",
                                }}
                              >
                                <div className="modal-dialog modal-lg">
                                  <div className="modal-content">
                                    <div className="modal-header">
                                      <h5 className="modal-title">
                                        <i className="ti ti-edit me-1"></i>Edit Visit Notes
                                      </h5>
                                    </div>
                                    <div className="modal-body">
                                      <div className="row g-3">
                                        {visitNotesFields.map((f) => (
                                          <div className="col-md-6 col-12" key={f.field}>
                                            <label className="form-label">
                                              <i className={f.icon}></i> {f.label}
                                            </label>
                                            <textarea
                                              className="form-control"
                                              rows={3}
                                              value={f.value}
                                              onChange={(e) => f.setValue(e.target.value)}
                                            />
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                    <div className="modal-footer justify-content-end">
                                      <button
                                        type="button"
                                        className="cancelText"
                                        onClick={() => setIsEditVisitNotesOpen(false)}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        type="button"
                                        className="bgBtn btn-sm"
                                        onClick={handleSaveAllVisitNotes}
                                        disabled={savingAllVisitNotes}
                                      >
                                        {savingAllVisitNotes ? "Saving..." : "Save All"}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )}
                            <div className="cardBorder mh-visit-notes-box">
                              <div className="mh-vn-split">
                                <div className="mh-vn-col mh-vn-col-summary">
                                  <div className="mh-vn-subhead">
                                    <h6><i className="ti ti-file-text"></i>Notes Summary</h6>
                                    <button
                                      type="button"
                                      className="borderBtn btn-sm"
                                      style={{ cursor: isMedicalNotesLocked ? "not-allowed" : "pointer", opacity: isMedicalNotesLocked ? 0.4 : 1 }}
                                      onClick={isMedicalNotesLocked ? undefined : openEditAllVisitNotes}
                                      disabled={isMedicalNotesLocked}
                                      title={isMedicalNotesLocked ? "Record is locked and cannot be edited" : "Edit all notes"}
                                    >
                                      <i className="ti ti-edit"></i> Edit
                                    </button>
                                  </div>
                                  <div className="mh-vn-grid">
                                    {visitNotesFields.map((f) => (
                                      <div className="mh-vn-item" key={f.field}>
                                        <div className="mh-vn-item-label">
                                          <i className={f.icon}></i>{f.label}
                                        </div>
                                        <div
                                          className="mh-vn-item-value"
                                          dangerouslySetInnerHTML={{
                                            __html: nl2br(
                                              dataMedical?.[f.field]
                                                ? dataMedical?.[f.field]
                                                : "N/A"
                                            ),
                                          }}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="mh-vn-col-divider" />
                                <div className="mh-vn-col mh-vn-col-diagnosis">
                                  <div className="mh-vn-subhead">
                                    <h6><i className="ti ti-clipboard-text"></i>Diagnosis</h6>
                                    <div
                                      className="addBtnIcon"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => handlemodaldiagonise()}
                                      title="Add Diagnosis"
                                    >
                                      <i class="borderBtn ti ti-plus f-20" style={{ padding: "5px 12px" }}></i>
                                    </div>
                                  </div>
                                  <div className="mh-vn-diagnosis table-responsive">
                                    <table className="table table-sm mb-0">
                                      <thead>
                                        <tr>
                                          <th>Date</th>
                                          <th>Code</th>
                                          <th>Text</th>
                                          <th>Status</th>
                                          <th></th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {ddsafjahfl?.length > 0 ? (
                                          ddsafjahfl.filter(item => {
                                            if (dateqq) {
                                              return moment(item.created_at).format('YYYY-MM-DD') == dateqq
                                            }
                                            return true;
                                          }).map((item, index) => (
                                            <tr key={item.id || index}>
                                              <td>
                                                {new Date(
                                                  item?.created_at
                                                ).toLocaleDateString("en-GB")}
                                              </td>
                                              <td>{item.code}</td>
                                              <td className="mh-vn-diagnosis-text">
                                                {item.diagnosis_text
                                                  ? item.diagnosis_text
                                                  : "N/A"}
                                              </td>
                                              <td className="text-capitalize">
                                                {item.status}
                                              </td>
                                              <td
                                                onClick={() =>
                                                  hadndiagosedelete(item)
                                                }
                                              >
                                                <div className="avtar avtar-xs btn-link-secondary deleteIcon">
                                                  <i
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    className="ti ti-trash f-20"
                                                  ></i>
                                                  <span>Delete</span>
                                                </div>
                                              </td>
                                            </tr>
                                          ))
                                        ) : (
                                          <tr>
                                            <td
                                              colSpan="100%"
                                              className="text-center"
                                            >
                                              N/A
                                            </td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mh-section">
                          <span className="mh-section-badge"><i className="ti ti-clipboard-list"></i>Orders &amp; Results</span>
                          <div className="mh-section-line" />
                        </div>
                        <div className="row g-3 mb-3">
                          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="cardBorder">
                              <div className="tableHeader">
                                <div className="d-flex justify-content-between">
                                  <h5><i className="ti ti-file-text"></i>Prescriptions</h5>
                                  <div
                                    className="addBtnIcon"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handlemodaldpresctiption()}
                                  >
                                    <i class="borderBtn ti ti-plus f-20" style={{ padding: "5px 12px" }}></i>
                                  </div>
                                </div>
                              </div>
                              <div className="card-body p-0 bg-white rounded-bottom">
                                <div className="table-responsive rounded-bottom">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Sn</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                        <th>Medicine Name</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {dataVitals123 &&
                                        dataVitals123.length > 0 ? (
                                        dataVitals123.filter(item => {
                                          if (dateqq) {
                                            return moment(item.prescribed_at).format('YYYY-MM-DD') == dateqq
                                          }
                                          return true;
                                        }).sort((a, b) => new Date(b.prescribed_at) - new Date(a.prescribed_at)).map((plan, index) => {
                                          const isLocked = recordLockHours != null && plan.prescribed_at
                                            ? (Date.now() - new Date(plan.prescribed_at).getTime()) > recordLockHours * 3600 * 1000
                                            : false
                                          return (<tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>
                                              {new Date(
                                                plan?.prescribed_at
                                              ).toLocaleDateString("en-GB")}
                                            </td>
                                            <td>
                                              {plan?.prescribed_at
                                                ? new Date(
                                                  plan?.prescribed_at
                                                ).toLocaleTimeString("en-GB", {
                                                  hour: "2-digit",
                                                  minute: "2-digit",
                                                  hour12: true,
                                                  timeZone: "Asia/Bahrain"
                                                })
                                                : ""}
                                            </td>
                                            <td>
                                              {plan.medicines
                                                .slice(
                                                  0,
                                                  expandedRow === index
                                                    ? plan.medicines.length
                                                    : 1
                                                )
                                                .map((item, i) => (
                                                  <span key={i}>
                                                    {item.medicine_name}
                                                    {i <
                                                      (expandedRow === index
                                                        ? plan.medicines.length
                                                        : 1) -
                                                      1
                                                      ? ", "
                                                      : ""}
                                                  </span>
                                                ))}

                                              {plan.medicines.length > 1 && (
                                                <span
                                                  onClick={() =>
                                                    setExpandedRow(
                                                      expandedRow === index
                                                        ? null
                                                        : index
                                                    )
                                                  }
                                                  style={{
                                                    color: "#4680ff",
                                                    cursor: "pointer",
                                                    marginLeft: "5px",
                                                    fontWeight: "500",
                                                    textDecoration: "none"
                                                  }}
                                                >
                                                  {expandedRow === index
                                                    ? " See Less"
                                                    : " See More"}
                                                </span>
                                              )}
                                            </td>
                                            <td>
                                              <div className="avtar avtar-xs btn-link-secondary editIcon">
                                                <i
                                                  className="ti ti-printer f-20"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => {
                                                    hadlenavigate(
                                                      plan.group_id
                                                    );
                                                  }}
                                                ></i>
                                                <span>View</span>
                                              </div>
                                              <div
                                                className="avtar avtar-xs btn-link-secondary editIcon"
                                                style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.5 : 1 }}
                                                title={isLocked ? "Record is locked" : "Edit"}
                                                onClick={() => { if (!isLocked) handleEditPrescription(plan); }}
                                              >
                                                <i className="ti ti-edit f-20"></i>
                                                <span>Edit</span>
                                              </div>
                                              <div
                                                className="avtar avtar-xs btn-link-secondary deleteIcon"
                                                style={{ cursor: isLocked ? "not-allowed" : "pointer", opacity: isLocked ? 0.5 : 1 }}
                                                title={isLocked ? "Record is locked" : "Delete"}
                                              >
                                                <i
                                                  className="ti ti-trash f-20"
                                                  style={{ cursor: isLocked ? "not-allowed" : "pointer" }}
                                                  onClick={() => { if (!isLocked) hadlenavigatedelete(plan.group_id); }}
                                                ></i>
                                                <span>Delete</span>
                                              </div>
                                            </td>
                                          </tr>
                                        )})
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="6"
                                            className="text-center"
                                          >
                                            N/A
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                            <div className="cardBorder">
                              <div className="tableHeader">
                                <div className="d-flex justify-content-between">
                                  {xrayRadio && (
                                    <div
                                      className="modal fade show"
                                      style={{
                                        backgroundColor:
                                          "rgba(81, 81, 81, 0.5)",
                                        display: "block",
                                      }}
                                    >
                                      <div className="modal-dialog modal-lg">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title">
                                              {isEditingXray
                                                ? "Edit File"
                                                : "Add File"}
                                            </h5>
                                          </div>
                                          <div className="modal-body">
                                            <div className="row">
                                              <div className="col-md-6">
                                                <label className="form-label">
                                                  Title<span className="text-danger">*</span>
                                                </label>
                                                <select
                                                  name="Title"
                                                  value={dataxray.Title || ""}
                                                  onChange={handlechangeXray}
                                                  className="form-control"
                                                >
                                                  <option value="">Select Title</option>
                                                  {dataxray.Title && !uploadTypes.some((t) => t.name === dataxray.Title) && (
                                                    <option value={dataxray.Title}>{dataxray.Title}</option>
                                                  )}
                                                  {uploadTypes.map((t) => (
                                                    <option key={t.id} value={t.name}>
                                                      {t.name}
                                                    </option>
                                                  ))}
                                                </select>
                                              </div>
                                              <div className="col-md-6">
                                                <label className="form-label">
                                                  Upload File{!isEditingXray && (
                                                    <span className="text-muted ms-1" style={{ fontSize: "11px" }}>
                                                      (multiple allowed)
                                                    </span>
                                                  )}
                                                </label>
                                                <input
                                                  type="file"
                                                  name="attachment"
                                                  multiple={!isEditingXray}
                                                  onChange={handlechangeXray}
                                                  className="form-control"
                                                />
                                                {Array.isArray(dataxray.attachment) && dataxray.attachment.length > 1 && (
                                                  <small className="text-muted">
                                                    {dataxray.attachment.length} files selected
                                                  </small>
                                                )}
                                              </div>
                                              <div className="col-md-12">
                                                <label className="form-label">
                                                  Description
                                                </label>
                                                <input
                                                  type="text"
                                                  name="description"
                                                  placeholder="Description"
                                                  value={dataxray.description}
                                                  onChange={handlechangeXray}
                                                  className="form-control"
                                                />
                                              </div>
                                            </div>
                                          </div>
                                          <div className="modal-footer justify-content-end">
                                            <button
                                              type="button"
                                              className="cancelText"
                                              onClick={closexray}
                                            >
                                              Cancel
                                            </button>
                                            {isEditingXray ? (
                                              <button
                                                type="button"
                                                className="bgBtn btn-sm"
                                                onClick={updateXray}
                                              >
                                                Update
                                              </button>
                                            ) : (
                                              <button
                                                type="button"
                                                className="bgBtn btn-sm"
                                                onClick={Addreport}
                                              >
                                                Add
                                              </button>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                  <h5><i className="ti ti-photo"></i>Files &amp; Images</h5>
                                  <div
                                    className="addBtnIcon"
                                    onClick={openxray}
                                    style={{ cursor: "pointer" }}
                                  >
                                    <i class="borderBtn ti ti-plus f-20" style={{ padding: "5px 12px" }}></i>
                                  </div>
                                </div>
                              </div>
                              <div className="card-body p-0 bg-white rounded-bottom">
                                <div className="table-responsive rounded-bottom">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Sn</th>
                                        <th>Date</th>
                                        <th>Title</th>
                                        <th>Description</th>
                                        <th>File</th>
                                        <th>Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {(!Array.isArray(radiology) || radiology.length === 0) && (<tr><td className="text-center" colSpan="100%">N/A</td></tr>)}
                                      {radiology?.map((plan, index) => {
                                        return (
                                          <>
                                            {plan.title ? (
                                              <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                  {new Date(
                                                    plan?.created_at
                                                  ).toLocaleDateString("en-GB")}
                                                </td>
                                                <td>{!plan.title ? "N/A" : plan.title}</td>
                                                <td>{!plan.description ? "N/A" : plan.description}</td>
                                                <td>
                                                  <a
                                                    href={`${baseurImage}${plan.attachment}`}
                                                    target="_blank"
                                                  >
                                                    Show Doc
                                                  </a>
                                                </td>
                                                <td>
                                                  <button
                                                    type="button"
                                                    onClick={() =>
                                                      handleEditXray(plan)
                                                    }
                                                    className="avtar avtar-xs btn-link-secondary viewIcon"
                                                  >
                                                    <i className="ti ti-edit f-20"></i>
                                                    <span>Edit</span>
                                                  </button>
                                                </td>
                                              </tr>
                                            ) : (
                                              "N/A"
                                            )}
                                          </>
                                        );
                                      })}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-12 searchParent"></div>
                          <div className="col-md-12">
                            <div className="card table-card patientCardHeader">
                              <div className="tableHeader">
                                <div className="d-sm-flex align-items-center justify-content-between">
                                  <div className="d-flex align-items-center gap-3">
                                    <h5 className="mb-0">Labs</h5>
                                    <div className="tableSearch">
                                      <input
                                        type="text"
                                        placeholder="Search by Labs name..."
                                        className="form-control"
                                        value={labSearch}
                                        onChange={(e) =>
                                          setLabSearch(e.target.value)
                                        }
                                      />
                                      <span className="searchIcon">
                                        <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="18"
                                          height="18"
                                          fill="none"
                                          viewBox="0 0 24 24"
                                          stroke="gray"
                                          style={{
                                            position: "absolute",
                                            top: "50%",
                                            left: "10px",
                                            transform: "translateY(-50%)",
                                            pointerEvents: "none",
                                          }}
                                        >
                                          <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth={2}
                                            d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                                          />
                                        </svg>
                                      </span>
                                    </div>
                                  </div>
                                  <div className="tableHeaderBtn">
                                    <button
                                      className="bgBtn btn-sm d-flex align-items-center gap-1"
                                      style={{ fontSize: 13, padding: "5px 12px" }}
                                      onClick={handleclickopentestadd}
                                    >
                                      <i className="fas fa-plus"></i>
                                      New Request
                                    </button>
                                  </div>
                                </div>
                              </div>
                              <div className="pb-0">
                                <div className="table-responsive rounded-bottom">
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        {/* <th>Patient </th> */}
                                        <th>Date</th>
                                        <th>Lab Name</th>
                                        <th>Services</th>
                                        {/* <th>Title</th> */}
                                        {/* <th>Description</th> */}
                                        <th>Added By</th>
                                        <th>Status</th>
                                        <th className="text-center">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {filteredLabs.length > 0 ? (
                                        filteredLabs.map((item, index) => {
                                          return (
                                            <>
                                              <tr key={index}>
                                                {/* <td>{item.patient_name}</td> */}
                                                <td>
                                                  {item.request_date
                                                    ? new Date(item.request_date).toLocaleDateString("en-GB")
                                                    : ""}
                                                </td>
                                                <td>{item.lab_name}</td>
                                                <td className="wrapText">
                                                  {item.services &&
                                                    item.services.length > 0
                                                    ? item.services
                                                      .map(
                                                        (s) =>
                                                          s.serviceName ||
                                                          s.service ||
                                                          s.service_name ||
                                                          s.name ||
                                                          ""
                                                      )
                                                      .join(", ")
                                                    : "-"}
                                                </td>
                                                {/* <td>{item.title}</td> */}
                                                {/* <td>{item.description}</td> */}
                                                <td>{item.doctor_name}</td>
                                                <td>
                                                  {item.status ||
                                                    item.report_status ||
                                                    "-"}
                                                </td>
                                                <td>
                                                  <div className="d-flex gap-2 justify-content-center">
                                                    <div
                                                      onClick={() =>
                                                        handleLabView(item)
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className="avtar avtar-xs btn-link-secondary viewIcon"
                                                    >
                                                      <i className="ti ti-eye f-20" />
                                                      <span>View</span>
                                                    </div>
                                                    <div
                                                      onClick={() =>
                                                        handleLabEdit(item)
                                                      }
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className="avtar avtar-xs btn-link-secondary editIcon"
                                                    >
                                                      <i className="ti ti-edit f-20" />
                                                      <span>Edit</span>
                                                    </div>
                                                    <div
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      className="avtar avtar-xs btn-link-secondary deleteIcon"
                                                      onClick={() =>
                                                        handleLabDelete(item)
                                                      }
                                                    >
                                                      <i className="ti ti-trash f-20" />
                                                      <span>Delete</span>
                                                    </div>
                                                  </div>
                                                </td>
                                              </tr>
                                            </>
                                          );
                                        })
                                      ) : (
                                        <tr>
                                          <td
                                            colSpan="10"
                                            className="text-center"
                                          >
                                            No request found.
                                          </td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              {openmodaltest && (
                                <div
                                  className="modal fade show"
                                  style={{
                                    backgroundColor: "rgba(81, 81, 81, 0.5)",
                                    display: "block",
                                  }}
                                >
                                  <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                      <div className="modal-header">
                                        <h5 className="modal-title">
                                          Add Tests
                                        </h5>
                                      </div>
                                      <div className="modal-body">
                                        <div className="row">
                                          <div className="col-md-6">
                                            <label className="form-label">
                                              Title
                                            </label>
                                            <input
                                              type="text"
                                              name="title"
                                              onChange={handlechange}
                                              placeholder="Title"
                                              className="form-control"
                                            />
                                          </div>
                                          <div className="col-md-6">
                                            <label className="form-label">
                                              Description
                                            </label>
                                            <textarea
                                              type="text"
                                              name="description"
                                              placeholder="Description"
                                              onChange={handlechange}
                                              className="form-control"
                                            />
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-md-6">
                                            <label className="form-label">
                                              Select Lab
                                            </label>
                                            <select
                                              className="form-select"
                                              name="category"
                                              onChange={handlechange}
                                              value={inpval.category || ""}
                                            >
                                              {/* <option>Select</option> */}
                                              {data2 &&
                                                data2 &&
                                                data2.map((item, index) => {
                                                  return (
                                                    <>
                                                      <option
                                                        key={index}
                                                        value={item.id}
                                                      >
                                                        {item.lab_name}
                                                      </option>
                                                    </>
                                                  );
                                                })}
                                            </select>
                                          </div>
                                          <div className="col-md-6">
                                            <label className="form-label">
                                              Select Doctor
                                            </label>
                                            <select
                                              name="doctor_id"
                                              onChange={handlechange}
                                              className="form-control"
                                              value={inpval.doctor_id || ""}
                                            >
                                              <option>Select</option>
                                              {doctors &&
                                                doctors.length > 0 &&
                                                doctors.map((items, index) => {
                                                  return (
                                                    <option
                                                      key={index}
                                                      value={items.id}
                                                    >
                                                      {items.displayName}
                                                    </option>
                                                  );
                                                })}
                                            </select>
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="col-md-12 autoComplete">
                                            <label className="form-label">
                                              Select Services
                                            </label>
                                            <Autocomplete

                                              id="services-selection"
                                              multiple
                                              options={labServices || []}
                                              isOptionEqualToValue={(option, value) => option.id === value.id}
                                              getOptionLabel={(option) => {
                                                const serviceName =
                                                  option.serviceName ||
                                                  option.service ||
                                                  option.name ||
                                                  "Unknown Service";
                                                const category =
                                                  option.category || "";
                                                const price = option.price
                                                  ? `${Number(option.price || 0).toFixed(3)} BHD`
                                                  : "";
                                                let label = serviceName;
                                                if (category)
                                                  label += ` (${category})`;
                                                if (price)
                                                  label += ` - ${price}`;
                                                return label;
                                              }}
                                              value={selectedServices}
                                              onChange={handleServicesChange}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  placeholder="Search services..."
                                                />
                                              )}
                                              noOptionsText="No services found"
                                              loadingText="Loading services..."
                                              disabled={
                                                labServices.length === 0 ||
                                                !inpval.category
                                              }
                                              renderOption={(props, option) => {
                                                const serviceName =
                                                  option.serviceName ||
                                                  option.service ||
                                                  option.name ||
                                                  "Unknown Service";
                                                const category =
                                                  option.category || "";
                                                const price = option.price || 0;
                                                return (
                                                  <li {...props}>
                                                    <div>
                                                      <strong>
                                                        {serviceName}
                                                      </strong>
                                                      {category && (
                                                        <small className="text-muted d-block">
                                                          Category: {category}
                                                        </small>
                                                      )}
                                                      {price > 0 && (
                                                        <small className="text-success d-block">
                                                          Price: {Number(price).toFixed(3)} BHD
                                                        </small>
                                                      )}
                                                    </div>
                                                  </li>
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>

                                        {/* Price summary and discount section */}
                                        {selectedServices.length > 0 && (
                                          <div className="row mt-3">
                                            <div className="col-md-12">
                                              <div className="card bg-light border-primary">
                                                <div className="card-body">
                                                  <h6 className="card-title mb-3 text-primary">
                                                    <i className="ti ti-calculator me-2"></i>
                                                    Price Summary
                                                  </h6>
                                                  <div className="mb-3">
                                                    {selectedServices.map((s) => {
                                                      const serviceName = s.serviceName || s.service || s.name || "Unknown Service";
                                                      const price = companyLabPriceMap[s.id] ?? Number(s.price) ?? 0;
                                                      const qty = parseInt(s.quantity, 10) || 1;
                                                      return (
                                                        <div key={s.id} className="d-flex justify-content-between align-items-center" style={{ fontSize: 13, padding: "3px 0" }}>
                                                          <span>{serviceName}{s.category ? ` (${s.category})` : ''}</span>
                                                          <span className="d-flex align-items-center" style={{ gap: 8 }}>
                                                            <span>{price.toFixed(3)} BHD</span>
                                                            <span className="text-muted">×</span>
                                                            <input
                                                              type="number"
                                                              className="form-control form-control-sm"
                                                              style={{ width: 60 }}
                                                              min="1"
                                                              value={qty}
                                                              onChange={(e) => handleServiceQuantityChange(s.id, e.target.value)}
                                                            />
                                                            <span className="fw-semibold" style={{ minWidth: 70, textAlign: "right" }}>
                                                              {(price * qty).toFixed(3)} BHD
                                                            </span>
                                                          </span>
                                                        </div>
                                                      );
                                                    })}
                                                  </div>
                                                  <div className="row g-3">
                                                    {/* Total Price */}
                                                    <div className="col-md-3">
                                                      <label className="form-label text-muted small">Total Price</label>
                                                      <div className="h5 text-primary fw-bold">
                                                        {testTotalPrice.toFixed(3)} BHD
                                                      </div>
                                                    </div>

                                                    {/* Discount Type */}
                                                    <div className="col-md-3">
                                                      <label className="form-label small">Discount Type</label>
                                                      <select
                                                        className="form-select form-select-sm"
                                                        name="discount_type"
                                                        value={inpval.discount_type || "Amount"}
                                                        onChange={handleDiscountTypeChange}
                                                      >
                                                        <option value="Amount">By Amount (BHD)</option>
                                                        <option value="Percentage">By Percentage (%)</option>
                                                      </select>
                                                    </div>

                                                    {/* Discount Value */}
                                                    <div className="col-md-3">
                                                      <label className="form-label small">
                                                        Discount Value
                                                        {inpval.discount_type === "Percentage" && globalDiscountLimit > 0 && (
                                                          <small className="text-muted ms-1">(Max: {globalDiscountLimit}%)</small>
                                                        )}
                                                      </label>
                                                      <input
                                                        type="number"
                                                        className="form-control form-control-sm"
                                                        name="discount_value"
                                                        min="0"
                                                        value={inpval.discount_value || ""}
                                                        onChange={handleDiscountValueChange}
                                                      />
                                                    </div>

                                                    {/* Net Amount */}
                                                    <div className="col-md-3">
                                                      <label className="form-label text-muted small">Net Amount</label>
                                                      <div className="h5 text-success fw-bold">
                                                        {testNetAmount.toFixed(3)} BHD
                                                      </div>
                                                      {testDiscountAmont > 0 && (
                                                        <small className="text-success">
                                                          You save {testDiscountAmont.toFixed(3)} BHD
                                                        </small>
                                                      )}
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        )}


                                        <div className="row">
                                          <div className="col-md-12">
                                            <label className="form-label">
                                              Attachment
                                            </label>
                                            <input
                                              type="file"
                                              name="file"
                                              onChange={handlechange}
                                              className="form-control"
                                              accept="image/*,application/pdf,.doc,.docx"
                                            />
                                            {inpval.file && (
                                              <small className="text-muted">
                                                Selected file:{" "}
                                                {inpval.file.name}
                                              </small>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                      <div className="modal-footer justify-content-end">
                                        <button
                                          type="button"
                                          className="cancelText"
                                          onClick={closeModaladdtest}
                                        >
                                          Cancel
                                        </button>
                                        <button
                                          type="button"
                                          className="bgBtn btn-sm"
                                          onClick={handletest}
                                        >
                                          Add test
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, margin: '16px 0 12px' }}>
                          <span style={{ fontWeight: 600, fontSize: 13, color: '#6c757d', textTransform: 'uppercase', letterSpacing: '0.08em', whiteSpace: 'nowrap' }}>Services</span>
                          <div style={{ flex: 1, height: 2, background: '#e0e0e0', borderRadius: 1 }} />
                        </div>
                        <div className="mb-3 card table-card patientCardHeader my-4">
                          <div className="tableHeader d-flex justify-content-between align-items-center">
                            <div className="d-flex align-items-center gap-3">
                              <h5 className="mb-0">Services</h5>
                              <div
                                className="tableSearch"
                                style={{ position: "relative", width: "250px" }}
                              >
                                <input
                                  type="text"
                                  placeholder="Search services..."
                                  className="form-control"
                                  value={serviceTableSearchTerm}
                                  onChange={(e) =>
                                    setServiceTableSearchTerm(e.target.value)
                                  }
                                  style={{ paddingLeft: "35px" }}
                                />
                                <span className="searchIcon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="18"
                                    height="18"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke="gray"
                                    style={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "10px",
                                      transform: "translateY(-50%)",
                                      pointerEvents: "none",
                                    }}
                                  >
                                    <path
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth={2}
                                      d="M21 21l-4.35-4.35M17 10a7 7 0 11-14 0 7 7 0 0114 0z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </div>
                            {hasActiveInsuranceCard && (
                              <span className="badge bg-success ms-2"></span>
                            )}
                            <div className="d-flex gap-2">
                              <button
                                className="bgBtn btn-sm d-flex align-items-center gap-1"
                                style={{ fontSize: 13, padding: "5px 12px" }}
                                onClick={handlePrintClick}
                                disabled={safeServices.length === 0}
                                title={
                                  safeServices.length === 0
                                    ? "No services to print"
                                    : "Print selected services"
                                }
                              >
                                <i className="fas fa-print"></i>
                                Print
                              </button>
                              <button
                                className="bgBtn btn-sm d-flex align-items-center gap-1"
                                style={{ fontSize: 13, padding: "5px 12px" }}
                                onClick={handleAddService}
                              >
                                Add Services
                              </button>
                            </div>
                          </div>
                          <div className="card-body p-0">
                            <div className="table-responsive rounded-bottom">
                              <table className="table">
                                <thead>
                                  <tr>
                                    <th>Sn</th>
                                    <th>Date-Time</th>
                                    <th>Code</th>
                                    <th>Name</th>
                                    <th>Description</th>
                                    <th>Notes</th>
                                    <th>Added By</th>
                                    {/* <th>
                                      {hasActiveInsuranceCard ? "Cost" : "Cost"}
                                    </th> */}
                                    {/* <th>Discount</th> */}
                                    {/* <th>Cost After Discount</th> */}
                                    {/* <th>VAT</th> */}
                                    <th>Net Amt.</th>
                                    <th>Status</th>
                                    <th className="text-center">Actions</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {paginatedServices.map((service, index) => {
                                    const serial =
                                      (currentServicePage - 1) *
                                      servicesPerPage +
                                      index +
                                      1;
                                    const serviceData = availableServices.find(
                                      (s) =>
                                        s.id ===
                                        (service.serviceId ??
                                          service.service_id)
                                    );
                                    const vatDisplay = serviceData
                                      ? serviceData.vatEnabled
                                        ? `${serviceData.vatValue}%`
                                        : "0%"
                                      : service.vat_value
                                        ? `${service.vat_value}%`
                                        : "0%";


                                    //vat

                                    const amountAfterDiscount = Number(service.amount_after_discount || 0);
                                    const netAmount = Number(service.netAmount ?? service.net_amount ?? 0);

                                    const vatAmount =
                                      netAmount > 0 && amountAfterDiscount > 0
                                        ? (netAmount - amountAfterDiscount).toFixed(3)
                                        : "0.00";
                                    return (
                                      <tr key={index}>
                                        <td>{serial}</td>
                                        <td>
                                          {moment(service.createdAt || service.created_at).format("DD/MM/YYYY HH:mm A")}
                                        </td>
                                        <td>
                                          {serviceData?.code ||
                                            service.serviceCode ||
                                            "-"}
                                        </td>
                                        <td>
                                          {serviceData?.serviceName ||
                                            service.serviceName ||
                                            "-"}
                                        </td>
                                        <td
                                          style={{
                                            maxWidth: "250px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                          }}
                                        >
                                          {serviceData?.description ||
                                            service.description ||
                                            "-"}
                                        </td>
                                        <td
                                          style={{
                                            maxWidth: "250px",
                                            whiteSpace: "normal",
                                            wordWrap: "break-word",
                                          }}
                                          title={service.extra_notes || "-"}
                                        >
                                          {service.extra_notes || "-"}
                                        </td>
                                        <td>
                                          {service?.doctor_name || service?.sent_by || "-"}
                                        </td>
                                        {/* <td>
                                          {hasActiveInsuranceCard
                                            ? serviceData?.insurancePrice ??
                                            serviceData?.insurance_price ??
                                            service.insurancePrice ??
                                            service.insurance_price ??
                                            0
                                            : serviceData?.standardCost ||
                                            service.standardCost ||
                                            0}{" "}
                                          BHD
                                        </td> */}

                                        {/* <td>
                                          {(service.discount_value ??
                                            service.discount_value ??
                                            0) > 0 ? (
                                            <>
                                              {(
                                                service.discountType ||
                                                service.discount_type ||
                                                ""
                                              )
                                                .toString()
                                                .toLowerCase() === "percentage"
                                                ? `${service.discountValue ??
                                                service.discount_value
                                                }%`
                                                : `-${service.discountValue ??
                                                service.discount_value
                                                } BHD`}
                                            </>
                                          ) : (
                                            "-"
                                          )}
                                        </td> */}
                                        {/* <td>{service.amount_after_discount} BHD</td> */}
                                        {/* <td>{vatAmount}</td> */}

                                        <td>
                                          {service.netAmount ??
                                            service.net_amount}{" "}
                                          BHD
                                        </td>
                                        <td>
                                          {(service.status || "").toString().toLowerCase() === "complete" || (service.status || "").toString().toLowerCase() === "completed" ? (
                                            <span className="badge bg-success">Completed</span>
                                          ) : (
                                            <button
                                              className="bgBtn btn-sm d-flex align-items-center gap-1"
                                              style={{ fontSize: 10, padding: "3px 12px", backgroundColor: "#fff", color: "var(--green)" }}
                                              onMouseEnter={e => { e.currentTarget.style.backgroundColor = "var(--green)"; e.currentTarget.style.color = "#fff"; }}
                                              onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#fff"; e.currentTarget.style.color = "var(--green)"; }}
                                              onClick={() => handleServiceStatusChange(service.id, "Complete")}
                                            >
                                              Mark Complete
                                            </button>
                                          )}
                                        </td>
                                        <td className="text-center">
                                          <div
                                            onClick={() =>
                                              handleEditService(service)
                                            }
                                            style={{ cursor: "pointer" }}
                                            className="avtar avtar-xs btn-link-secondary editIcon"
                                          >
                                            <i className="ti ti-edit f-20" />
                                            <span>Edit</span>
                                          </div>


                                          <div
                                            style={{
                                              cursor:
                                                (service.billing_status || "") === "Paid"
                                                  ? "not-allowed"
                                                  : "pointer",
                                              opacity:
                                                (service.billing_status || "") === "Paid"
                                                  ? 0.5
                                                  : 1,
                                            }}
                                            title={
                                              (service.billing_status || "") === "Paid"
                                                ? "Cannot delete paid service"
                                                : "Delete"
                                            }
                                            className="avtar avtar-xs btn-link-secondary deleteIcon"
                                            onClick={() =>
                                              (service.billing_status || "") === "Paid"
                                                ? null
                                                : handleDeleteService(service.id, service.serviceId)
                                            }
                                          >
                                            <i className="ti ti-trash f-20" />
                                            <span>Delete</span>
                                          </div>



                                        </td>
                                      </tr>
                                    );
                                  })}
                                  {paginatedServices.length === 0 && (
                                    <tr>
                                      <td colSpan="10" className="text-center">
                                        No services added yet
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {totalServicePages > 1 && (
                              <nav className="tablepagination d-flex justify-content-end mt-3 mb-2">
                                <ul className="pagination mb-0">
                                  <li
                                    className={`page-item ${currentServicePage === 1 ? "disabled" : ""
                                      }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        currentServicePage > 1 &&
                                        setCurrentServicePage(
                                          currentServicePage - 1
                                        )
                                      }
                                    >
                                      &laquo;
                                    </button>
                                  </li>
                                  <li className="pageNmbr">{`${currentServicePage} of ${totalServicePages}`}</li>
                                  <li
                                    className={`page-item ${currentServicePage === totalServicePages
                                      ? "disabled"
                                      : ""
                                      }`}
                                  >
                                    <button
                                      className="page-link"
                                      onClick={() =>
                                        currentServicePage <
                                        totalServicePages &&
                                        setCurrentServicePage(
                                          currentServicePage + 1
                                        )
                                      }
                                    >
                                      &raquo;
                                    </button>
                                  </li>
                                </ul>
                              </nav>
                            )}
                          </div>
                        </div>
                        {printModalOpen && (
                          <div
                            className="modal fade show"
                            style={{ display: "block" }}
                            tabIndex="-1"
                          >
                            <div className="modal-dialog modal-lg">
                              <div className="modal-content">
                                <div className="modal-header">
                                  <h5 className="modal-title">
                                    Select Services to Print
                                  </h5>
                                </div>
                                <div className="modal-body billingModal">
                                  <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div>
                                      <h6>
                                        Choose services you want on the printout
                                      </h6>
                                    </div>
                                    <button
                                      type="button"
                                      className="bgBtn btn-sm d-flex align-items-center gap-1"
                                      style={{ fontSize: 13, padding: "5px 12px" }}
                                      onClick={handleSelectAllServices}
                                    >
                                      Select / Deselect All
                                    </button>
                                  </div>
                                  <div className="list-group">
                                    {safeServices.length === 0 && (
                                      <div className="list-group-item text-muted">
                                        No services available
                                      </div>
                                    )}
                                    {safeServices.map((service) => (
                                      <label
                                        key={service.id}
                                        className="list-group-item d-flex align-items-center"
                                        style={{ cursor: "pointer" }}
                                      >
                                        <input
                                          type="checkbox"
                                          className="form-check-input me-2"
                                          checked={selectedPrintIds.includes(
                                            service.id
                                          )}
                                          onChange={() =>
                                            handleServiceSelection(service.id)
                                          }
                                        />
                                        <div className="flex-grow-1">
                                          <div>
                                            <strong>
                                              {service.serviceName ||
                                                service.service_name ||
                                                service.name ||
                                                "Service"}
                                            </strong>{" "}
                                            <span className="text-muted">
                                              {service.serviceCode ||
                                                service.service_code ||
                                                service.code
                                                ? `(${service.serviceCode ||
                                                service.service_code ||
                                                service.code
                                                })`
                                                : ""}
                                            </span>
                                          </div>
                                          <div className="small text-muted">
                                            Net:{" "}
                                            {service.netAmount ??
                                              service.net_amount ??
                                              0}{" "}
                                            BHD
                                          </div>
                                        </div>
                                      </label>
                                    ))}
                                  </div>
                                </div>
                                <div className="modal-footer">
                                  <button
                                    type="button"
                                    className="cancelText"
                                    onClick={() => {
                                      setPrintModalOpen(false);
                                      setIsSelectingForPrint(false);
                                    }}
                                  >
                                    Cancel
                                  </button>
                                  <button
                                    type="button"
                                    className="bgBtn btn-sm"
                                    onClick={handlePrintSelected}
                                    disabled={selectedPrintIds.length === 0}
                                  >
                                    Print Selected
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                        {printModalOpen && (
                          <div className="modal-backdrop fade show"></div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                className={`tab-pane p-0 fade ${activeTab === "forms" ? "show active" : ""
                  }`}
                id="forms"
                role="tabpanel"
                aria-labelledby="forms-tab"
              >
                <PatientForms patientId={location?.state?.patientid?.id} />
              </div>

              <div
                className={`tab-pane p-0 fade ${activeTab === "patientfiles" ? "show active" : ""}`}
                id="patientfiles"
                role="tabpanel"
                aria-labelledby="patientfiles-tab"
              >
                <FileUploads
                  radiology={radiology}
                  xrayRadio={xrayRadio}
                  isEditingXray={isEditingXray}
                  dataxray={dataxray}
                  handlechangeXray={handlechangeXray}
                  closexray={closexray}
                  updateXray={updateXray}
                  Addreport={Addreport}
                  openxray={openxray}
                  handleEditXray={handleEditXray}
                  openEditIxrayradio={openEditIxrayradio}
                  uploadTypes={uploadTypes}
                />
              </div>

              <div
                className={`tab-pane fade ${activeTab === "service" ? "show active" : ""
                  }`}
                id="service"
                role="tabpanel"
                aria-labelledby="service-tab"
              >
                <PatientServices
                  patientId={location?.state?.patientid?.id}
                  patientDetailsFromParent={personalinfo}
                  doctorId={
                    JSON.parse(localStorage.getItem("userMedical"))?.id
                  }
                  insurance={0}
                  vat={0}
                />
              </div>
            </div>

            {prescriptionModalOpen && (
              <div className="modal fade show" style={{ backgroundColor: "rgba(81,81,81,0.5)", display: "block" }}>
                <div className="modal-dialog modal-xl" style={{ maxWidth: "1200px" }}>
                  <div className="modal-content">
                    <div className="modal-header py-2">
                      <h6 className="modal-title mb-0">
                        {isEditMode ? "Edit Prescription" : "Add Prescription"}
                        <span className="text-muted ms-2" style={{ fontSize: "12px", fontWeight: 400 }}>
                          — {personalinfo?.firstName} {personalinfo?.lastName}
                        </span>
                      </h6>
                      <button type="button" className="btn-close" onClick={() => { setPrescriptionModalOpen(false); setIsEditMode(false); setEditingGroupId(null); }} />
                    </div>
      
                    <div className="modal-body py-2 px-3">
                      <div className="row g-2">
                        {/* Template sidebar */}
                        <div className="col-auto" style={{ width: "160px" }}>
                          <MedicalTemplateList onSelect={handleSelectPerscriptionTemplate} templateType="prescriptions" />
                        </div>
      
                        {/* Form */}
                        <div className="col">
                          {/* Row 1: Medicine select + name */}
                          <div className="row g-2 mb-1">
                            <div className="col-5">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Medicine (from List)</label>
                              <Select
                                isSearchable
                                name="rxId"
                                options={rxList.map((item) => ({
                                  value: item.rxId,
                                  label: item.medicineName,
                                  strength: item.strength,
                                  unit: item.unit,
                                  packet_size: item.packet_size,
                                  activeSubstances: item.activeSubstances,
                                }))}
                                value={
                                  rxList.find((item) => item.rxId === medicineData?.rxId)
                                    ? {
                                      value: medicineData.rxId,
                                      label: rxList.find((item) => item.rxId === medicineData.rxId).medicineName,
                                      strength: rxList.find((item) => item.rxId === medicineData.rxId).strength,
                                      unit: rxList.find((item) => item.rxId === medicineData.rxId).unit,
                                      packet_size: rxList.find((item) => item.rxId === medicineData.rxId).packet_size,
                                      activeSubstances: rxList.find((item) => item.rxId === medicineData.rxId).activeSubstances,
                                    }
                                    : null
                                }
                                onChange={handleEditLabChange123}
                                classNamePrefix="select"
                                placeholder="Select Medicine"
                                styles={{ control: (b) => ({ ...b, fontSize: "13px" }), option: (b) => ({ ...b, fontSize: "13px" }) }}
                                formatOptionLabel={(data) => (
                                  <div style={{ display: "flex", flexDirection: "column" }}>
                                    <strong style={{ fontSize: "12px", color: "#333" }}>{data.label}</strong>
                                    <small style={{ color: "#666", fontSize: "10px" }}>
                                      {data.strength && `${data.strength}`}{data.unit && ` ${data.unit}`}
                                      {data.packet_size && ` | Pack: ${data.packet_size}`}
                                      {data.activeSubstances && ` | ${data.activeSubstances}`}
                                    </small>
                                  </div>
                                )}
                                filterOption={(option, inputValue) => {
                                  const s = inputValue.toLowerCase();
                                  return option.data.label.toLowerCase().includes(s) ||
                                    (option.data.strength && option.data.strength.toLowerCase().includes(s)) ||
                                    (option.data.activeSubstances && option.data.activeSubstances.toLowerCase().includes(s)) ||
                                    (option.data.packet_size && option.data.packet_size.toLowerCase().includes(s));
                                }}
                              />
                            </div>
                            <div className="col-4">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Medicine Name</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="medicine_name" value={medicineData.medicine_name} onChange={handleMedicineChange} placeholder="Medicine name" />
                            </div>
                            <div className="col-3">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Active Substances</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="substance" value={medicineData.substance} onChange={handleMedicineChange} placeholder="Substance" />
                            </div>
                          </div>
      
                          {/* Row 2: Dose / Freq / Duration / Form */}
                          <div className="row g-2 mb-1">
                            <div className="col-3">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Dose</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="dose" value={medicineData.dose} onChange={handleMedicineChange} placeholder="Dose" />
                            </div>
                            <div className="col-3">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Frequency</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="frequency" value={medicineData.frequency} onChange={handleMedicineChange} placeholder="Frequency" />
                            </div>
                            <div className="col-3">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Duration</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="duration" value={medicineData.duration} onChange={handleMedicineChange} placeholder="Duration" />
                            </div>
                            <div className="col-3">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Form</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="form" value={medicineData.form} onChange={handleMedicineChange} placeholder="Form" />
                            </div>
                          </div>
      
                          {/* Row 3: Strength / Unit / Route / Pack Size / Product Type / Notes */}
                          <div className="row g-2 mb-2">
                            <div className="col-2">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Strength</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="strength" value={medicineData.strength} onChange={handleMedicineChange} placeholder="Strength" />
                            </div>
                            <div className="col-2">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Unit</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="unit" value={medicineData.unit} onChange={handleMedicineChange} placeholder="Unit" />
                            </div>
                            <div className="col-2">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Route</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="route" value={medicineData.route} onChange={handleMedicineChange} placeholder="Route" />
                            </div>
                            <div className="col-2">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Pack Size</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="packet_size" value={medicineData.packet_size} onChange={handleMedicineChange} placeholder="Pack size" />
                            </div>
                            <div className="col-2">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Product Type</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="productType" value={medicineData.productType} onChange={handleMedicineChange} placeholder="Type" />
                            </div>
                            <div className="col-2">
                              <label className="form-label mb-0" style={{ fontSize: "11px" }}>Notes</label>
                              <input className="form-control" style={{ height: "38px", fontSize: "13px" }} name="notes" value={medicineData.notes} onChange={handleMedicineChange} placeholder="Notes" />
                            </div>
                          </div>
      
                          {/* Add button */}
                          <div className="text-end mb-2">
                            <button type="button" className="bgBtn btn-sm d-flex align-items-center gap-1" style={{ fontSize: 13, padding: "5px 12px" }} onClick={handleAddMedicine}>
                              {editIndex !== null ? "Update Medicine" : "+ Add Medicine"}
                            </button>
                          </div>
      
                          {/* Medicines table */}
                          <div style={{ maxHeight: "180px", overflowY: "auto", border: "1px solid #e9ecef", borderRadius: "6px" }}>
                            <table className="table table-sm mb-0" style={{ fontSize: "12px" }}>
                              <thead style={{ position: "sticky", top: 0, background: "#f8f9fa", zIndex: 1 }}>
                                <tr>
                                  <th style={{ padding: "5px 8px" }}>#</th>
                                  <th style={{ padding: "5px 8px" }}>Medicine</th>
                                  <th style={{ padding: "5px 8px" }}>Dose</th>
                                  <th style={{ padding: "5px 8px" }}>Frequency</th>
                                  <th style={{ padding: "5px 8px" }}>Duration</th>
                                  <th style={{ padding: "5px 8px", textAlign: "center" }}>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {addedMedicines.length > 0 ? addedMedicines.map((item, index) => (
                                  <tr key={index}>
                                    <td style={{ padding: "4px 8px" }}>{index + 1}</td>
                                    <td style={{ padding: "4px 8px" }}>{item.medicine_name}</td>
                                    <td style={{ padding: "4px 8px" }}>{item.dose}</td>
                                    <td style={{ padding: "4px 8px" }}>{item.frequency}</td>
                                    <td style={{ padding: "4px 8px" }}>{item.duration}</td>
                                    <td style={{ padding: "4px 8px", textAlign: "center" }}>
                                      <button className="bgBtn btn-sm" style={{ fontSize: 13, padding: "5px 12px", marginRight: "4px" }} onClick={() => handleEditMedicine(index)}>Edit</button>
                                      <button className="bgBtn btn-sm" style={{ fontSize: 13, padding: "5px 12px" }} onClick={() => handleDeleteMedicine(index)}>Delete</button>
                                    </td>
                                  </tr>
                                )) : (
                                  <tr><td colSpan="6" className="text-center text-muted" style={{ padding: "10px" }}>No medicines added yet</td></tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
      
                    <div className="modal-footer py-2 justify-content-end">
                      <button type="button" className="cancelText" onClick={() => { setPrescriptionModalOpen(false); setIsEditMode(false); setEditingGroupId(null); }}>Cancel</button>
                      <button type="button" className="bgBtn btn-sm" onClick={handlesubmitprescription}>
                        {isEditMode ? "Update Prescription" : "Submit Prescription"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {serviceModalOpen && (() => {
              const s = availableServices.find(x => x.id === serviceFormData.serviceId);
              const fld = { fontSize: 12, height: 32, borderRadius: 7, border: '1px solid #dde3eb', padding: '0 10px', width: '100%', background: '#fff', color: '#2d3748', outline: 'none' };
              const lbl = { fontSize: 10, fontWeight: 700, color: '#5B6B79', textTransform: 'uppercase', letterSpacing: '0.05em', display: 'block', marginBottom: 3 };
              const col = (flex) => ({ flex, minWidth: 0 });
              return (
                <div style={{ position: 'fixed', inset: 0, zIndex: 1050, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
                  <div style={{ background: '#fff', borderRadius: 14, width: '100%', maxWidth: 900, boxShadow: '0 8px 40px rgba(0,0,0,0.2)', overflow: 'hidden' }}>

                    {/* Header */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '13px 20px', borderBottom: '1px solid #e8ecf0' }}>
                      <div style={{ width: 32, height: 32, borderRadius: 8, background: '#4680ff18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                        <i className="ti ti-stethoscope" style={{ color: '#4680ff', fontSize: 17 }} />
                      </div>
                      <div style={{ fontSize: 14, fontWeight: 700, color: '#1a202c' }}>
                        {selectedService ? 'Edit Service' : 'Add Service'}
                      </div>
                      <button type="button" onClick={() => setServiceModalOpen(false)}
                        style={{ marginLeft: 'auto', width: 26, height: 26, borderRadius: 6, border: '1px solid #e8ecf0', background: '#f8f9fb', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#5B6B79', fontSize: 14 }}>
                        <i className="ti ti-x" />
                      </button>
                    </div>

                    <form onSubmit={handleServiceSubmit}>
                      <div style={{ padding: '16px 20px', display: 'flex', flexDirection: 'column', gap: 12 }}>

                        {/* Row 1: Search */}
                        <div style={{ position: 'relative' }} ref={serviceDropdownRef}>
                          <label style={lbl}>Search & Select Service <span style={{ color: '#e53e3e' }}>*</span></label>
                          <input
                            type="text"
                            style={{ ...fld, height: 34, border: serviceFormData.serviceId ? '1px solid #dde3eb' : '1px solid #f6ad55' }}
                            placeholder="Type to search by name or code..."
                            value={searchServiceQuery}
                            onChange={e => { setSearchServiceQuery(e.target.value); setShowServiceSuggestions(true); }}
                            onFocus={() => setShowServiceSuggestions(true)}
                            required
                          />
                          {!serviceFormData.serviceId && (
                            <div style={{ fontSize: 11, color: '#d97706', marginTop: 3 }}>
                              <i className="ti ti-alert-circle me-1" />Please select a service from the list
                            </div>
                          )}
                          {showServiceSuggestions && (
                            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 1100, background: '#fff', border: '1px solid #e8ecf0', borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.12)', maxHeight: 220, overflowY: 'auto', marginTop: 2 }}>
                              {filteredServices.length === 0
                                ? <div style={{ padding: '10px 14px', fontSize: 12, color: '#9aa0ac' }}>No services found</div>
                                : filteredServices.map(service => (
                                  <div key={service.id}
                                    onClick={() => {
                                      const baseCost = hasActiveInsuranceCard
                                        ? service.companyPrice ?? service.insurancePrice ?? service.insurance_price ?? service.standardCost
                                        : service.standardCost;
                                      setServiceFormData({ ...serviceFormData, serviceId: service.id, customCost: baseCost || '' });
                                      setSearchServiceQuery(`${service.code} - ${service.serviceName}`);
                                      setShowServiceSuggestions(false);
                                    }}
                                    style={{
                                      padding: '8px 14px', fontSize: 12, cursor: 'pointer', borderBottom: '1px solid #f0f2f5',
                                      background: service.id === serviceFormData.serviceId ? '#4680ff0d' : '#fff',
                                      color: service.id === serviceFormData.serviceId ? '#4680ff' : '#2d3748',
                                      fontWeight: service.id === serviceFormData.serviceId ? 600 : 400,
                                    }}
                                    onMouseEnter={e => { if (service.id !== serviceFormData.serviceId) e.currentTarget.style.background = '#f8f9fb'; }}
                                    onMouseLeave={e => { if (service.id !== serviceFormData.serviceId) e.currentTarget.style.background = '#fff'; }}
                                  >
                                    <span style={{ fontWeight: 600 }}>{service.code}</span> — {service.serviceName}
                                    <span style={{ marginLeft: 8, fontSize: 11, color: '#5B6B79' }}>
                                      {hasActiveInsuranceCard
                                        ? `${service.companyPrice ?? service.insurancePrice ?? service.insurance_price ?? service.standardCost} BHD`
                                        : `${service.standardCost} BHD`}
                                    </span>
                                  </div>
                                ))
                              }
                            </div>
                          )}
                        </div>

                        {/* Row 2: Code | Name | Cost | VAT */}
                        <div style={{ display: 'flex', gap: 10 }}>
                          <div style={col('0 0 120px')}>
                            <label style={lbl}>Code</label>
                            <input style={{ ...fld, background: '#f8f9fb' }} value={s?.code || ''} readOnly />
                          </div>
                          <div style={col(1)}>
                            <label style={lbl}>Service Name</label>
                            <input style={{ ...fld, background: '#f8f9fb' }} value={s?.serviceName || ''} readOnly />
                          </div>
                          <div style={col('0 0 150px')}>
                            <label style={lbl}>{hasActiveInsuranceCard ? 'Insurance Cost' : 'Standard Cost'}</label>
                            <input
                              type="number" style={fld}
                              value={serviceFormData.customCost}
                              onChange={e => setServiceFormData({ ...serviceFormData, customCost: e.target.value })}
                              step="0.001" min="0"
                              placeholder={hasActiveInsuranceCard ? s?.companyPrice ?? s?.insurancePrice ?? s?.insurance_price ?? s?.standardCost : s?.standardCost}
                            />
                          </div>
                          <div style={col('0 0 90px')}>
                            <label style={lbl}>Quantity</label>
                            <input
                              type="number" style={fld}
                              value={serviceFormData.quantity ?? 1}
                              onChange={e => setServiceFormData({ ...serviceFormData, quantity: parseInt(e.target.value, 10) || 1 })}
                              step="1" min="1"
                            />
                          </div>
                          <div style={col('0 0 80px')}>
                            <label style={lbl}>VAT</label>
                            <input style={{ ...fld, background: '#f8f9fb' }} value={s ? (s.vatEnabled ? `${s.vatValue}%` : '0%') : ''} readOnly />
                          </div>
                          <div style={col('0 0 120px')}>
                            <label style={lbl}>Total</label>
                            <input
                              style={{ ...fld, background: '#f8f9fb', fontWeight: 600 }}
                              value={(Number(serviceFormData.customCost || 0) * (Number(serviceFormData.quantity) || 1)).toFixed(3)}
                              readOnly
                            />
                          </div>
                        </div>

                        {/* Row 3: Doctor | Discount Type | Discount Value */}
                        <div style={{ display: 'flex', gap: 10 }}>
                          <div style={col(1)}>
                            <label style={lbl}>Doctor <span style={{ color: '#e53e3e' }}>*</span></label>
                            <select style={{ ...fld, cursor: 'pointer' }} name="sent_by" value={serviceFormData.sent_by || ''}
                              onChange={e => setServiceFormData({ ...serviceFormData, sent_by: e.target.value })} required>
                              <option value="">Select Doctor</option>
                              {enhancedDoctors.map((doc, i) => (
                                <option key={i} value={doc.id}>{doc.displayName || doc.fullName || doc.name}</option>
                              ))}
                            </select>
                          </div>
                          <div style={col('0 0 180px')}>
                            <label style={lbl}>Discount Type</label>
                            <select style={{ ...fld, cursor: 'pointer' }} value={serviceFormData.discountType}
                              onChange={e => setServiceFormData({ ...serviceFormData, discountType: e.target.value, discountValue: 0 })}>
                              <option value="Amount">By Amount BHD</option>
                              <option value="Percentage">By Percentage (%)</option>
                            </select>
                          </div>
                          <div style={col('0 0 130px')}>
                            <label style={lbl}>
                              Discount Value
                              {globalDiscountLimit > 0 && (
                                <small className="text-muted ms-1">
                                  {serviceFormData.discountType === "Percentage"
                                    ? `(Max: ${globalDiscountLimit}%)`
                                    : `(Max: ${globalDiscountLimit}% of total)`}
                                </small>
                              )}
                            </label>
                            <input type="number" style={fld} value={serviceFormData.discountValue}
                              onChange={handleServiceDiscountValueChange}
                              min="0" step="0.001" />
                          </div>
                        </div>

                        {/* Row 4: Description | Extra Notes */}
                        <div style={{ display: 'flex', gap: 10 }}>
                          <div style={col(1)}>
                            <label style={lbl}>Description</label>
                            <textarea style={{ ...fld, height: 56, resize: 'none', padding: '6px 10px' }} value={s?.description || ''} readOnly />
                          </div>
                          <div style={col(1)}>
                            <label style={lbl}>Extra Notes</label>
                            <textarea style={{ ...fld, height: 56, resize: 'none', padding: '6px 10px' }}
                              value={serviceFormData.extraNotes}
                              onChange={e => setServiceFormData({ ...serviceFormData, extraNotes: e.target.value })} />
                          </div>
                        </div>

                      </div>

                      {/* Footer */}
                      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8, padding: '12px 20px', borderTop: '1px solid #f0f2f5' }}>
                        <button type="button" onClick={() => setServiceModalOpen(false)}
                          style={{ padding: '7px 18px', fontSize: 13, borderRadius: 8, border: '1px solid #dde3eb', background: '#f8f9fb', color: '#5B6B79', cursor: 'pointer' }}>
                          Cancel
                        </button>
                        <button type="submit" disabled={!serviceFormData.serviceId}
                          title={!serviceFormData.serviceId ? 'Please select a service first' : ''}
                          style={{
                            padding: '7px 18px', fontSize: 13, borderRadius: 8, border: 'none', cursor: serviceFormData.serviceId ? 'pointer' : 'not-allowed',
                            background: serviceFormData.serviceId ? '#4680ff' : '#c8d0da', color: '#fff', fontWeight: 600,
                          }}>
                          {selectedService ? 'Update' : 'Add'} Service
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      </div>

      <QuickAddConsentModal
        open={!!pendingMissingConsents}
        onClose={() => setPendingMissingConsents(null)}
        patientId={patientId}
        patient={personalinfo}
        missing={pendingMissingConsents || []}
        onDone={() => {
          setPendingMissingConsents(null);
          handleServiceSubmit({ preventDefault: () => { } });
        }}
      />

      {
        showEditLabModal && (
          <div
            className="modal fade show"
            style={{
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "block",
              overflowY: "auto",
            }}
          >
            <div className="modal-dialog modal-lg" style={{ marginTop: "1.75rem", marginBottom: "1.75rem" }}>
              <div className="modal-content" style={{ maxHeight: "calc(100vh - 3.5rem)", display: "flex", flexDirection: "column" }}>
                <div className="modal-header" style={{ flexShrink: 0 }}>
                  <h5 className="modal-title">Edit Lab Request</h5>
                </div>
                <form onSubmit={handleEditLabSubmit} style={{ display: "flex", flexDirection: "column", minHeight: 0, flex: 1 }}>
                  <div className="modal-body" style={{ overflowY: "auto", flex: 1, minHeight: 0 }}>
                    {/* Row 1: Lab + Title */}
                    <div className="row">
                      <div className="col-lg-6">
                        <label className="form-label">Lab</label>
                        <select
                          className="form-select"
                          name="lab_id"
                          value={editLabData.lab_id}
                          onChange={handleEditLabChange}
                          required
                        >
                          <option value="">Select Lab</option>
                          {labs.map((lab) => (
                            <option key={lab.id} value={lab.id}>
                              {lab.lab_name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg-6">
                        <label className="form-label">Title</label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={editLabData.title}
                          onChange={handleEditLabChange}
                          placeholder="title"
                        />
                      </div>
                    </div>

                    {/* Description */}
                    <div>
                      <label className="form-label">Description</label>
                      <textarea
                        className="form-control"
                        name="description"
                        value={editLabData.description}
                        onChange={handleEditLabChange}
                      />
                    </div>

                    {/* Lab Services Autocomplete */}
                    <div className="mt-3">
                      <label className="form-label">Lab Services</label>
                      <Autocomplete
                        id="edit-lab-services"
                        options={labServices || []}
                        getOptionLabel={(option) => {
                          const serviceName =
                            option.serviceName ||
                            option.service ||
                            option.service_name ||
                            option.name ||
                            "Unknown Service";
                          const category = option.category || "";
                          const price = option.price ? `${Number(option.price || 0).toFixed(3)} BHD` : "";
                          let label = serviceName;
                          if (category) label += ` (${category})`;
                          if (price) label += ` - ${price}`;
                          return label;
                        }}
                        value={
                          (editLabData.serviceId && labServices.length > 0)
                            ? labServices.find((service) => String(service.id) === String(editLabData.serviceId))
                            : null
                        }
                        onChange={handleEditLabServicesChange}
                        disabled={!editLabData.lab_id || labServices.length === 0}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            placeholder={
                              editLabData.lab_id
                                ? "Search and select a service..."
                                : "Please select a lab first"
                            }
                          />
                        )}
                        renderOption={(props, option) => {
                          const serviceName =
                            option.serviceName ||
                            option.service ||
                            option.service_name ||
                            option.name ||
                            "Unknown Service";
                          const category = option.category || "";
                          const price = option.price || 0;
                          return (
                            <li {...props}>
                              <div>
                                <strong>{serviceName}</strong>
                                {category && (
                                  <small className="text-muted d-block">
                                    Category: {category}
                                  </small>
                                )}
                                {price > 0 && (
                                  <small className="text-success d-block">
                                    Price: {Number(price).toFixed(3)} BHD
                                  </small>
                                )}
                              </div>
                            </li>
                          );
                        }}
                      />
                    </div>

                    {/* {/* 🆕 DISCOUNT SECTION -  */}
                    {editLabData.serviceId && (
                      <div className="row mt-3">
                        <div className="col-md-12">
                          <div className="card bg-light border-primary">
                            <div className="card-body">
                              <h6 className="card-title mb-3 text-primary">
                                <i className="ti ti-calculator me-2"></i>
                                Price Summary
                              </h6>
                              <div className="row g-3">
                                {/* Total Price */}
                                <div className="col-md-3">
                                  <label className="form-label text-muted small">Total Price</label>
                                  <div className="h5 text-primary fw-bold">
                                    {editTestTotalPrice.toFixed(3)} BHD
                                  </div>
                                </div>

                                {/* Discount Type */}
                                <div className="col-md-3">
                                  <label className="form-label small">Discount Type</label>
                                  <select
                                    className="form-select form-select-sm"
                                    name="discount_type"
                                    value={editLabData.discount_type || "Amount"}
                                    onChange={handleEditDiscountTypeChange}
                                  >
                                    <option value="Amount">By Amount (BHD)</option>
                                    <option value="Percentage">By Percentage (%)</option>
                                  </select>
                                </div>

                                {/* Discount Value */}
                                <div className="col-md-3">
                                  <label className="form-label small">
                                    Discount Value
                                    {editLabData.discount_type === "Percentage" && globalDiscountLimit > 0 && (
                                      <small className="text-muted ms-1">(Max: {globalDiscountLimit}%)</small>
                                    )}
                                  </label>
                                  <input
                                    type="number"
                                    className="form-control form-control-sm"
                                    name="discount_value"
                                    min="0"
                                    value={editLabData.discount_value || ""}
                                    onChange={handleEditDiscountValueChange}
                                  />
                                </div>

                                {/* Net Amount */}
                                <div className="col-md-3">
                                  <label className="form-label text-muted small">Net Amount</label>
                                  <div className="h5 text-success fw-bold">
                                    {editTestNetAmount.toFixed(3)} BHD
                                  </div>
                                  {editTestDiscountAmount > 0 && (
                                    <small className="text-success">
                                      You save {editTestDiscountAmount.toFixed(3)} BHD
                                    </small>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Attachments Section */}
                    <div>
                      <label className="form-label">
                        Attachments ({editLabAttachments.length})
                      </label>
                      {editLabAttachments.length > 0 && (
                        <div className="table-responsive mb-3">
                          <table className="table table-sm table-bordered">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>File</th>
                                <th>Status</th>
                                <th>Uploaded At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {editLabAttachments.map((attachment) => (
                                <tr key={attachment.attachment_id}>
                                  <td>{attachment.attachment_name}</td>
                                  <td>
                                    {attachment.filename ? (
                                      <a
                                        href={`${baseurImage}${attachment.filename}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-sm btn-outline-primary"
                                      >
                                        View File
                                      </a>
                                    ) : (
                                      "No file"
                                    )}
                                  </td>
                                  <td>{attachment.report_status}</td>
                                  <td>
                                    {new Date(
                                      attachment?.uploaded_at
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleDeleteLabAttachment(
                                          attachment.attachment_id
                                        )
                                      }
                                    >
                                      <i className="ti ti-trash f-20"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-md-4">
                          <label className="form-label">Add New Attachment</label>
                          <input
                            type="file"
                            name="newAttachment"
                            onChange={handleEditLabFileChange}
                            className="form-control"
                            accept="image/*,application/pdf,.doc,.docx"
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Attachment Name</label>
                          <input
                            type="text"
                            name="attachmentName"
                            value={editLabData.attachmentName || ""}
                            onChange={handleEditLabChange}
                            className="form-control"
                            placeholder="Enter attachment name"
                          />
                        </div>
                        <div className="col-md-4">
                          <label className="form-label">Status</label>
                          <select
                            name="attachmentStatus"
                            value={editLabData.attachmentStatus || ""}
                            onChange={handleEditLabChange}
                            className="form-select"
                          >
                            <option value="">Select Status</option>
                            <option value="Positive">Positive</option>
                            <option value="Negative">Negative</option>
                          </select>
                        </div>
                      </div>
                      <div className="mt-2">
                        <button
                          type="button"
                          className="bgBtn btn-sm d-flex align-items-center gap-1"
                          style={{ fontSize: 13, padding: "5px 12px" }}
                          onClick={handleAddLabAttachment}
                          disabled={
                            !editLabData.newAttachment ||
                            !editLabData.attachmentName ||
                            !editLabData.attachmentStatus
                          }
                        >
                          Add Attachment
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer d-flex justify-content-end" style={{ flexShrink: 0 }}>
                    <button
                      type="button"
                      className="cancelText"
                      onClick={() => setShowEditLabModal(false)}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="bgBtn btn-sm">
                      Save
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )
      }



      {
        editPrescriptionModal && (
          <div
            className="modal fade show"
            style={{
              backgroundColor: "rgba(81, 81, 81, 0.5)",
              display: "block",
            }}
          >
            <div className="modal-dialog modal-lg">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Edit Prescription</h5>
                </div>
                <div className="modal-body">
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Medicine</th>
                          <th>Dose</th>
                          <th>Frequency</th>
                          <th>Duration</th>
                          <th>Notes</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {editMedicines.map((medicine, index) => (
                          <tr key={index}>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={medicine.medicine_name}
                                onChange={(e) => {
                                  const updated = [...editMedicines];
                                  updated[index].medicine_name = e.target.value;
                                  setEditMedicines(updated);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={medicine.dose || ""}
                                onChange={(e) => {
                                  const updated = [...editMedicines];
                                  updated[index].dose = e.target.value;
                                  setEditMedicines(updated);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={medicine.frequency || ""}
                                onChange={(e) => {
                                  const updated = [...editMedicines];
                                  updated[index].frequency = e.target.value;
                                  setEditMedicines(updated);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={medicine.duration || ""}
                                onChange={(e) => {
                                  const updated = [...editMedicines];
                                  updated[index].duration = e.target.value;
                                  setEditMedicines(updated);
                                }}
                              />
                            </td>
                            <td>
                              <input
                                type="text"
                                className="form-control form-control-sm"
                                value={medicine.notes || ""}
                                onChange={(e) => {
                                  const updated = [...editMedicines];
                                  updated[index].notes = e.target.value;
                                  setEditMedicines(updated);
                                }}
                              />
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-sm btn-danger"
                                onClick={() => {
                                  const updated = editMedicines.filter((_, i) => i !== index);
                                  setEditMedicines(updated);
                                }}
                              >
                                <i className="ti ti-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div className="modal-footer justify-content-end">
                  <button
                    type="button"
                    className="cancelText"
                    onClick={() => setEditPrescriptionModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="bgBtn btn-sm"
                    onClick={handleUpdatePrescription}
                  >
                    Update Prescription
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }


      <ToastContainer />
    </div >
  );
}
